/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** DateTime custom scalar type */
  DateTime: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any; }
};

export type ActivateUserInput = {
  password: Scalars['String']['input'];
  token: Scalars['ID']['input'];
};

export type ActivateUserRequestInput = {
  id: Scalars['ID']['input'];
};

export type Address = Node & {
  __typename?: 'Address';
  city: Scalars['String']['output'];
  company?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  countryName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  line1: Scalars['String']['output'];
  line2?: Maybe<Scalars['String']['output']>;
  line3?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  regionName?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type AddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  line3?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

export enum Alteration {
  LengthDecrease = 'LengthDecrease',
  LengthIncrease = 'LengthIncrease'
}

export type Anklet = {
  __typename?: 'Anklet';
  category?: Maybe<AnkletCategory>;
};

export enum AnkletCategory {
  Bead = 'Bead',
  Chain = 'Chain',
  Pendant = 'Pendant'
}

export type AnkletInput = {
  category?: InputMaybe<AnkletCategory>;
};

export type Appraisal = Node & {
  __typename?: 'Appraisal';
  id: Scalars['ID']['output'];
  values: Array<CurrencyAmount>;
};

export enum ApproximateValue {
  Between50and500 = 'Between50and500',
  Between50and500Dkk = 'Between50and500DKK',
  Between50and500Eur = 'Between50and500EUR',
  Between50and500Usd = 'Between50and500USD',
  Between500and1000 = 'Between500and1000',
  Between500and1000Dkk = 'Between500and1000DKK',
  Between500and1000Eur = 'Between500and1000EUR',
  Between500and1000Usd = 'Between500and1000USD',
  Between1000and2500 = 'Between1000and2500',
  Between1000and2500Dkk = 'Between1000and2500DKK',
  Between1000and2500Eur = 'Between1000and2500EUR',
  Between1000and2500Usd = 'Between1000and2500USD',
  GreaterThan2500 = 'GreaterThan2500',
  GreaterThan2500Dkk = 'GreaterThan2500DKK',
  GreaterThan2500Eur = 'GreaterThan2500EUR',
  GreaterThan2500Usd = 'GreaterThan2500USD',
  LessThan50 = 'LessThan50',
  LessThan50Dkk = 'LessThan50DKK',
  LessThan50Eur = 'LessThan50EUR',
  LessThan50Usd = 'LessThan50USD'
}

export type Authentication = {
  __typename?: 'Authentication';
  accessToken: Scalars['String']['output'];
  user: User;
};

export type Authenticity = {
  __typename?: 'Authenticity';
  dated?: Maybe<Scalars['Boolean']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  receipt?: Maybe<Scalars['Boolean']['output']>;
  signed?: Maybe<Scalars['Boolean']['output']>;
};

export type AuthenticityInput = {
  dated?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  receipt?: InputMaybe<Scalars['Boolean']['input']>;
  signed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BankDetails = Node & {
  __typename?: 'BankDetails';
  bankInformationToken: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
};

export type Batch = {
  __typename?: 'Batch';
  barcode?: Maybe<Scalars['String']['output']>;
  barcodeSource?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  items?: Maybe<Array<ServiceOrderItem>>;
  receivedDate?: Maybe<Scalars['DateTime']['output']>;
  serviceType: ServiceOrderType;
  status: BatchStatus;
  totalItems: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  workshop?: Maybe<Workshop>;
  workshopId?: Maybe<Scalars['String']['output']>;
};

export type BatchCreateInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  barcodeSource?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  receivedDate?: InputMaybe<Scalars['DateTime']['input']>;
  serviceType: ServiceOrderType;
  status?: InputMaybe<BatchStatus>;
  totalItems?: InputMaybe<Scalars['Float']['input']>;
  workshopId?: InputMaybe<Scalars['String']['input']>;
};

export enum BatchStatus {
  Completed = 'Completed',
  Created = 'Created',
  InProgress = 'InProgress',
  Received = 'Received',
  Shipped = 'Shipped'
}

export type BatchUpdateInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  barcodeSource?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  receivedDate?: InputMaybe<Scalars['DateTime']['input']>;
  serviceType?: InputMaybe<ServiceOrderType>;
  status?: InputMaybe<BatchStatus>;
  totalItems?: InputMaybe<Scalars['Float']['input']>;
  workshopId?: InputMaybe<Scalars['String']['input']>;
};

export type BespokeServiceOrderCreateInput = {
  budget?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  inspirationDesigners?: InputMaybe<Array<Scalars['String']['input']>>;
  inspirationImages?: InputMaybe<Array<Scalars['String']['input']>>;
  jewelleryType: JewelleryType;
  lastName: Scalars['String']['input'];
  originalPieceDescription?: InputMaybe<Scalars['String']['input']>;
  originalPieceImages?: InputMaybe<Array<Scalars['String']['input']>>;
  userSource?: InputMaybe<UserSource>;
};

export type Bracelet = {
  __typename?: 'Bracelet';
  category?: Maybe<BraceletCategory>;
  lock?: Maybe<BraceletLock>;
};

export enum BraceletCategory {
  Bangle = 'Bangle',
  Bead = 'Bead',
  Chain = 'Chain',
  Charm = 'Charm',
  Cuff = 'Cuff',
  Id = 'Id',
  Link = 'Link',
  Station = 'Station',
  Tennis = 'Tennis',
  Wrap = 'Wrap'
}

export type BraceletInput = {
  category?: InputMaybe<BraceletCategory>;
  lock?: InputMaybe<BraceletLock>;
};

export enum BraceletLock {
  ButtonFastening = 'ButtonFastening',
  FoldoverClasp = 'FoldoverClasp',
  Hinge = 'Hinge',
  Hook = 'Hook',
  LobsterClaw = 'LobsterClaw',
  PushClasp = 'PushClasp',
  SClasp = 'SClasp',
  SlidingKnot = 'SlidingKnot',
  SlipOn = 'SlipOn',
  SpringClasp = 'SpringClasp',
  TBar = 'TBar',
  TieFastening = 'TieFastening'
}

export type Brand = Node & {
  __typename?: 'Brand';
  country?: Maybe<Scalars['String']['output']>;
  designers: Array<BrandDesigner>;
  handle: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  vintage: Scalars['Boolean']['output'];
};

export type BrandCreateInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  handle?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  vintage?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BrandDesigner = Node & {
  __typename?: 'BrandDesigner';
  brand: Brand;
  designer: Brand;
  id: Scalars['ID']['output'];
  role: BrandDesignerRole;
};

export type BrandDesignerAddInput = {
  brandHandle: Scalars['String']['input'];
  designerHandle: Scalars['String']['input'];
  role: BrandDesignerRole;
};

export enum BrandDesignerRole {
  Owner = 'Owner',
  Reseller = 'Reseller'
}

export type BrandDesignerUpdateInput = {
  role?: InputMaybe<BrandDesignerRole>;
};

export type BrandEdge = {
  __typename?: 'BrandEdge';
  cursor: Scalars['String']['output'];
  node: Brand;
};

export type BrandUpdateInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  handle?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  vintage?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BrandsPage = {
  __typename?: 'BrandsPage';
  edges: Array<BrandEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type Brooch = {
  __typename?: 'Brooch';
  category?: Maybe<BroochCategory>;
};

export enum BroochCategory {
  Pendant = 'Pendant'
}

export type BroochInput = {
  category?: InputMaybe<BroochCategory>;
};

export type CheckoutResponseModel = {
  __typename?: 'CheckoutResponseModel';
  checkoutUrl: Scalars['String']['output'];
};

export type Condition = {
  __typename?: 'Condition';
  notes?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<ConditionRank>;
};

export type ConditionInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<ConditionRank>;
};

export enum ConditionRank {
  Excellent = 'Excellent',
  Good = 'Good',
  VeryGood = 'VeryGood'
}

export type Contact = {
  __typename?: 'Contact';
  email: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ContactCustomerServiceInput = {
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  userSource?: InputMaybe<UserSource>;
};

export enum Country {
  Ad = 'AD',
  Ae = 'AE',
  Af = 'AF',
  Ag = 'AG',
  Ai = 'AI',
  Al = 'AL',
  Am = 'AM',
  Ao = 'AO',
  Aq = 'AQ',
  Ar = 'AR',
  As = 'AS',
  At = 'AT',
  Au = 'AU',
  Aw = 'AW',
  Ax = 'AX',
  Az = 'AZ',
  Ba = 'BA',
  Bb = 'BB',
  Bd = 'BD',
  Be = 'BE',
  Bf = 'BF',
  Bg = 'BG',
  Bh = 'BH',
  Bi = 'BI',
  Bj = 'BJ',
  Bl = 'BL',
  Bm = 'BM',
  Bn = 'BN',
  Bo = 'BO',
  Bq = 'BQ',
  Br = 'BR',
  Bs = 'BS',
  Bt = 'BT',
  Bv = 'BV',
  Bw = 'BW',
  By = 'BY',
  Bz = 'BZ',
  Ca = 'CA',
  Cc = 'CC',
  Cd = 'CD',
  Cf = 'CF',
  Cg = 'CG',
  Ch = 'CH',
  Ci = 'CI',
  Ck = 'CK',
  Cl = 'CL',
  Cm = 'CM',
  Cn = 'CN',
  Co = 'CO',
  Cr = 'CR',
  Cu = 'CU',
  Cv = 'CV',
  Cw = 'CW',
  Cx = 'CX',
  Cy = 'CY',
  Cz = 'CZ',
  De = 'DE',
  Dj = 'DJ',
  Dk = 'DK',
  Dm = 'DM',
  Do = 'DO',
  Dz = 'DZ',
  Ec = 'EC',
  Ee = 'EE',
  Eg = 'EG',
  Eh = 'EH',
  Er = 'ER',
  Es = 'ES',
  Et = 'ET',
  Fi = 'FI',
  Fj = 'FJ',
  Fk = 'FK',
  Fm = 'FM',
  Fo = 'FO',
  Fr = 'FR',
  Ga = 'GA',
  Gb = 'GB',
  Gd = 'GD',
  Ge = 'GE',
  Gf = 'GF',
  Gg = 'GG',
  Gh = 'GH',
  Gi = 'GI',
  Gl = 'GL',
  Gm = 'GM',
  Gn = 'GN',
  Gp = 'GP',
  Gq = 'GQ',
  Gr = 'GR',
  Gs = 'GS',
  Gt = 'GT',
  Gu = 'GU',
  Gw = 'GW',
  Gy = 'GY',
  Hk = 'HK',
  Hm = 'HM',
  Hn = 'HN',
  Hr = 'HR',
  Ht = 'HT',
  Hu = 'HU',
  Id = 'ID',
  Ie = 'IE',
  Il = 'IL',
  Im = 'IM',
  In = 'IN',
  Io = 'IO',
  Iq = 'IQ',
  Ir = 'IR',
  Is = 'IS',
  It = 'IT',
  Je = 'JE',
  Jm = 'JM',
  Jo = 'JO',
  Jp = 'JP',
  Ke = 'KE',
  Kg = 'KG',
  Kh = 'KH',
  Ki = 'KI',
  Km = 'KM',
  Kn = 'KN',
  Kp = 'KP',
  Kr = 'KR',
  Kw = 'KW',
  Ky = 'KY',
  Kz = 'KZ',
  La = 'LA',
  Lb = 'LB',
  Lc = 'LC',
  Li = 'LI',
  Lk = 'LK',
  Lr = 'LR',
  Ls = 'LS',
  Lt = 'LT',
  Lu = 'LU',
  Lv = 'LV',
  Ly = 'LY',
  Ma = 'MA',
  Mc = 'MC',
  Md = 'MD',
  Me = 'ME',
  Mf = 'MF',
  Mg = 'MG',
  Mh = 'MH',
  Mk = 'MK',
  Ml = 'ML',
  Mm = 'MM',
  Mn = 'MN',
  Mo = 'MO',
  Mp = 'MP',
  Mq = 'MQ',
  Mr = 'MR',
  Ms = 'MS',
  Mt = 'MT',
  Mu = 'MU',
  Mv = 'MV',
  Mw = 'MW',
  Mx = 'MX',
  My = 'MY',
  Mz = 'MZ',
  Na = 'NA',
  Nc = 'NC',
  Ne = 'NE',
  Nf = 'NF',
  Ng = 'NG',
  Ni = 'NI',
  Nl = 'NL',
  No = 'NO',
  Np = 'NP',
  Nr = 'NR',
  Nu = 'NU',
  Nz = 'NZ',
  Om = 'OM',
  Pa = 'PA',
  Pe = 'PE',
  Pf = 'PF',
  Pg = 'PG',
  Ph = 'PH',
  Pk = 'PK',
  Pl = 'PL',
  Pm = 'PM',
  Pn = 'PN',
  Pr = 'PR',
  Ps = 'PS',
  Pt = 'PT',
  Pw = 'PW',
  Py = 'PY',
  Qa = 'QA',
  Re = 'RE',
  Ro = 'RO',
  Rs = 'RS',
  Ru = 'RU',
  Rw = 'RW',
  Sa = 'SA',
  Sb = 'SB',
  Sc = 'SC',
  Sd = 'SD',
  Se = 'SE',
  Sg = 'SG',
  Sh = 'SH',
  Si = 'SI',
  Sj = 'SJ',
  Sk = 'SK',
  Sl = 'SL',
  Sm = 'SM',
  Sn = 'SN',
  So = 'SO',
  Sr = 'SR',
  Ss = 'SS',
  St = 'ST',
  Sv = 'SV',
  Sx = 'SX',
  Sy = 'SY',
  Sz = 'SZ',
  Tc = 'TC',
  Td = 'TD',
  Tf = 'TF',
  Tg = 'TG',
  Th = 'TH',
  Tj = 'TJ',
  Tk = 'TK',
  Tl = 'TL',
  Tm = 'TM',
  Tn = 'TN',
  To = 'TO',
  Tr = 'TR',
  Tt = 'TT',
  Tv = 'TV',
  Tw = 'TW',
  Tz = 'TZ',
  Ua = 'UA',
  Ug = 'UG',
  Um = 'UM',
  Us = 'US',
  Uy = 'UY',
  Uz = 'UZ',
  Va = 'VA',
  Vc = 'VC',
  Ve = 'VE',
  Vg = 'VG',
  Vi = 'VI',
  Vn = 'VN',
  Vu = 'VU',
  Wf = 'WF',
  Ws = 'WS',
  Ye = 'YE',
  Yt = 'YT',
  Za = 'ZA',
  Zm = 'ZM',
  Zw = 'ZW'
}

export type CreatePhotoshootInput = {
  endDate: Scalars['String']['input'];
  location: PhotoshootLocation;
  reference: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  type: PhotoshootType;
};

export type CreatePhotoshootLinesInput = {
  photoshootId: Scalars['String']['input'];
  pieceIds: Array<Scalars['String']['input']>;
};

export type CreatePhotoshootShipmentsInput = {
  direction: PhotoshootDirection;
  photoshootId: Scalars['String']['input'];
  photoshootReference: Scalars['String']['input'];
  pieces: Array<PhotoshootDesignerShipmentInput>;
};

export type Cufflink = {
  __typename?: 'Cufflink';
  category?: Maybe<CufflinkCategory>;
};

export enum CufflinkCategory {
  BulletBack = 'BulletBack',
  Button = 'Button',
  ChainLink = 'ChainLink',
  Knot = 'Knot',
  WhaleBack = 'WhaleBack'
}

export type CufflinkInput = {
  category?: InputMaybe<CufflinkCategory>;
};

export enum Currency {
  Aud = 'AUD',
  Cad = 'CAD',
  Chf = 'CHF',
  Dkk = 'DKK',
  Eur = 'EUR',
  Gbp = 'GBP',
  Hkd = 'HKD',
  Jpy = 'JPY',
  Mxn = 'MXN',
  Pln = 'PLN',
  Qar = 'QAR',
  Sgd = 'SGD',
  Usd = 'USD'
}

export type CurrencyAmount = {
  __typename?: 'CurrencyAmount';
  amount: Scalars['Float']['output'];
  currency: Currency;
};

export type CurrencyAmountInput = {
  amount: Scalars['Float']['input'];
  currency: Currency;
};

export type CurrencyRate = {
  __typename?: 'CurrencyRate';
  code: Currency;
  rate: Scalars['Float']['output'];
  type: CurrencyType;
};

export enum CurrencyType {
  Display = 'Display',
  Sale = 'Sale'
}

export type CurrentSubscriptionModel = {
  __typename?: 'CurrentSubscriptionModel';
  canceledAt?: Maybe<Scalars['DateTime']['output']>;
  configureMarkets: Scalars['Boolean']['output'];
  currentPeriodEnd?: Maybe<Scalars['DateTime']['output']>;
  margin?: Maybe<Scalars['Float']['output']>;
  marginBespoke?: Maybe<Scalars['Float']['output']>;
  productName: Scalars['String']['output'];
  status: Scalars['String']['output'];
  tier: Scalars['String']['output'];
};

export type Customer = {
  __typename?: 'Customer';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  shopifyId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CustomerAssociatePayload = {
  __typename?: 'CustomerAssociatePayload';
  customer: CustomerSummaryBasic;
  designer: Designer;
  piece: Piece;
  variant: ProductVariant;
};

export type CustomerCreditEntry = {
  __typename?: 'CustomerCreditEntry';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  currency: Currency;
  expiryDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  settled?: Maybe<Scalars['Boolean']['output']>;
  shopifyCustomerId?: Maybe<Scalars['String']['output']>;
  shopifyDiscountCode?: Maybe<Scalars['String']['output']>;
  shopifyOrderId?: Maybe<Scalars['String']['output']>;
  source: CustomerCreditEntrySource;
};

export enum CustomerCreditEntrySource {
  Exchange = 'Exchange',
  Manual = 'Manual',
  OrderCancellation = 'OrderCancellation',
  OrderFulfillment = 'OrderFulfillment',
  OrderRefund = 'OrderRefund',
  Referral = 'Referral'
}

export type CustomerMetafieldInput = {
  customerAccessToken: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  metafield: MetafieldInput;
};

export type CustomerMetafieldPayload = {
  __typename?: 'CustomerMetafieldPayload';
  userErrors: Array<UserError>;
};

export type CustomerProductsPayload = {
  __typename?: 'CustomerProductsPayload';
  products?: Maybe<Array<CustomerProductsType>>;
};

export type CustomerProductsType = {
  __typename?: 'CustomerProductsType';
  handle?: Maybe<Scalars['String']['output']>;
  imageSrc?: Maybe<Scalars['String']['output']>;
  instanceId: Scalars['String']['output'];
  isVintage?: Maybe<Scalars['Boolean']['output']>;
  purchasedDate: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
  vendor: Scalars['String']['output'];
};

export type CustomerReferralEntry = {
  __typename?: 'CustomerReferralEntry';
  amount: Scalars['Float']['output'];
  campaign?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency: Currency;
  currentUses: Scalars['Float']['output'];
  deletedAt: Scalars['DateTime']['output'];
  expiryPeriod?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  isUsed: Scalars['Boolean']['output'];
  maximumUses: Scalars['Float']['output'];
  referringUserEmail?: Maybe<Scalars['String']['output']>;
  status: ReferralStatus;
  toUserEmail?: Maybe<Scalars['String']['output']>;
};

export type CustomerSearchItem = {
  __typename?: 'CustomerSearchItem';
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
};

export type CustomerSummaryBasic = {
  __typename?: 'CustomerSummaryBasic';
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
};

export type CustomerSummaryWithProducts = {
  __typename?: 'CustomerSummaryWithProducts';
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  products?: Maybe<Array<Instance>>;
};

export type CustomersListEdge = {
  __typename?: 'CustomersListEdge';
  cursor: Scalars['String']['output'];
  node: CustomersListItem;
};

export type CustomersListItem = {
  __typename?: 'CustomersListItem';
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type CustomersListPage = {
  __typename?: 'CustomersListPage';
  edges: Array<CustomersListEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type DeletedEntity = Node & {
  __typename?: 'DeletedEntity';
  id: Scalars['ID']['output'];
};

export type Designer = Node & {
  __typename?: 'Designer';
  abbreviation?: Maybe<Scalars['String']['output']>;
  awaitingImagesPiecesCount: Scalars['Float']['output'];
  awaitingQAPiecesCount: Scalars['Float']['output'];
  b2bPageUrl?: Maybe<Scalars['String']['output']>;
  bankAccountName?: Maybe<Scalars['String']['output']>;
  bespoke: Scalars['Boolean']['output'];
  billingAddress?: Maybe<Address>;
  comingSoon: Scalars['Boolean']['output'];
  configureMarkets: Scalars['Boolean']['output'];
  countryOfOrigin?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  curatorQuote?: Maybe<Scalars['String']['output']>;
  customisation: Scalars['Boolean']['output'];
  deliveryZipcode?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  designerUsers: Array<DesignerUserModel>;
  disabledCountries: Array<Country>;
  draftPiecesCount: Scalars['Float']['output'];
  ein?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  enabledCurrencies: Array<Currency>;
  eori?: Maybe<Scalars['String']['output']>;
  featuredProduct?: Maybe<Piece>;
  handle: Scalars['String']['output'];
  headline?: Maybe<Scalars['String']['output']>;
  highlights?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  instagramHandle?: Maybe<Scalars['String']['output']>;
  isRegisteredInShopify?: Maybe<Scalars['Boolean']['output']>;
  jewellerCategory?: Maybe<Scalars['String']['output']>;
  jewelleryMakingLocation?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['String']['output']>;
  leadSource?: Maybe<LeadSource>;
  leadStatus: LeadStatus;
  leadTime?: Maybe<Scalars['String']['output']>;
  livePiecesCount: Scalars['Float']['output'];
  longitude?: Maybe<Scalars['String']['output']>;
  margin: Scalars['Float']['output'];
  marginBespoke?: Maybe<Scalars['Float']['output']>;
  materials?: Maybe<Scalars['String']['output']>;
  microBusiness?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  otherPartners?: Maybe<Scalars['String']['output']>;
  otherPartnersText?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  priceRange?: Maybe<Scalars['String']['output']>;
  productSpreadsheetId?: Maybe<Scalars['String']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  readyToOrder: Scalars['Boolean']['output'];
  remodel: Scalars['Boolean']['output'];
  repair: Scalars['Boolean']['output'];
  returnPeriodDays: Scalars['Float']['output'];
  selectedB2BServices?: Maybe<Scalars['String']['output']>;
  servicesTerms?: Maybe<ServicesTerms>;
  shippingAddress?: Maybe<Address>;
  shippingRegion?: Maybe<ShippingRegions>;
  specialties?: Maybe<Array<Scalars['String']['output']>>;
  status: Status;
  statusHistory?: Maybe<Array<DesignerStatusHistory>>;
  storeAddress?: Maybe<Scalars['String']['output']>;
  storeGoogleMapsUrl?: Maybe<Scalars['String']['output']>;
  storeImageUrl?: Maybe<Scalars['String']['output']>;
  subscriptionTier?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  sustainabilityLabels?: Maybe<Array<SustainabilityLabel>>;
  tags: Array<DesignerStyleTag>;
  tasks: Array<DesignerTask>;
  taxRegistered?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  vatIdNo?: Maybe<Scalars['String']['output']>;
  verifiedPartner: Scalars['Boolean']['output'];
  videoHighlightDescription?: Maybe<Scalars['String']['output']>;
  videoHighlightUrl?: Maybe<Scalars['String']['output']>;
  warrantyDuration?: Maybe<Scalars['Float']['output']>;
  warrantyTerms?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  workbenchImageUrl?: Maybe<Scalars['String']['output']>;
};

export type DesignerCreateInput = {
  abbreviation: Scalars['String']['input'];
  b2bPageUrl?: InputMaybe<Scalars['String']['input']>;
  bespoke?: InputMaybe<Scalars['Boolean']['input']>;
  billingAddress: AddressInput;
  customisation?: InputMaybe<Scalars['Boolean']['input']>;
  disabledCountries?: InputMaybe<Array<Country>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabledCurrencies?: InputMaybe<Array<Currency>>;
  eori?: InputMaybe<Scalars['String']['input']>;
  instagramHandle?: InputMaybe<Scalars['String']['input']>;
  jewellerCategory?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['String']['input']>;
  leadStatus?: InputMaybe<Array<LeadStatus>>;
  longitude?: InputMaybe<Scalars['String']['input']>;
  margin?: InputMaybe<Scalars['Float']['input']>;
  marginBespoke?: InputMaybe<Scalars['Float']['input']>;
  microBusiness?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  productSpreadsheetId?: InputMaybe<Scalars['String']['input']>;
  readyToOrder?: InputMaybe<Scalars['Boolean']['input']>;
  remodel?: InputMaybe<Scalars['Boolean']['input']>;
  repair?: InputMaybe<Scalars['Boolean']['input']>;
  returnPeriodDays?: InputMaybe<Scalars['Float']['input']>;
  selectedB2BServices?: InputMaybe<Scalars['String']['input']>;
  servicesTerms?: InputMaybe<ServicesTermsInput>;
  shippingAddress?: InputMaybe<AddressInput>;
  shippingRegion?: InputMaybe<Array<ShippingRegions>>;
  sustainabilityLabels?: InputMaybe<Array<SustainabilityLabel>>;
  tags?: InputMaybe<Array<DesignerStyleTag>>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  vatIdNo?: InputMaybe<Scalars['String']['input']>;
  verifiedPartner?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type DesignerEdge = {
  __typename?: 'DesignerEdge';
  cursor: Scalars['String']['output'];
  node: Designer;
};

export type DesignerOrder = Node & {
  __typename?: 'DesignerOrder';
  adminLink: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  designer: Designer;
  designerCity: Scalars['String']['output'];
  entityId?: Maybe<Scalars['String']['output']>;
  expectedFulfillmentAt?: Maybe<Scalars['DateTime']['output']>;
  fulfilledAt?: Maybe<Scalars['DateTime']['output']>;
  giftWrapping: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  invoice?: Maybe<Invoice>;
  lineItems: Array<FulfillmentOrderLineItem>;
  orderId: Scalars['String']['output'];
  orderName: Scalars['String']['output'];
  orderReference: Scalars['String']['output'];
  reference: Scalars['String']['output'];
  shipment?: Maybe<Shipment>;
  shippingTo?: Maybe<DesignerOrderDestinationModel>;
  status: DesignerOrderStatus;
};

export type DesignerOrderAcceptCancellationInput = {
  message?: InputMaybe<Scalars['String']['input']>;
};

export type DesignerOrderAcceptInput = {
  expectedFulfillmentAt?: InputMaybe<Scalars['DateTime']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type DesignerOrderDestinationModel = {
  __typename?: 'DesignerOrderDestinationModel';
  city: Scalars['String']['output'];
  company?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  countryName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  line1: Scalars['String']['output'];
  line2?: Maybe<Scalars['String']['output']>;
  line3?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  regionName?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type DesignerOrderEdge = {
  __typename?: 'DesignerOrderEdge';
  cursor: Scalars['String']['output'];
  node: DesignerOrder;
};

export type DesignerOrderFulfillInput = {
  message?: InputMaybe<Scalars['String']['input']>;
};

export type DesignerOrderHistory = Node & {
  __typename?: 'DesignerOrderHistory';
  action: DesignerOrderHistoryAction;
  createdAt: Scalars['DateTime']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  user?: Maybe<User>;
};

export enum DesignerOrderHistoryAction {
  OrderAccepted = 'OrderAccepted',
  OrderCancellationAccepted = 'OrderCancellationAccepted',
  OrderCancellationRequested = 'OrderCancellationRequested',
  OrderFulfillmentRequested = 'OrderFulfillmentRequested',
  OrderShipped = 'OrderShipped',
  OrderUpdated = 'OrderUpdated'
}

export type DesignerOrderShippingRequestInput = {
  itn?: InputMaybe<Scalars['String']['input']>;
  packageType: PackageType;
};

export enum DesignerOrderStatus {
  CancellationRequested = 'CANCELLATION_REQUESTED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  Requested = 'REQUESTED',
  Review = 'REVIEW'
}

export type DesignerOrderUpdateInput = {
  expectedFulfillmentAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DesignerOrdersPage = {
  __typename?: 'DesignerOrdersPage';
  edges: Array<DesignerOrderEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type DesignerStatusHistory = {
  __typename?: 'DesignerStatusHistory';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  leadStatus: LeadStatus;
  status: Status;
};

export type DesignerTask = {
  __typename?: 'DesignerTask';
  designer: Designer;
  id: Scalars['String']['output'];
  status: DesignerTaskStatus;
  type: DesignerTaskType;
};

export type DesignerTaskCreateInput = {
  designerId: Scalars['String']['input'];
  status: DesignerTaskStatus;
  type: DesignerTaskType;
};

export enum DesignerStyleTag {
  Architectural = 'Architectural',
  AvantGarde = 'AvantGarde',
  Classical = 'Classical',
  Dark = 'Dark',
  Folk = 'Folk',
  Maximalist = 'Maximalist',
  Minimal = 'Minimal',
  Organic = 'Organic',
  Playful = 'Playful',
  Romantic = 'Romantic',
  Sculptural = 'Sculptural',
  Symbolic = 'Symbolic'
}

export enum DesignerTaskStatus {
  Complete = 'Complete',
  Error = 'Error',
  Pending = 'Pending'
}

export enum DesignerTaskType {
  AcceptInstagramCollaborationPost = 'AcceptInstagramCollaborationPost',
  AddFinematterProfileToInstagramBio = 'AddFinematterProfileToInstagramBio',
  AddFinematterToStockistsPage = 'AddFinematterToStockistsPage',
  ReshareInstagramLaunchStories = 'ReshareInstagramLaunchStories',
  SendLaunchEmailNewsletter = 'SendLaunchEmailNewsletter'
}

export type DesignerTaskUpdateInput = {
  designerId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DesignerTaskStatus>;
  type?: InputMaybe<DesignerTaskType>;
};

export type DesignerUpdateInput = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  b2bPageUrl?: InputMaybe<Scalars['String']['input']>;
  bespoke?: InputMaybe<Scalars['Boolean']['input']>;
  billingAddress?: InputMaybe<AddressInput>;
  comingSoon?: InputMaybe<Scalars['Boolean']['input']>;
  curatorQuote?: InputMaybe<Scalars['String']['input']>;
  customisation?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  disabledCountries?: InputMaybe<Array<Country>>;
  ein?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabledCurrencies?: InputMaybe<Array<Currency>>;
  eori?: InputMaybe<Scalars['String']['input']>;
  featuredProductId?: InputMaybe<Scalars['String']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  highlights?: InputMaybe<Array<Scalars['String']['input']>>;
  instagramHandle?: InputMaybe<Scalars['String']['input']>;
  jewellerCategory?: InputMaybe<Scalars['String']['input']>;
  jewelleryMakingLocation?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['String']['input']>;
  leadStatus?: InputMaybe<Array<LeadStatus>>;
  leadTime?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['String']['input']>;
  margin?: InputMaybe<Scalars['Float']['input']>;
  marginBespoke?: InputMaybe<Scalars['Float']['input']>;
  materials?: InputMaybe<Scalars['String']['input']>;
  microBusiness?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  priceRange?: InputMaybe<Scalars['String']['input']>;
  productSpreadsheetId?: InputMaybe<Scalars['String']['input']>;
  profileImageUrl?: InputMaybe<Scalars['String']['input']>;
  readyToOrder?: InputMaybe<Scalars['Boolean']['input']>;
  remodel?: InputMaybe<Scalars['Boolean']['input']>;
  repair?: InputMaybe<Scalars['Boolean']['input']>;
  returnPeriodDays?: InputMaybe<Scalars['Float']['input']>;
  selectedB2BServices?: InputMaybe<Scalars['String']['input']>;
  servicesTerms?: InputMaybe<ServicesTermsInput>;
  shippingAddress?: InputMaybe<AddressInput>;
  shippingRegion?: InputMaybe<Array<ShippingRegions>>;
  specialties?: InputMaybe<Array<Scalars['String']['input']>>;
  storeAddress?: InputMaybe<Scalars['String']['input']>;
  storeGoogleMapsUrl?: InputMaybe<Scalars['String']['input']>;
  storeImageUrl?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  sustainabilityLabels?: InputMaybe<Array<SustainabilityLabel>>;
  tags?: InputMaybe<Array<DesignerStyleTag>>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  vatIdNo?: InputMaybe<Scalars['String']['input']>;
  verifiedPartner?: InputMaybe<Scalars['Boolean']['input']>;
  videoHighlightDescription?: InputMaybe<Scalars['String']['input']>;
  videoHighlightUrl?: InputMaybe<Scalars['String']['input']>;
  warrantyDuration?: InputMaybe<Scalars['Int']['input']>;
  warrantyTerms?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  workbenchImageUrl?: InputMaybe<Scalars['String']['input']>;
};

export type DesignerUserInput = {
  notify?: InputMaybe<Scalars['Boolean']['input']>;
  notifyOf?: InputMaybe<Array<DesignerUserNotificationDomain>>;
};

export type DesignerUserModel = Node & {
  __typename?: 'DesignerUserModel';
  designer: Designer;
  id: Scalars['ID']['output'];
  notify: Scalars['Boolean']['output'];
  shouldNotifyOrders: Scalars['Boolean']['output'];
  shouldNotifyPayouts: Scalars['Boolean']['output'];
  user: User;
};

export enum DesignerUserNotificationDomain {
  Orders = 'ORDERS',
  Payouts = 'PAYOUTS'
}

export type DesignerVacationDates = Node & {
  __typename?: 'DesignerVacationDates';
  createdAt: Scalars['DateTime']['output'];
  designerId?: Maybe<Scalars['String']['output']>;
  from: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  to: Scalars['DateTime']['output'];
};

export type DesignersPage = {
  __typename?: 'DesignersPage';
  edges: Array<DesignerEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type Diamond = {
  __typename?: 'Diamond';
  clarity?: Maybe<DiamondClarity>;
  class?: Maybe<DiamondClass>;
  colour?: Maybe<DiamondColour>;
  cut?: Maybe<DiamondCut>;
  shape?: Maybe<DiamondShape>;
};

export enum DiamondClarity {
  Fl = 'FL',
  I1 = 'I1',
  I2 = 'I2',
  I3 = 'I3',
  If = 'IF',
  Opaque = 'Opaque',
  Si1 = 'SI1',
  Si2 = 'SI2',
  Vs1 = 'VS1',
  Vs2 = 'VS2',
  Vvs1 = 'VVS1',
  Vvs2 = 'VVS2'
}

export enum DiamondClass {
  LabGrown = 'LabGrown',
  Natural = 'Natural'
}

export enum DiamondColour {
  D = 'D',
  E = 'E',
  F = 'F',
  Fancy = 'Fancy',
  G = 'G',
  H = 'H',
  I = 'I',
  J = 'J',
  K = 'K',
  L = 'L'
}

export enum DiamondCut {
  Excellent = 'Excellent',
  Fair = 'Fair',
  Good = 'Good',
  Poor = 'Poor',
  VeryGood = 'VeryGood'
}

export type DiamondInput = {
  clarity?: InputMaybe<DiamondClarity>;
  class?: InputMaybe<DiamondClass>;
  colour?: InputMaybe<DiamondColour>;
  cut?: InputMaybe<DiamondCut>;
  shape?: InputMaybe<DiamondShape>;
};

export enum DiamondShape {
  Asscher = 'Asscher',
  Baguette = 'Baguette',
  Briolette = 'Briolette',
  Carre = 'Carre',
  Cushion = 'Cushion',
  Emerald = 'Emerald',
  Heart = 'Heart',
  Kite = 'Kite',
  Marquise = 'Marquise',
  OldEuropean = 'OldEuropean',
  OldMine = 'OldMine',
  Oval = 'Oval',
  Pear = 'Pear',
  Portrait = 'Portrait',
  Princess = 'Princess',
  Radiant = 'Radiant',
  Rose = 'Rose',
  Round = 'Round',
  Trillion = 'Trillion'
}

export type Discount = {
  __typename?: 'Discount';
  associatedPieces: Array<Piece>;
  createdAt: Scalars['DateTime']['output'];
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  startsAt: Scalars['DateTime']['output'];
  status: DiscountStatus;
  target: DiscountTarget;
  title: Scalars['String']['output'];
  type: DiscountType;
  updatedAt: Scalars['DateTime']['output'];
  valueAmount: Scalars['Float']['output'];
  valueType: DiscountValueType;
};

export enum DiscountStatus {
  Active = 'Active',
  Expired = 'Expired',
  Scheduled = 'Scheduled'
}

export enum DiscountTarget {
  Order = 'Order',
  Product = 'Product',
  Shipping = 'Shipping'
}

export enum DiscountType {
  Automatic = 'Automatic',
  Code = 'Code'
}

export enum DiscountValueType {
  Fixed = 'Fixed',
  Percentage = 'Percentage'
}

export enum Durability {
  Plated = 'Plated',
  Solid = 'Solid'
}

export type Earring = {
  __typename?: 'Earring';
  category?: Maybe<EarringCategory>;
  closure?: Maybe<EarringClosure>;
  soldAs?: Maybe<EarringSoldAs>;
};

export enum EarringCategory {
  Climber = 'Climber',
  Cuff = 'Cuff',
  Dangle = 'Dangle',
  Drop = 'Drop',
  Hoops = 'Hoops',
  Huggies = 'Huggies',
  Statement = 'Statement',
  Studs = 'Studs',
  Threader = 'Threader'
}

export enum EarringClosure {
  Alpa = 'Alpa',
  BellBack = 'BellBack',
  Butterfly = 'Butterfly',
  Clasp = 'Clasp',
  ClipOn = 'ClipOn',
  Cuff = 'Cuff',
  FlatBack = 'FlatBack',
  Hook = 'Hook',
  Post = 'Post',
  Threader = 'Threader'
}

export type EarringInput = {
  category?: InputMaybe<EarringCategory>;
  closure?: InputMaybe<EarringClosure>;
  soldAs?: InputMaybe<EarringSoldAs>;
};

export enum EarringSoldAs {
  Pair = 'Pair',
  Single = 'Single',
  SingleAsymmetrical = 'SingleAsymmetrical',
  SingleLeft = 'SingleLeft',
  SingleOnly = 'SingleOnly',
  SingleRight = 'SingleRight'
}

export type ExchangeCreateInput = {
  creditAmount: Scalars['Float']['input'];
  currency: Currency;
  customerAccessToken: Scalars['String']['input'];
  exchangeDesigner?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  karat?: InputMaybe<Scalars['String']['input']>;
  metal?: InputMaybe<Scalars['String']['input']>;
  productToPurchaseVariantId: Scalars['String']['input'];
  weight?: InputMaybe<Scalars['String']['input']>;
};

export enum ExchangeMetal {
  KaratGold9 = 'KaratGold9',
  KaratGold10 = 'KaratGold10',
  KaratGold14 = 'KaratGold14',
  KaratGold18 = 'KaratGold18',
  KaratGold22 = 'KaratGold22',
  KaratGold24 = 'KaratGold24',
  Other = 'Other',
  SterlingSilver = 'SterlingSilver'
}

export type ExchangeResult = {
  __typename?: 'ExchangeResult';
  cartCheckoutUrl: Scalars['String']['output'];
  cartId: Scalars['String']['output'];
};

export type Favourite = {
  __typename?: 'Favourite';
  createdAt: Scalars['DateTime']['output'];
  handle: Scalars['String']['output'];
};

export type FavouriteInput = {
  /** The handle of the product from Shopify */
  handle: Scalars['String']['input'];
};

export type FavouritesBoard = {
  __typename?: 'FavouritesBoard';
  coverImage?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  items?: Maybe<Array<FavouritesBoardItem>>;
  name: Scalars['String']['output'];
  publicId: Scalars['String']['output'];
};

export type FavouritesBoardInput = {
  /** Name of board */
  name: Scalars['String']['input'];
};

export type FavouritesBoardItem = {
  __typename?: 'FavouritesBoardItem';
  createdAt: Scalars['DateTime']['output'];
  handle: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type FavouritesBoardItemInput = {
  /** ID of the board to which the item is added */
  boardId: Scalars['ID']['input'];
  /** The handle of the product from Shopify */
  handle: Scalars['String']['input'];
};

export enum Finish {
  Matte = 'Matte',
  Polished = 'Polished'
}

export type FulfillmentOrderLineItem = Node & {
  __typename?: 'FulfillmentOrderLineItem';
  appliedDiscount: Scalars['Float']['output'];
  customLettering?: Maybe<Scalars['String']['output']>;
  deliveredBy?: Maybe<Scalars['String']['output']>;
  engraving?: Maybe<Scalars['String']['output']>;
  engravingMaxLength?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  imageRaw?: Maybe<Scalars['String']['output']>;
  orderLineItem: Scalars['ID']['output'];
  price: Scalars['Float']['output'];
  productId: Scalars['String']['output'];
  productType: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  refundableQuantity?: Maybe<Scalars['Float']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  soldAs: Scalars['String']['output'];
  title: Scalars['String']['output'];
  variantId?: Maybe<Scalars['String']['output']>;
};

export enum GemstoneType {
  Agate = 'Agate',
  Alexandrite = 'Alexandrite',
  Amazonite = 'Amazonite',
  Amber = 'Amber',
  Amethyst = 'Amethyst',
  Aquamarine = 'Aquamarine',
  Beryl = 'Beryl',
  BlackDiamond = 'BlackDiamond',
  BrownDiamond = 'BrownDiamond',
  Carnelian = 'Carnelian',
  Chalcedony = 'Chalcedony',
  Citrine = 'Citrine',
  Coral = 'Coral',
  Diamond = 'Diamond',
  Emerald = 'Emerald',
  Garnet = 'Garnet',
  Iolite = 'Iolite',
  Jade = 'Jade',
  Kunzite = 'Kunzite',
  Kyanite = 'Kyanite',
  Labradorite = 'Labradorite',
  Lapis = 'Lapis',
  Malachite = 'Malachite',
  Moissanite = 'Moissanite',
  Moonstone = 'Moonstone',
  Morganite = 'Morganite',
  MotherOfPearl = 'MotherOfPearl',
  Onyx = 'Onyx',
  Opal = 'Opal',
  Other = 'Other',
  Pearl = 'Pearl',
  Peridot = 'Peridot',
  Quartz = 'Quartz',
  Rhodolite = 'Rhodolite',
  Rhodonite = 'Rhodonite',
  RockCrystal = 'RockCrystal',
  Ruby = 'Ruby',
  Sapphire = 'Sapphire',
  Spinel = 'Spinel',
  Tanzanite = 'Tanzanite',
  Topaz = 'Topaz',
  Tourmaline = 'Tourmaline',
  Tsavorite = 'Tsavorite',
  Turquoise = 'Turquoise'
}

export type GenericResult = {
  __typename?: 'GenericResult';
  success: Scalars['Boolean']['output'];
};

export type GoogleAuthenticationStart = {
  __typename?: 'GoogleAuthenticationStart';
  state: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type IpShopData = {
  __typename?: 'IPShopData';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
};

export type Image = {
  __typename?: 'Image';
  altText?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum ImgixAuto {
  Compress = 'COMPRESS',
  Enhance = 'ENHANCE',
  Format = 'FORMAT',
  Redeye = 'REDEYE'
}

export enum ImgixCrop {
  Bottom = 'BOTTOM',
  Edges = 'EDGES',
  Entropy = 'ENTROPY',
  Faces = 'FACES',
  FocalPoint = 'FOCAL_POINT',
  Left = 'LEFT',
  Right = 'RIGHT',
  Top = 'TOP'
}

export enum ImgixFit {
  Clamp = 'CLAMP',
  Clip = 'CLIP',
  Crop = 'CROP',
  FaceArea = 'FACE_AREA',
  Fill = 'FILL',
  FillMax = 'FILL_MAX',
  Max = 'MAX',
  Min = 'MIN',
  Scale = 'SCALE'
}

export type Instance = {
  __typename?: 'Instance';
  createdAt?: Maybe<Scalars['String']['output']>;
  designerName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  images?: Maybe<Array<Image>>;
  name?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Product>;
  productVariantId?: Maybe<Scalars['String']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
};

export type Invoice = Node & {
  __typename?: 'Invoice';
  id: Scalars['ID']['output'];
  invoiceNo: Scalars['Float']['output'];
  orderNo: Scalars['String']['output'];
  pdfCommercial: Scalars['String']['output'];
  pdfSales: Scalars['String']['output'];
};

export enum JewelleryType {
  Anklet = 'Anklet',
  Bracelet = 'Bracelet',
  Earring = 'Earring',
  Necklace = 'Necklace',
  Pendant = 'Pendant',
  Ring = 'Ring'
}

export enum Karat {
  Kt_9 = 'KT_9',
  Kt_10 = 'KT_10',
  Kt_12 = 'KT_12',
  Kt_14 = 'KT_14',
  Kt_18 = 'KT_18',
  Kt_20 = 'KT_20',
  Kt_22 = 'KT_22',
  Kt_24 = 'KT_24'
}

export type LeadCreateInput = {
  countryOfOrigin: Scalars['String']['input'];
  email: Scalars['String']['input'];
  instagramHandle?: InputMaybe<Scalars['String']['input']>;
  jewelleryMakingLocation: Scalars['String']['input'];
  leadTime: Scalars['String']['input'];
  materials: Scalars['String']['input'];
  name: Scalars['String']['input'];
  otherPartners: Scalars['String']['input'];
  otherPartnersText: Scalars['String']['input'];
  priceRange: Scalars['String']['input'];
  taxRegistered: Scalars['String']['input'];
  website: Scalars['String']['input'];
};

export type LeadCreateInternalInput = {
  countryOfOrigin: Scalars['String']['input'];
  description: Scalars['String']['input'];
  email: Scalars['String']['input'];
  instagramHandle?: InputMaybe<Scalars['String']['input']>;
  leadSource: LeadSource;
  name: Scalars['String']['input'];
  website?: InputMaybe<Scalars['String']['input']>;
};

export type LeadMessageInput = {
  message?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export enum LeadOrderByInput {
  CreatedAt = 'createdAt',
  Name = 'name'
}

export enum LeadSource {
  Canvassing = 'Canvassing',
  Inbound = 'Inbound',
  Instagram = 'Instagram',
  LinkUp = 'LinkUp',
  Other = 'Other',
  Referral = 'Referral',
  TradeFair = 'TradeFair'
}

export enum LeadStatus {
  Applied = 'Applied',
  Approved = 'Approved',
  Contacted = 'Contacted',
  OnHold = 'OnHold',
  PendingRegistration = 'PendingRegistration',
  Rejected = 'Rejected'
}

export type LeadTimeInput = {
  from: Scalars['Float']['input'];
  to: Scalars['Float']['input'];
  unit: TimeUnit;
};

export type LoginPasswordInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export enum Material {
  Brass = 'Brass',
  Bronze = 'Bronze',
  Enamel = 'Enamel',
  GoldBlack = 'GoldBlack',
  GoldGreen = 'GoldGreen',
  GoldRose = 'GoldRose',
  GoldWhite = 'GoldWhite',
  GoldYellow = 'GoldYellow',
  Other = 'Other',
  Platinum = 'Platinum',
  SilverSterling = 'SilverSterling'
}

export type MaterialPrice = {
  __typename?: 'MaterialPrice';
  currencyAmounts: Array<CurrencyAmount>;
  materialType: MaterialType;
};

export enum MaterialType {
  GoldPlatedBronze = 'GoldPlatedBronze',
  GoldPlatedSilver = 'GoldPlatedSilver',
  KaratGold9 = 'KaratGold9',
  KaratGold10 = 'KaratGold10',
  KaratGold14 = 'KaratGold14',
  KaratGold18 = 'KaratGold18',
  KaratGold22 = 'KaratGold22',
  KaratGold23 = 'KaratGold23',
  KaratGold24 = 'KaratGold24',
  Other = 'Other',
  SterlingSilver = 'SterlingSilver',
  Unknown = 'Unknown'
}

export type MetafieldInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  namespace: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};

export type MultiItemServiceOrderCreateDto = {
  __typename?: 'MultiItemServiceOrderCreateDTO';
  items: Array<ServiceOrderItem>;
  order: ServiceOrder;
};

export type MultiItemServiceOrderCreateInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  items: Array<ServiceOrderItemCreateInput>;
  lastName: Scalars['String']['input'];
  orderPage?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  AllowSkuSharingForAllDesigners: Scalars['String']['output'];
  activateUser: Authentication;
  activateUserRequest: GenericResult;
  activateWorkshop?: Maybe<Workshop>;
  addArbitraryPayoutLine: Payout;
  addItemToFavouritesBoard: Scalars['Boolean']['output'];
  assignBatchBarcode?: Maybe<Batch>;
  assignBatchToWorkshop?: Maybe<Batch>;
  assignWorkshopJobBarcode?: Maybe<WorkshopJob>;
  assignWorkshopJobToWorkshop?: Maybe<WorkshopJob>;
  bespokeServiceOrderCreate: ServiceOrderBespoke;
  brandCreate: Brand;
  brandDelete: DeletedEntity;
  brandDesignerAdd: BrandDesigner;
  brandDesignerRemove: DeletedEntity;
  brandDesignerUpdate: BrandDesigner;
  brandUpdate: Brand;
  bulkUpdateLeadTime: Scalars['Boolean']['output'];
  changePayoutLineStatus: Payout;
  changePayoutStatus: Payout;
  changePhotoshootLineStatus: Photoshoot;
  changePhotoshootStatus: Photoshoot;
  contact: Contact;
  createB2BBatchServiceOrder: Array<Batch>;
  createBatch: Batch;
  createCustomerCreditEntry: CustomerCreditEntry;
  createCustomerReferralCampaignEntry: CustomerReferralEntry;
  createFavouritesBoard: FavouritesBoard;
  createMultiItemServiceOrder: MultiItemServiceOrderCreateDto;
  createPhotoshoot: Photoshoot;
  createPhotoshootLines: Photoshoot;
  createPhotoshootShipments: Array<Shipment>;
  createServiceOrderItem: ServiceOrderItem;
  createServiceOrderShipment: Shipment;
  createSubscriptionCheckout: CheckoutResponseModel;
  createWorkshop: Workshop;
  createWorkshopJob: WorkshopJob;
  currencyRatesRefresh: GenericResult;
  customerAssociateProduct: CustomerAssociatePayload;
  customerCreate: Customer;
  customerUpdateMetafield: CustomerMetafieldPayload;
  deactivateWorkshop?: Maybe<Workshop>;
  deleteBatch: Scalars['Boolean']['output'];
  deleteCustomerReferralEntry: CustomerReferralEntry;
  deleteFavouritesBoard: Scalars['Boolean']['output'];
  deletePhotoshoot: DeletedEntity;
  deletePhotoshootLine: Photoshoot;
  deleteServiceOrderItem: Scalars['Boolean']['output'];
  deleteUser: GenericResult;
  deleteVacationDate: DeletedEntity;
  deleteWorkshop: Scalars['Boolean']['output'];
  deleteWorkshopJob: Scalars['Boolean']['output'];
  designerCreate: Designer;
  designerDelete: DeletedEntity;
  designerOrderAccept: DesignerOrder;
  designerOrderAcceptCancellation: DesignerOrder;
  designerOrderFulfill: DesignerOrder;
  designerOrderGenerateInvoice: Scalars['Boolean']['output'];
  designerOrderShippingRequest: DesignerOrder;
  designerOrderUpdate: DesignerOrder;
  designerRegisterShopify: Designer;
  designerRestore: Designer;
  designerTaskCreate: DesignerTask;
  designerTaskUpdate: DesignerTask;
  designerUpdate: Designer;
  designerUserAdd: DesignerUserModel;
  designerUserRemove: DeletedEntity;
  designerUserUpdate: DesignerUserModel;
  exchangeCreate: ExchangeResult;
  favouritesSet: Array<Favourite>;
  hidePieces: Array<Scalars['String']['output']>;
  leadApprove: Designer;
  leadContact: Designer;
  leadCreate: Designer;
  leadCreateInternal: Designer;
  leadOnHold: Designer;
  leadReject: Designer;
  leadRemove: Scalars['Boolean']['output'];
  leadSendMessage: Designer;
  loginGoogle: Authentication;
  loginPassword: Authentication;
  markBatchAsReceived?: Maybe<Batch>;
  materialPriceUpdate: MaterialPrice;
  passwordChange: GenericResult;
  passwordRecovery: GenericResult;
  passwordRecoveryRequest: GenericResult;
  pieceCollectionCreate: PieceCollection;
  pieceCollectionDelete: DeletedEntity;
  pieceCollectionUpdate: PieceCollection;
  pieceCreate: Piece;
  pieceDelete: DeletedEntity;
  pieceImageDelete: GenericResult;
  pieceUpdate: Piece;
  pieceVariantUpdate: PieceVariant;
  piecesExportBrand: GenericResult;
  piecesExportDesigner: GenericResult;
  piecesExportPiece: GenericResult;
  piecesExportPieces: GenericResult;
  piecesExportPrices: GenericResult;
  piecesImport: GenericResult;
  piecesImportFromSheet: GenericResult;
  publicCreateCreditDiscount: Scalars['String']['output'];
  publicCreateCustomerReferralEntry: CustomerReferralEntry;
  publicRegisterDesigner: PublicDesigner;
  removeItemFromFavouritesBoard: Scalars['Boolean']['output'];
  saveBankDetails: BankDetails;
  saveVacationDates: Designer;
  sendFavouritesEmail: Scalars['Boolean']['output'];
  serviceOrderCreate: ServiceOrder;
  syncFavourites: Array<Favourite>;
  syncLocalPrices: SyncProducts;
  syncOrder: SyncOrder;
  syncOrders: SyncOrders;
  syncProductVariantIds: SyncProducts;
  syncProducts: SyncProducts;
  unhidePieces: Array<Scalars['String']['output']>;
  updateBatch?: Maybe<Batch>;
  updateBatchStatus?: Maybe<Batch>;
  updateFavouritesBoard: FavouritesBoard;
  updateServiceOrderItem?: Maybe<ServiceOrderItem>;
  updateServiceOrderStatus: ServiceOrder;
  updateWorkshop?: Maybe<Workshop>;
  updateWorkshopJob?: Maybe<WorkshopJob>;
  updateWorkshopJobStatus?: Maybe<WorkshopJob>;
  uploadFile: RemoteFile;
  uploadProductImage: GenericResult;
  userCreate: User;
  userUpdate: User;
};


export type MutationActivateUserArgs = {
  input: ActivateUserInput;
};


export type MutationActivateUserRequestArgs = {
  input: ActivateUserRequestInput;
};


export type MutationActivateWorkshopArgs = {
  id: Scalars['String']['input'];
};


export type MutationAddArbitraryPayoutLineArgs = {
  input: PayoutLineInput;
};


export type MutationAddItemToFavouritesBoardArgs = {
  input: FavouritesBoardItemInput;
};


export type MutationAssignBatchBarcodeArgs = {
  barcode: Scalars['String']['input'];
  id: Scalars['String']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAssignBatchToWorkshopArgs = {
  id: Scalars['String']['input'];
  workshopId: Scalars['String']['input'];
};


export type MutationAssignWorkshopJobBarcodeArgs = {
  barcode: Scalars['String']['input'];
  id: Scalars['String']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAssignWorkshopJobToWorkshopArgs = {
  id: Scalars['String']['input'];
  workshopId: Scalars['String']['input'];
};


export type MutationBespokeServiceOrderCreateArgs = {
  input: BespokeServiceOrderCreateInput;
};


export type MutationBrandCreateArgs = {
  input: BrandCreateInput;
};


export type MutationBrandDeleteArgs = {
  handle: Scalars['String']['input'];
};


export type MutationBrandDesignerAddArgs = {
  input: BrandDesignerAddInput;
};


export type MutationBrandDesignerRemoveArgs = {
  id: Scalars['String']['input'];
};


export type MutationBrandDesignerUpdateArgs = {
  id: Scalars['String']['input'];
  input: BrandDesignerUpdateInput;
};


export type MutationBrandUpdateArgs = {
  handle: Scalars['String']['input'];
  input: BrandUpdateInput;
};


export type MutationBulkUpdateLeadTimeArgs = {
  ids: Array<Scalars['ID']['input']>;
  leadTime: LeadTimeInput;
};


export type MutationChangePayoutLineStatusArgs = {
  excludedReason?: InputMaybe<PayoutLineExcludedReason>;
  id: Scalars['String']['input'];
  isExcluded?: InputMaybe<Scalars['Boolean']['input']>;
  quantityReturned?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationChangePayoutStatusArgs = {
  id: Scalars['String']['input'];
  status: PayoutStatus;
};


export type MutationChangePhotoshootLineStatusArgs = {
  id: Scalars['String']['input'];
  status: PhotoshootLineStatus;
};


export type MutationChangePhotoshootStatusArgs = {
  id: Scalars['String']['input'];
  status: PhotoshootStatus;
};


export type MutationContactArgs = {
  input: ContactCustomerServiceInput;
};


export type MutationCreateB2BBatchServiceOrderArgs = {
  clientId: Scalars['String']['input'];
  input: MultiItemServiceOrderCreateInput;
};


export type MutationCreateBatchArgs = {
  input: BatchCreateInput;
};


export type MutationCreateCustomerCreditEntryArgs = {
  amount: Scalars['Float']['input'];
  currency: Currency;
  expiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  settled?: Scalars['Boolean']['input'];
  shopifyCustomerId: Scalars['String']['input'];
  shopifyDiscountCode?: InputMaybe<Scalars['String']['input']>;
  shopifyOrderId?: InputMaybe<Scalars['String']['input']>;
  source: CustomerCreditEntrySource;
};


export type MutationCreateCustomerReferralCampaignEntryArgs = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  campaign?: InputMaybe<Scalars['String']['input']>;
  currency: Currency;
  expiryPeriod?: InputMaybe<Scalars['Float']['input']>;
  maximumUses?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationCreateFavouritesBoardArgs = {
  input: FavouritesBoardInput;
  userId: Scalars['String']['input'];
};


export type MutationCreateMultiItemServiceOrderArgs = {
  input: MultiItemServiceOrderCreateInput;
};


export type MutationCreatePhotoshootArgs = {
  input: CreatePhotoshootInput;
};


export type MutationCreatePhotoshootLinesArgs = {
  input: CreatePhotoshootLinesInput;
};


export type MutationCreatePhotoshootShipmentsArgs = {
  input: CreatePhotoshootShipmentsInput;
};


export type MutationCreateServiceOrderItemArgs = {
  input: ServiceOrderItemCreateInput;
};


export type MutationCreateServiceOrderShipmentArgs = {
  input: ServiceOrderCreateShipmentInput;
};


export type MutationCreateSubscriptionCheckoutArgs = {
  cancelUrl: Scalars['String']['input'];
  designerId: Scalars['ID']['input'];
  priceId: Scalars['String']['input'];
  successUrl: Scalars['String']['input'];
};


export type MutationCreateWorkshopArgs = {
  input: WorkshopCreateInput;
};


export type MutationCreateWorkshopJobArgs = {
  input: WorkshopJobCreateInput;
};


export type MutationCustomerAssociateProductArgs = {
  customerId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  variantId: Scalars['String']['input'];
};


export type MutationCustomerCreateArgs = {
  acceptsMarketing: Scalars['Boolean']['input'];
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  referralCode?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Region>;
};


export type MutationCustomerUpdateMetafieldArgs = {
  input: CustomerMetafieldInput;
};


export type MutationDeactivateWorkshopArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteBatchArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteCustomerReferralEntryArgs = {
  entryId: Scalars['String']['input'];
};


export type MutationDeleteFavouritesBoardArgs = {
  boardId: Scalars['String']['input'];
};


export type MutationDeletePhotoshootArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeletePhotoshootLineArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteServiceOrderItemArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteVacationDateArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteWorkshopArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteWorkshopJobArgs = {
  id: Scalars['String']['input'];
};


export type MutationDesignerCreateArgs = {
  input: DesignerCreateInput;
};


export type MutationDesignerDeleteArgs = {
  handle: Scalars['String']['input'];
};


export type MutationDesignerOrderAcceptArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<DesignerOrderAcceptInput>;
};


export type MutationDesignerOrderAcceptCancellationArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<DesignerOrderAcceptCancellationInput>;
};


export type MutationDesignerOrderFulfillArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<DesignerOrderFulfillInput>;
};


export type MutationDesignerOrderGenerateInvoiceArgs = {
  fulfillmentId: Scalars['ID']['input'];
};


export type MutationDesignerOrderShippingRequestArgs = {
  id: Scalars['ID']['input'];
  input: DesignerOrderShippingRequestInput;
};


export type MutationDesignerOrderUpdateArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<DesignerOrderUpdateInput>;
};


export type MutationDesignerRegisterShopifyArgs = {
  handle: Scalars['String']['input'];
};


export type MutationDesignerRestoreArgs = {
  handle: Scalars['String']['input'];
};


export type MutationDesignerTaskCreateArgs = {
  input: DesignerTaskCreateInput;
};


export type MutationDesignerTaskUpdateArgs = {
  id: Scalars['String']['input'];
  input: DesignerTaskUpdateInput;
};


export type MutationDesignerUpdateArgs = {
  handle: Scalars['String']['input'];
  input: DesignerUpdateInput;
};


export type MutationDesignerUserAddArgs = {
  designerHandle: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationDesignerUserRemoveArgs = {
  id: Scalars['String']['input'];
};


export type MutationDesignerUserUpdateArgs = {
  id: Scalars['String']['input'];
  input: DesignerUserInput;
};


export type MutationExchangeCreateArgs = {
  input: ExchangeCreateInput;
};


export type MutationFavouritesSetArgs = {
  favourites: Array<FavouriteInput>;
  userId: Scalars['String']['input'];
};


export type MutationHidePiecesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationLeadApproveArgs = {
  handle: Scalars['String']['input'];
  input?: InputMaybe<LeadMessageInput>;
};


export type MutationLeadContactArgs = {
  handle: Scalars['String']['input'];
  input?: InputMaybe<LeadMessageInput>;
};


export type MutationLeadCreateArgs = {
  input: LeadCreateInput;
};


export type MutationLeadCreateInternalArgs = {
  input: LeadCreateInternalInput;
};


export type MutationLeadOnHoldArgs = {
  handle: Scalars['String']['input'];
  input?: InputMaybe<LeadMessageInput>;
};


export type MutationLeadRejectArgs = {
  handle: Scalars['String']['input'];
  input?: InputMaybe<LeadMessageInput>;
};


export type MutationLeadRemoveArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLeadSendMessageArgs = {
  handle: Scalars['String']['input'];
  input?: InputMaybe<LeadMessageInput>;
};


export type MutationLoginGoogleArgs = {
  code: Scalars['String']['input'];
};


export type MutationLoginPasswordArgs = {
  input: LoginPasswordInput;
};


export type MutationMarkBatchAsReceivedArgs = {
  id: Scalars['String']['input'];
};


export type MutationMaterialPriceUpdateArgs = {
  currencyAmounts: Array<CurrencyAmountInput>;
  materialType: MaterialType;
};


export type MutationPasswordChangeArgs = {
  input: PasswordChangeInput;
};


export type MutationPasswordRecoveryArgs = {
  input: PasswordRecoveryInput;
};


export type MutationPasswordRecoveryRequestArgs = {
  input: PasswordRecoveryRequestInput;
};


export type MutationPieceCollectionCreateArgs = {
  input: PieceCollectionCreateInput;
};


export type MutationPieceCollectionDeleteArgs = {
  handle: Scalars['String']['input'];
};


export type MutationPieceCollectionUpdateArgs = {
  handle: Scalars['String']['input'];
  input: PieceCollectionUpdateInput;
};


export type MutationPieceCreateArgs = {
  input: PieceCreateInput;
};


export type MutationPieceDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPieceImageDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationPieceUpdateArgs = {
  id: Scalars['ID']['input'];
  input: PieceUpdateInput;
};


export type MutationPieceVariantUpdateArgs = {
  id: Scalars['ID']['input'];
  input: PieceVariantInput;
};


export type MutationPiecesExportBrandArgs = {
  brandHandle: Scalars['String']['input'];
};


export type MutationPiecesExportDesignerArgs = {
  designerHandle: Scalars['String']['input'];
};


export type MutationPiecesExportPieceArgs = {
  id: Scalars['String']['input'];
};


export type MutationPiecesExportPiecesArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationPiecesImportArgs = {
  designerHandle: Scalars['String']['input'];
};


export type MutationPiecesImportFromSheetArgs = {
  designerHandle: Scalars['String']['input'];
};


export type MutationPublicCreateCreditDiscountArgs = {
  customerAccessToken: Scalars['String']['input'];
};


export type MutationPublicCreateCustomerReferralEntryArgs = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  currency: Currency;
  customerAccessToken: Scalars['String']['input'];
  maximumUses?: InputMaybe<Scalars['Float']['input']>;
  toUserEmail: Scalars['String']['input'];
};


export type MutationPublicRegisterDesignerArgs = {
  id: Scalars['ID']['input'];
  input: PublicRegisterDesignerArgs;
};


export type MutationRemoveItemFromFavouritesBoardArgs = {
  input: FavouritesBoardItemInput;
};


export type MutationSaveBankDetailsArgs = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  bankAccountName?: InputMaybe<Scalars['String']['input']>;
  bankAddress?: InputMaybe<Scalars['String']['input']>;
  clearingNumber?: InputMaybe<Scalars['String']['input']>;
  cvr?: InputMaybe<Scalars['String']['input']>;
  designerId: Scalars['String']['input'];
  iban?: InputMaybe<Scalars['String']['input']>;
  routingNumber?: InputMaybe<Scalars['String']['input']>;
  sortCode?: InputMaybe<Scalars['String']['input']>;
  swiftCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSaveVacationDatesArgs = {
  handle: Scalars['String']['input'];
  input: VacationDatesInput;
};


export type MutationSendFavouritesEmailArgs = {
  message: Scalars['String']['input'];
  targetEmails: Array<Scalars['String']['input']>;
  userShopifyId: Scalars['String']['input'];
};


export type MutationServiceOrderCreateArgs = {
  input: ServiceOrderCreateInput;
};


export type MutationSyncOrderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnhidePiecesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationUpdateBatchArgs = {
  id: Scalars['String']['input'];
  input: BatchUpdateInput;
};


export type MutationUpdateBatchStatusArgs = {
  id: Scalars['String']['input'];
  status: BatchStatus;
};


export type MutationUpdateFavouritesBoardArgs = {
  boardId: Scalars['String']['input'];
  input: FavouritesBoardInput;
};


export type MutationUpdateServiceOrderItemArgs = {
  id: Scalars['String']['input'];
  input: ServiceOrderItemUpdateInput;
};


export type MutationUpdateServiceOrderStatusArgs = {
  id: Scalars['String']['input'];
  status: ServiceOrderStatus;
};


export type MutationUpdateWorkshopArgs = {
  id: Scalars['String']['input'];
  input: WorkshopUpdateInput;
};


export type MutationUpdateWorkshopJobArgs = {
  id: Scalars['String']['input'];
  input: WorkshopJobUpdateInput;
};


export type MutationUpdateWorkshopJobStatusArgs = {
  id: Scalars['String']['input'];
  status: WorkshopJobStatus;
};


export type MutationUploadFileArgs = {
  file: Scalars['Upload']['input'];
  namespace: Scalars['String']['input'];
  path: Scalars['String']['input'];
};


export type MutationUploadProductImageArgs = {
  file: Scalars['Upload']['input'];
  gender: Scalars['String']['input'];
  order: Scalars['Float']['input'];
  pieceId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
  usePhotoroom?: Scalars['Boolean']['input'];
};


export type MutationUserCreateArgs = {
  input: UserCreateInput;
};


export type MutationUserUpdateArgs = {
  id: Scalars['String']['input'];
  input: UserUpdateInput;
};

export type Necklace = {
  __typename?: 'Necklace';
  category?: Maybe<NecklaceCategory>;
  lock?: Maybe<NecklaceLock>;
};

export enum NecklaceCategory {
  Bead = 'Bead',
  Chain = 'Chain',
  Charm = 'Charm',
  Choker = 'Choker',
  Lariat = 'Lariat',
  Link = 'Link',
  Pendant = 'Pendant',
  PendantWithoutChain = 'PendantWithoutChain',
  Station = 'Station',
  Tennis = 'Tennis'
}

export type NecklaceInput = {
  category?: InputMaybe<NecklaceCategory>;
  lock?: InputMaybe<NecklaceLock>;
};

export enum NecklaceLock {
  ButtonFastening = 'ButtonFastening',
  Hook = 'Hook',
  LobsterClaw = 'LobsterClaw',
  PushClasp = 'PushClasp',
  SClasp = 'SClasp',
  SlidingKnot = 'SlidingKnot',
  SlipOn = 'SlipOn',
  SpringClasp = 'SpringClasp',
  TBar = 'TBar',
  TieFastening = 'TieFastening'
}

export type Node = {
  id: Scalars['ID']['output'];
};

export type OrderInvoiceInput = {
  customerAccessToken: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  orderNo: Scalars['String']['input'];
};

export enum PackageType {
  Large = 'LARGE',
  Small = 'SMALL'
}

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PasswordChangeInput = {
  newPassword: Scalars['String']['input'];
  oldPassword?: InputMaybe<Scalars['String']['input']>;
};

export type PasswordRecoveryInput = {
  password: Scalars['String']['input'];
  token: Scalars['ID']['input'];
};

export type PasswordRecoveryRequestInput = {
  email: Scalars['String']['input'];
};

export type Payout = {
  __typename?: 'Payout';
  createdAt: Scalars['DateTime']['output'];
  designer: Designer;
  designerAddress: Scalars['String']['output'];
  designerCurrency: Scalars['String']['output'];
  designerId: Scalars['ID']['output'];
  finematterAddress: Scalars['String']['output'];
  generatedBy?: Maybe<Scalars['String']['output']>;
  generatedByUser: User;
  id: Scalars['ID']['output'];
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  paidBy?: Maybe<Scalars['String']['output']>;
  paidByUser?: Maybe<User>;
  paymentPeriod: Scalars['DateTime']['output'];
  payoutLines: Array<PayoutLine>;
  pdfUrl: Scalars['String']['output'];
  reference: Scalars['String']['output'];
  status: PayoutStatus;
  totalAmount: Scalars['Float']['output'];
  totalAmountByExchangeRate: Scalars['Float']['output'];
  totalFinematterCommission: Scalars['Float']['output'];
  totalFinematterVAT: Scalars['Float']['output'];
  totalGrossTransactionalAmount: Scalars['Float']['output'];
  totalGrossEarningsExcludingTaxes: Scalars['Float']['output'];
  totalImportTaxCollected: Scalars['Float']['output'];
  totalTaxCollected: Scalars['Float']['output'];
  totalVATCollected: Scalars['Float']['output'];
  vatRate?: Maybe<Scalars['Float']['output']>;
};

export type PayoutEdge = {
  __typename?: 'PayoutEdge';
  cursor: Scalars['String']['output'];
  node: Payout;
};

export type PayoutLine = {
  __typename?: 'PayoutLine';
  commissionRate: Scalars['Float']['output'];
  commissionTotal: Scalars['Float']['output'];
  customerCurrency: Currency;
  exchangeRate: Scalars['Float']['output'];
  excludedReason?: Maybe<PayoutLineExcludedReason>;
  grossTransactionalAmount: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  importRate?: Maybe<Scalars['Float']['output']>;
  importTotal: Scalars['Float']['output'];
  isExcluded: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  netTotal: Scalars['Float']['output'];
  netTotalExcludingCommission: Scalars['Float']['output'];
  orderReference?: Maybe<Scalars['String']['output']>;
  payout: Payout;
  payoutId: Scalars['String']['output'];
  piece?: Maybe<Piece>;
  pieceId?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  quantityReturned: Scalars['Int']['output'];
  refundOf?: Maybe<PayoutLine>;
  shipmentType?: Maybe<PayoutShipmentType>;
  shopifyCustomerId?: Maybe<Scalars['String']['output']>;
  shopifyLineItemId?: Maybe<Scalars['String']['output']>;
  shopifyOrderId?: Maybe<Scalars['String']['output']>;
  transactionDiscount: Scalars['Float']['output'];
  vatRate?: Maybe<Scalars['Float']['output']>;
  vatTotal: Scalars['Float']['output'];
};

export enum PayoutLineExcludedReason {
  Exchanged = 'Exchanged',
  Refunded = 'Refunded',
  RolledOver = 'RolledOver',
  Voided = 'Voided'
}

export type PayoutLineInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Currency>;
  description?: InputMaybe<Scalars['String']['input']>;
  payoutId?: InputMaybe<Scalars['ID']['input']>;
};

export enum PayoutOrderByInput {
  CreatedAt = 'createdAt',
  DesignerName = 'designerName',
  Id = 'id',
  PaymentPeriod = 'paymentPeriod',
  Status = 'status'
}

export enum PayoutShipmentType {
  Domestic = 'Domestic',
  International = 'International',
  IntraEu = 'IntraEU'
}

export enum PayoutStatus {
  Draft = 'Draft',
  Paid = 'Paid',
  Pending = 'Pending'
}

export type PayoutsPage = {
  __typename?: 'PayoutsPage';
  edges: Array<PayoutEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type Pearl = {
  __typename?: 'Pearl';
  shape?: Maybe<PearlShape>;
  type?: Maybe<PearlType>;
};

export type PearlInput = {
  shape?: InputMaybe<PearlShape>;
  type?: InputMaybe<PearlType>;
};

export enum PearlShape {
  Baroque = 'Baroque',
  Keshi = 'Keshi',
  Round = 'Round',
  Seed = 'Seed'
}

export enum PearlType {
  Akoya = 'Akoya',
  Freshwater = 'Freshwater',
  SouthSea = 'SouthSea',
  Tahitian = 'Tahitian'
}

export type Photoshoot = {
  __typename?: 'Photoshoot';
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  location: PhotoshootLocation;
  photoshootLines: Array<PhotoshootLine>;
  reference: Scalars['String']['output'];
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status: PhotoshootStatus;
  type: PhotoshootType;
};

export type PhotoshootDesignerShipmentInput = {
  designerName: Scalars['String']['input'];
  pieceId: Scalars['String']['input'];
};

export enum PhotoshootDirection {
  Inbound = 'inbound',
  Outbound = 'outbound'
}

export type PhotoshootEdge = {
  __typename?: 'PhotoshootEdge';
  cursor: Scalars['String']['output'];
  node: Photoshoot;
};

export type PhotoshootLine = {
  __typename?: 'PhotoshootLine';
  id: Scalars['ID']['output'];
  inboundShipment?: Maybe<Shipment>;
  outboundShipment?: Maybe<Shipment>;
  photoshoot: Photoshoot;
  photoshootId: Scalars['String']['output'];
  piece: Piece;
  pieceId: Scalars['String']['output'];
  status: PhotoshootLineStatus;
};

export enum PhotoshootLineStatus {
  Booked = 'Booked',
  CheckedIn = 'CheckedIn',
  InTransit = 'InTransit',
  Returned = 'Returned',
  Shot = 'Shot'
}

export enum PhotoshootLocation {
  London = 'London',
  NewYork = 'NewYork',
  Porto = 'Porto'
}

export enum PhotoshootOrderByInput {
  CreatedAt = 'createdAt',
  Id = 'id',
  Status = 'status'
}

export enum PhotoshootStatus {
  Booked = 'Booked',
  Complete = 'Complete',
  InProgress = 'InProgress'
}

export enum PhotoshootType {
  OnModel = 'OnModel',
  Packshots = 'Packshots'
}

export type PhotoshootsPage = {
  __typename?: 'PhotoshootsPage';
  edges: Array<PhotoshootEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type Piece = Node & PiecePriceable & {
  __typename?: 'Piece';
  anklet?: Maybe<Anklet>;
  bracelet?: Maybe<Bracelet>;
  brand: Brand;
  brooch?: Maybe<Brooch>;
  circumference?: Maybe<PieceSize>;
  collection?: Maybe<PieceCollection>;
  createdAt: Scalars['String']['output'];
  cufflink?: Maybe<Cufflink>;
  curatorQuote?: Maybe<Scalars['String']['output']>;
  customLetteringMaxLength?: Maybe<Scalars['Float']['output']>;
  defaultVariantShopifyId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  designYear?: Maybe<Scalars['String']['output']>;
  designer: Designer;
  designerCity?: Maybe<Scalars['String']['output']>;
  designerHandle: Scalars['String']['output'];
  diameter?: Maybe<PieceSize>;
  disabledCountries: Array<Country>;
  discounts: Array<Discount>;
  dropLength?: Maybe<PieceSize>;
  earring?: Maybe<Earring>;
  engraving: Scalars['Boolean']['output'];
  engravingMaxLength?: Maybe<Scalars['Float']['output']>;
  gemstones: Array<PieceGemstone>;
  gender: PieceGender;
  handle?: Maybe<Scalars['String']['output']>;
  hasCustomLettering: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  images: Array<PieceImage>;
  isBespoke: Scalars['Boolean']['output'];
  isHollow: Scalars['Boolean']['output'];
  leadTime?: Maybe<TimeRange>;
  length?: Maybe<PieceSize>;
  localPrices?: Maybe<Array<PiecePrice>>;
  margin: Scalars['Float']['output'];
  marginBespoke?: Maybe<Scalars['Float']['output']>;
  metals: Array<PieceMetal>;
  necklace?: Maybe<Necklace>;
  oneOfAKind: Scalars['Boolean']['output'];
  options: Array<PieceOption>;
  photoshoot?: Maybe<Photoshoot>;
  prices: Array<PiecePrice>;
  productionYear?: Maybe<Scalars['String']['output']>;
  returnPeriodDays?: Maybe<Scalars['Float']['output']>;
  ring?: Maybe<Ring>;
  shippingRegion?: Maybe<Scalars['String']['output']>;
  shopifyId?: Maybe<Scalars['String']['output']>;
  shopifyUrl?: Maybe<Scalars['String']['output']>;
  siteUrl?: Maybe<Scalars['String']['output']>;
  sku: Scalars['String']['output'];
  status: PieceStatus;
  sustainabilityLabels: Array<SustainabilityLabel>;
  tags: Array<PieceTags>;
  title: Scalars['String']['output'];
  tonality?: Maybe<Tonality>;
  type: PieceType;
  vacationDates?: Maybe<Array<Scalars['String']['output']>>;
  variants?: Maybe<Array<PieceVariant>>;
  videos: Array<PieceImage>;
  vintage: Vintage;
  warrantyDuration?: Maybe<Scalars['Float']['output']>;
  warrantyTerms?: Maybe<Scalars['String']['output']>;
  width?: Maybe<PieceSize>;
};

export type PieceAlterationProductInput = {
  alteration: Alteration;
  designerHandle: Scalars['String']['input'];
  karats?: InputMaybe<Karat>;
  material: Material;
  pieceType: PieceType;
};

export type PieceCollection = Node & {
  __typename?: 'PieceCollection';
  brand?: Maybe<Brand>;
  description?: Maybe<Scalars['String']['output']>;
  handle: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type PieceCollectionCreateInput = {
  brandHandle: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  handle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type PieceCollectionEdge = {
  __typename?: 'PieceCollectionEdge';
  cursor: Scalars['String']['output'];
  node: PieceCollection;
};

export type PieceCollectionUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  handle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PieceCollectionsPage = {
  __typename?: 'PieceCollectionsPage';
  edges: Array<PieceCollectionEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PieceCreateInput = {
  anklet?: InputMaybe<AnkletInput>;
  bracelet?: InputMaybe<BraceletInput>;
  brandHandle: Scalars['String']['input'];
  brooch?: InputMaybe<BroochInput>;
  circumference?: InputMaybe<PieceSizeInput>;
  collectionHandle?: InputMaybe<Scalars['String']['input']>;
  cufflink?: InputMaybe<CufflinkInput>;
  curatorQuote?: InputMaybe<Scalars['String']['input']>;
  customLetteringMaxLength?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  designYear?: InputMaybe<Scalars['String']['input']>;
  designerHandle: Scalars['String']['input'];
  diameter?: InputMaybe<PieceSizeInput>;
  dropLength?: InputMaybe<PieceSizeInput>;
  earring?: InputMaybe<EarringInput>;
  engraving?: InputMaybe<Scalars['Boolean']['input']>;
  engravingMaxLength?: InputMaybe<Scalars['Float']['input']>;
  gemstones?: InputMaybe<Array<PieceGemstoneInput>>;
  gender?: InputMaybe<PieceGender>;
  hasCustomLettering?: InputMaybe<Scalars['Boolean']['input']>;
  isBespoke?: InputMaybe<Scalars['Boolean']['input']>;
  isHollow?: InputMaybe<Scalars['Boolean']['input']>;
  leadTime?: InputMaybe<TimeRangeInput>;
  length?: InputMaybe<PieceSizeInput>;
  margin?: InputMaybe<Scalars['Float']['input']>;
  marginBespoke?: InputMaybe<Scalars['Float']['input']>;
  metals?: InputMaybe<Array<PieceMetalInput>>;
  necklace?: InputMaybe<NecklaceInput>;
  oneOfAKind?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Array<PieceOptionInput>>;
  prices?: InputMaybe<Array<PiecePriceInput>>;
  productionYear?: InputMaybe<Scalars['String']['input']>;
  returnPeriodDays?: InputMaybe<Scalars['Float']['input']>;
  ring?: InputMaybe<RingInput>;
  sku: Scalars['String']['input'];
  sustainabilityLabels?: InputMaybe<Array<SustainabilityLabel>>;
  title: Scalars['String']['input'];
  tonality?: InputMaybe<Tonality>;
  type: PieceType;
  vintage?: InputMaybe<VintageInput>;
  warrantyDuration?: InputMaybe<Scalars['Float']['input']>;
  warrantyTerms?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<PieceSizeInput>;
};

export type PieceEdge = {
  __typename?: 'PieceEdge';
  cursor: Scalars['String']['output'];
  node: Piece;
};

export type PieceGemstone = Node & {
  __typename?: 'PieceGemstone';
  carat?: Maybe<Scalars['Float']['output']>;
  count?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  diamond?: Maybe<Diamond>;
  id: Scalars['ID']['output'];
  pearl?: Maybe<Pearl>;
  type?: Maybe<GemstoneType>;
};

export type PieceGemstoneInput = {
  carat?: InputMaybe<Scalars['Float']['input']>;
  count?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  diamond?: InputMaybe<DiamondInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  pearl?: InputMaybe<PearlInput>;
  type?: InputMaybe<GemstoneType>;
};

export enum PieceGender {
  Men = 'Men',
  Neutral = 'Neutral',
  Women = 'Women'
}

export type PieceImage = Node & {
  __typename?: 'PieceImage';
  altText: Scalars['String']['output'];
  gender: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image: Scalars['String']['output'];
  order: Scalars['Float']['output'];
  type: Scalars['String']['output'];
  uploadedBy: Scalars['String']['output'];
  url: Scalars['String']['output'];
};


export type PieceImageImageArgs = {
  ar?: InputMaybe<Scalars['Float']['input']>;
  auto?: InputMaybe<Array<ImgixAuto>>;
  crop?: InputMaybe<Array<ImgixCrop>>;
  fit?: InputMaybe<ImgixFit>;
  h?: InputMaybe<Scalars['Float']['input']>;
  maxH?: InputMaybe<Scalars['Float']['input']>;
  maxW?: InputMaybe<Scalars['Float']['input']>;
  minH?: InputMaybe<Scalars['Float']['input']>;
  minW?: InputMaybe<Scalars['Float']['input']>;
  q?: InputMaybe<Scalars['Float']['input']>;
  w?: InputMaybe<Scalars['Float']['input']>;
};

export type PieceMetal = Node & {
  __typename?: 'PieceMetal';
  baseMaterial?: Maybe<Material>;
  description?: Maybe<Scalars['String']['output']>;
  durability?: Maybe<Durability>;
  finish?: Maybe<Finish>;
  id: Scalars['ID']['output'];
  karat?: Maybe<Scalars['Float']['output']>;
  platingThickness?: Maybe<Scalars['Float']['output']>;
  primaryMaterial?: Maybe<Material>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type PieceMetalInput = {
  baseMaterial?: InputMaybe<Material>;
  description?: InputMaybe<Scalars['String']['input']>;
  durability?: InputMaybe<Durability>;
  finish?: InputMaybe<Finish>;
  id?: InputMaybe<Scalars['ID']['input']>;
  karat?: InputMaybe<Scalars['Float']['input']>;
  platingThickness?: InputMaybe<Scalars['Float']['input']>;
  primaryMaterial?: InputMaybe<Material>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type PieceOption = Node & {
  __typename?: 'PieceOption';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  values: Array<PieceOptionValue>;
};

export type PieceOptionInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<PieceOptionValueInput>>;
};

export type PieceOptionValue = Node & PiecePriceable & {
  __typename?: 'PieceOptionValue';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  option: PieceOption;
  prices: Array<PiecePrice>;
  skuSuffix?: Maybe<Scalars['String']['output']>;
};

export type PieceOptionValueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  skuSuffix?: InputMaybe<Scalars['String']['input']>;
};

export type PiecePrice = Node & {
  __typename?: 'PiecePrice';
  amount: Scalars['Float']['output'];
  currency: Currency;
  id: Scalars['ID']['output'];
  type: PriceType;
};

export type PiecePriceInput = {
  amount: Scalars['Float']['input'];
  currency: Currency;
  type: PriceType;
};

export type PiecePriceable = {
  prices: Array<PiecePrice>;
};

export type PieceSize = Node & {
  __typename?: 'PieceSize';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  option: Scalars['Boolean']['output'];
  requestable: Scalars['Boolean']['output'];
  unit: SizeUnit;
  values: Array<PieceSizeValue>;
  variable: Scalars['Boolean']['output'];
};

export type PieceSizeInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  option?: InputMaybe<Scalars['Boolean']['input']>;
  requestable?: InputMaybe<Scalars['Boolean']['input']>;
  unit?: InputMaybe<SizeUnit>;
  values?: InputMaybe<Array<PieceSizeValueInput>>;
  variable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PieceSizeValue = Node & PiecePriceable & {
  __typename?: 'PieceSizeValue';
  id: Scalars['ID']['output'];
  prices: Array<PiecePrice>;
  size: PieceSize;
  value: Scalars['String']['output'];
};

export type PieceSizeValueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum PieceStatus {
  Active = 'Active',
  Archived = 'Archived',
  Draft = 'Draft',
  Hidden = 'Hidden'
}

export enum PieceTags {
  AlternativeAndModern = 'AlternativeAndModern',
  Architectural = 'Architectural',
  ArtDeco = 'ArtDeco',
  Asymmetrical = 'Asymmetrical',
  AvantGarde = 'AvantGarde',
  Beaded = 'Beaded',
  Bohemian = 'Bohemian',
  BoldAndStatement = 'BoldAndStatement',
  Celestial = 'Celestial',
  Classic = 'Classic',
  Classical = 'Classical',
  Colourful = 'Colourful',
  Cross = 'Cross',
  DaintyAndDelicate = 'DaintyAndDelicate',
  Dark = 'Dark',
  DarkAndEdgy = 'DarkAndEdgy',
  Floral = 'Floral',
  Folk = 'Folk',
  FunAndPlayful = 'FunAndPlayful',
  HeartShaped = 'HeartShaped',
  Maximalist = 'Maximalist',
  Minimal = 'Minimal',
  NaturalAndOrganic = 'NaturalAndOrganic',
  OnTrend = 'OnTrend',
  Open = 'Open',
  Organic = 'Organic',
  Ornate = 'Ornate',
  Playful = 'Playful',
  Romantic = 'Romantic',
  Sculptural = 'Sculptural',
  SharpAndLinear = 'SharpAndLinear',
  SimpleAndEveryday = 'SimpleAndEveryday',
  SpecialAndLuxurious = 'SpecialAndLuxurious',
  Symbolic = 'Symbolic',
  Textural = 'Textural',
  Understated = 'Understated'
}

export enum PieceType {
  Anklet = 'Anklet',
  Bracelet = 'Bracelet',
  Brooch = 'Brooch',
  Cufflink = 'Cufflink',
  Earring = 'Earring',
  GiftCard = 'GiftCard',
  Necklace = 'Necklace',
  Ring = 'Ring',
  Service = 'Service'
}

export type PieceUpdateInput = {
  anklet?: InputMaybe<AnkletInput>;
  bracelet?: InputMaybe<BraceletInput>;
  brooch?: InputMaybe<BroochInput>;
  circumference?: InputMaybe<PieceSizeInput>;
  collectionHandle?: InputMaybe<Scalars['String']['input']>;
  cufflink?: InputMaybe<CufflinkInput>;
  curatorQuote?: InputMaybe<Scalars['String']['input']>;
  customLetteringMaxLength?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  designYear?: InputMaybe<Scalars['String']['input']>;
  diameter?: InputMaybe<PieceSizeInput>;
  dropLength?: InputMaybe<PieceSizeInput>;
  earring?: InputMaybe<EarringInput>;
  engraving?: InputMaybe<Scalars['Boolean']['input']>;
  engravingMaxLength?: InputMaybe<Scalars['Float']['input']>;
  gemstones?: InputMaybe<Array<PieceGemstoneInput>>;
  gender?: InputMaybe<PieceGender>;
  hasCustomLettering?: InputMaybe<Scalars['Boolean']['input']>;
  imagesNewOrder?: InputMaybe<Array<Scalars['String']['input']>>;
  isBespoke?: InputMaybe<Scalars['Boolean']['input']>;
  isHollow?: InputMaybe<Scalars['Boolean']['input']>;
  leadTime?: InputMaybe<TimeRangeInput>;
  length?: InputMaybe<PieceSizeInput>;
  margin?: InputMaybe<Scalars['Float']['input']>;
  marginBespoke?: InputMaybe<Scalars['Float']['input']>;
  metals?: InputMaybe<Array<PieceMetalInput>>;
  necklace?: InputMaybe<NecklaceInput>;
  oneOfAKind?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Array<PieceOptionInput>>;
  prices?: InputMaybe<Array<PiecePriceInput>>;
  productionYear?: InputMaybe<Scalars['String']['input']>;
  returnPeriodDays?: InputMaybe<Scalars['Float']['input']>;
  ring?: InputMaybe<RingInput>;
  sku?: InputMaybe<Scalars['String']['input']>;
  sustainabilityLabels?: InputMaybe<Array<SustainabilityLabel>>;
  tags?: InputMaybe<Array<PieceTags>>;
  title?: InputMaybe<Scalars['String']['input']>;
  tonality?: InputMaybe<Tonality>;
  type?: InputMaybe<PieceType>;
  vintage?: InputMaybe<VintageInput>;
  warrantyDuration?: InputMaybe<Scalars['Float']['input']>;
  warrantyTerms?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<PieceSizeInput>;
};

export type PieceVariant = Node & {
  __typename?: 'PieceVariant';
  id: Scalars['ID']['output'];
  localPrices?: Maybe<Array<PiecePrice>>;
  piece: Piece;
  prices?: Maybe<Array<PiecePrice>>;
  shopifyId?: Maybe<Scalars['String']['output']>;
  sku: Scalars['String']['output'];
  skuDefault: Scalars['String']['output'];
  skuOverride?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  variantSku: Scalars['String']['output'];
};

export type PieceVariantInput = {
  prices?: InputMaybe<Array<PiecePriceInput>>;
  skuOverride?: InputMaybe<Scalars['String']['input']>;
};

export type PiecesPage = {
  __typename?: 'PiecesPage';
  edges: Array<PieceEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PortalResponseModel = {
  __typename?: 'PortalResponseModel';
  portalUrl: Scalars['String']['output'];
};

export type Price = {
  __typename?: 'Price';
  amount: Scalars['Float']['output'];
  currency: Currency;
};

export enum PriceType {
  ExclVat = 'EXCL_VAT',
  InclVat = 'INCL_VAT'
}

export type Product = {
  __typename?: 'Product';
  designer?: Maybe<Designer>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ProductVariant = {
  __typename?: 'ProductVariant';
  id: Scalars['String']['output'];
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

export type ProductVariantModel = {
  __typename?: 'ProductVariantModel';
  price?: Maybe<Array<CurrencyAmount>>;
  shopifyId: Scalars['String']['output'];
};

export type PublicDesigner = Node & {
  __typename?: 'PublicDesigner';
  b2bPageUrl?: Maybe<Scalars['String']['output']>;
  bespoke?: Maybe<Scalars['Boolean']['output']>;
  comingSoon?: Maybe<Scalars['Boolean']['output']>;
  countryOfOrigin?: Maybe<Scalars['String']['output']>;
  curatorQuote?: Maybe<Scalars['String']['output']>;
  customisation?: Maybe<Scalars['Boolean']['output']>;
  deliveryZipcode?: Maybe<Scalars['String']['output']>;
  disabledCountries?: Maybe<Array<Country>>;
  email?: Maybe<Scalars['String']['output']>;
  featuredProduct?: Maybe<Piece>;
  handle: Scalars['String']['output'];
  headline?: Maybe<Scalars['String']['output']>;
  highlights?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  latitude?: Maybe<Scalars['String']['output']>;
  leadStatus?: Maybe<LeadStatus>;
  longitude?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  readyToOrder?: Maybe<Scalars['Boolean']['output']>;
  remodel?: Maybe<Scalars['Boolean']['output']>;
  repair?: Maybe<Scalars['Boolean']['output']>;
  selectedB2BServices?: Maybe<Scalars['String']['output']>;
  servicesTerms?: Maybe<ServicesTerms>;
  specialties?: Maybe<Array<Scalars['String']['output']>>;
  status: Status;
  storeAddress?: Maybe<Scalars['String']['output']>;
  storeGoogleMapsUrl?: Maybe<Scalars['String']['output']>;
  storeImageUrl?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<DesignerStyleTag>>;
  verifiedPartner?: Maybe<Scalars['Boolean']['output']>;
  videoHighlightDescription?: Maybe<Scalars['String']['output']>;
  videoHighlightUrl?: Maybe<Scalars['String']['output']>;
  workbenchImageUrl?: Maybe<Scalars['String']['output']>;
};

export type PublicRegisterDesignerArgs = {
  additionalEmailAddresses?: InputMaybe<Array<RegisterContact>>;
  billingAddress: AddressInput;
  designerName: Scalars['String']['input'];
  ein?: InputMaybe<Scalars['String']['input']>;
  emailAddress: Scalars['String']['input'];
  eori?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  shippingAddress: AddressInput;
  termsAndConditionsVersion: Scalars['String']['input'];
  userFirstName: Scalars['String']['input'];
  userLastName: Scalars['String']['input'];
  vat?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  __typename?: 'Query';
  activeWorkshops: Array<Workshop>;
  allReferralEntries: Array<CustomerReferralEntry>;
  alterationProduct: ProductVariantModel;
  availableSubscriptionPlans: SubscriptionPlansResponseModel;
  batch?: Maybe<Batch>;
  batchByBarcode?: Maybe<Batch>;
  batches: Array<Batch>;
  batchesByClient: Array<Batch>;
  batchesByServiceType: Array<Batch>;
  batchesByStatus: Array<Batch>;
  batchesByWorkshop: Array<Batch>;
  brand: Brand;
  brands: BrandsPage;
  currencyRates: Array<CurrencyRate>;
  currentSubscription?: Maybe<CurrentSubscriptionModel>;
  customerCredit: Array<Price>;
  customerCreditEntries: Array<CustomerCreditEntry>;
  customerCreditTotals: Array<Price>;
  customerGetOwnerSummary: CustomerSummaryWithProducts;
  customerGetOwners: CustomersListPage;
  customerGetProducts: CustomerProductsPayload;
  customerReferralEntries: Array<CustomerReferralEntry>;
  customersSearch: Array<CustomerSearchItem>;
  designer: Designer;
  designerBillingPortalUrl: PortalResponseModel;
  designerOrder: DesignerOrder;
  designerOrderHistory: Array<DesignerOrderHistory>;
  designerOrders: DesignerOrdersPage;
  designerOrdersByShopifyOrder: Array<DesignerOrder>;
  designerTask?: Maybe<DesignerTask>;
  designerTasksByDesignerId: Array<DesignerTask>;
  designerUsers: Array<DesignerUserModel>;
  designers: DesignersPage;
  discountsPerProduct?: Maybe<Array<Piece>>;
  favourites: Array<Favourite>;
  favouritesBoardByPublicId?: Maybe<FavouritesBoard>;
  favouritesBoards: Array<FavouritesBoard>;
  getB2bServices?: Maybe<Scalars['String']['output']>;
  getDates: Array<DesignerVacationDates>;
  ipShopData: IpShopData;
  lead: Designer;
  leads: DesignersPage;
  loginGoogleStart: GoogleAuthenticationStart;
  materialPrices: Array<MaterialPrice>;
  orderInvoice: Scalars['String']['output'];
  payout: Payout;
  payouts: PayoutsPage;
  photoshoot: Photoshoot;
  photoshoots: PhotoshootsPage;
  piece: Piece;
  pieceCollection: PieceCollection;
  pieceCollections: PieceCollectionsPage;
  pieceImages: Array<PieceImage>;
  pieceVariants: Array<PieceVariant>;
  pieces: PiecesPage;
  piecesPublic: PiecesPage;
  piecesSummary: Array<Piece>;
  piecesToQA: Array<Piece>;
  productVariantEstimatedDeliveryTime: Scalars['DateTime']['output'];
  productVariants: Array<ProductVariant>;
  publicAppraiseMaterialValue: Appraisal;
  publicBespokeDesigners: Array<PublicDesigner>;
  publicCustomerCredit: Array<Price>;
  publicDesigner: PublicDesigner;
  publicDesignerById: PublicDesigner;
  publicDesigners: Array<PublicDesigner>;
  publicIsCustomerReferralValid: Scalars['Boolean']['output'];
  publicListCustomerReferralEntry: Array<CustomerReferralEntry>;
  publicMaterialPrice: MaterialPrice;
  publicRemodelDesigners: Array<PublicDesigner>;
  searchCombined: SearchResultsPage;
  serviceOrderItem?: Maybe<ServiceOrderItem>;
  serviceOrderItems: Array<ServiceOrderItem>;
  serviceOrderItemsByBatch: Array<ServiceOrderItem>;
  serviceOrderItemsByOrder: Array<ServiceOrderItem>;
  serviceOrderItemsByServiceType: Array<ServiceOrderItem>;
  serviceOrderItemsByWorkshopJob: Array<ServiceOrderItem>;
  serviceOrderWithItems?: Maybe<ServiceOrder>;
  serviceOrders: ServiceOrdersPage;
  serviceOrdersWithItems: ServiceOrdersPage;
  shipments: ShipmentPage;
  subscriptionHistory: Array<SubscriptionHistoryModel>;
  user: User;
  userCurrent: User;
  users: UsersPage;
  workshop?: Maybe<Workshop>;
  workshopJob?: Maybe<WorkshopJob>;
  workshopJobByBarcode?: Maybe<WorkshopJob>;
  workshopJobs: Array<WorkshopJob>;
  workshopJobsByServiceType: Array<WorkshopJob>;
  workshopJobsByStatus: Array<WorkshopJob>;
  workshopJobsByWorkshop: Array<WorkshopJob>;
  workshops: Array<Workshop>;
  workshopsByEnterpriseClient: Array<Workshop>;
  workshopsByServiceType: Array<Workshop>;
};


export type QueryAlterationProductArgs = {
  input: PieceAlterationProductInput;
};


export type QueryAvailableSubscriptionPlansArgs = {
  currency?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBatchArgs = {
  id: Scalars['String']['input'];
};


export type QueryBatchByBarcodeArgs = {
  barcode: Scalars['String']['input'];
};


export type QueryBatchesByClientArgs = {
  clientId: Scalars['String']['input'];
};


export type QueryBatchesByServiceTypeArgs = {
  serviceType: ServiceOrderType;
};


export type QueryBatchesByStatusArgs = {
  status: BatchStatus;
};


export type QueryBatchesByWorkshopArgs = {
  workshopId: Scalars['String']['input'];
};


export type QueryBrandArgs = {
  handle: Scalars['String']['input'];
};


export type QueryBrandsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  designerHandle?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCurrentSubscriptionArgs = {
  designerId: Scalars['ID']['input'];
};


export type QueryCustomerCreditArgs = {
  shopifyCustomerId: Scalars['String']['input'];
};


export type QueryCustomerCreditEntriesArgs = {
  shopifyCustomerId: Scalars['String']['input'];
};


export type QueryCustomerGetOwnerSummaryArgs = {
  id: Scalars['String']['input'];
};


export type QueryCustomerGetOwnersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCustomerGetProductsArgs = {
  customerAccessToken: Scalars['String']['input'];
};


export type QueryCustomerReferralEntriesArgs = {
  shopifyCustomerId: Scalars['String']['input'];
};


export type QueryCustomersSearchArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDesignerArgs = {
  handle: Scalars['String']['input'];
};


export type QueryDesignerBillingPortalUrlArgs = {
  designerId: Scalars['ID']['input'];
  returnUrl: Scalars['String']['input'];
};


export type QueryDesignerOrderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDesignerOrderHistoryArgs = {
  id: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};


export type QueryDesignerOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  designerHandle?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeClosed?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDesignerOrdersByShopifyOrderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDesignerTaskArgs = {
  id: Scalars['String']['input'];
};


export type QueryDesignerTasksByDesignerIdArgs = {
  designerId: Scalars['String']['input'];
};


export type QueryDesignerUsersArgs = {
  designerHandle: Scalars['String']['input'];
};


export type QueryDesignersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDiscountsPerProductArgs = {
  productHandles: Array<Scalars['String']['input']>;
  targetCodes: Array<Scalars['String']['input']>;
};


export type QueryFavouritesArgs = {
  userId: Scalars['String']['input'];
};


export type QueryFavouritesBoardByPublicIdArgs = {
  publicId: Scalars['String']['input'];
};


export type QueryFavouritesBoardsArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetDatesArgs = {
  handle: Scalars['String']['input'];
};


export type QueryLeadArgs = {
  handle: Scalars['String']['input'];
};


export type QueryLeadsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LeadOrderByInput>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<LeadStatus>>;
};


export type QueryOrderInvoiceArgs = {
  input: OrderInvoiceInput;
};


export type QueryPayoutArgs = {
  convertToDesignerCurrency?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type QueryPayoutsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  convertToDesignerCurrency?: InputMaybe<Scalars['Boolean']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  designerCurrencies?: InputMaybe<Array<Currency>>;
  designerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PayoutOrderByInput>;
  sort?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<PayoutStatus>>;
};


export type QueryPhotoshootArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPhotoshootsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PhotoshootOrderByInput>;
  sort?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<PhotoshootStatus>>;
};


export type QueryPieceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPieceCollectionArgs = {
  handle: Scalars['String']['input'];
};


export type QueryPieceCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  brandHandle: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPieceImagesArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPieceVariantsArgs = {
  pieceId: Scalars['ID']['input'];
};


export type QueryPiecesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  designerHandle?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPiecesPublicArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  pieceHandles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryPiecesSummaryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  designerHandle?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProductVariantEstimatedDeliveryTimeArgs = {
  id: Scalars['ID']['input'];
  isEngraved?: Scalars['Boolean']['input'];
};


export type QueryProductVariantsArgs = {
  productIds: Array<Scalars['ID']['input']>;
};


export type QueryPublicAppraiseMaterialValueArgs = {
  materialType: MaterialType;
  weightInGrams: Scalars['Float']['input'];
};


export type QueryPublicCustomerCreditArgs = {
  customerAccessToken: Scalars['String']['input'];
};


export type QueryPublicDesignerArgs = {
  handle: Scalars['String']['input'];
};


export type QueryPublicDesignerByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryPublicIsCustomerReferralValidArgs = {
  id: Scalars['String']['input'];
};


export type QueryPublicListCustomerReferralEntryArgs = {
  customerAccessToken: Scalars['String']['input'];
};


export type QueryPublicMaterialPriceArgs = {
  currency: Currency;
  materialType: MaterialType;
};


export type QuerySearchCombinedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  query: Scalars['String']['input'];
};


export type QueryServiceOrderItemArgs = {
  id: Scalars['String']['input'];
};


export type QueryServiceOrderItemsByBatchArgs = {
  batchId: Scalars['String']['input'];
};


export type QueryServiceOrderItemsByOrderArgs = {
  orderId: Scalars['String']['input'];
};


export type QueryServiceOrderItemsByServiceTypeArgs = {
  serviceType: ServiceOrderType;
};


export type QueryServiceOrderItemsByWorkshopJobArgs = {
  workshopJobId: Scalars['String']['input'];
};


export type QueryServiceOrderWithItemsArgs = {
  id: Scalars['String']['input'];
};


export type QueryServiceOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  countries?: InputMaybe<Array<Country>>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  enterpriseClientId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  includeReturned?: InputMaybe<Scalars['Boolean']['input']>;
  includeUnpaid?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ServiceOrderOrderByInput>;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  services?: InputMaybe<Array<ServiceOrderType>>;
  sort?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<ServiceOrderStatus>>;
  workshopId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryServiceOrdersWithItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  countries?: InputMaybe<Array<Country>>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  enterpriseClientId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  includeReturned?: InputMaybe<Scalars['Boolean']['input']>;
  includeUnpaid?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ServiceOrderOrderByInput>;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  services?: InputMaybe<Array<ServiceOrderType>>;
  sort?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<ServiceOrderStatus>>;
  workshopId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryShipmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySubscriptionHistoryArgs = {
  designerId: Scalars['ID']['input'];
};


export type QueryUserArgs = {
  id: Scalars['String']['input'];
};


export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryWorkshopArgs = {
  id: Scalars['String']['input'];
};


export type QueryWorkshopJobArgs = {
  id: Scalars['String']['input'];
};


export type QueryWorkshopJobByBarcodeArgs = {
  barcode: Scalars['String']['input'];
};


export type QueryWorkshopJobsByServiceTypeArgs = {
  serviceType: ServiceOrderType;
};


export type QueryWorkshopJobsByStatusArgs = {
  status: WorkshopJobStatus;
};


export type QueryWorkshopJobsByWorkshopArgs = {
  workshopId: Scalars['String']['input'];
};


export type QueryWorkshopsByEnterpriseClientArgs = {
  clientId: Scalars['String']['input'];
};


export type QueryWorkshopsByServiceTypeArgs = {
  serviceType: ServiceOrderType;
};

export enum RecycleMetal {
  KaratGold9 = 'KaratGold9',
  KaratGold10 = 'KaratGold10',
  KaratGold14 = 'KaratGold14',
  KaratGold18 = 'KaratGold18',
  KaratGold22 = 'KaratGold22',
  KaratGold24 = 'KaratGold24',
  Mixture = 'Mixture',
  Other = 'Other',
  SterlingSilver = 'SterlingSilver'
}

export enum ReferralStatus {
  Accepted = 'Accepted',
  Pending = 'Pending'
}

export enum RefreshType {
  Refresh = 'Refresh'
}

export enum Region {
  En = 'EN',
  EnAu = 'EN_AU',
  EnCa = 'EN_CA',
  EnCh = 'EN_CH',
  EnDk = 'EN_DK',
  EnGb = 'EN_GB',
  EnHk = 'EN_HK',
  EnJp = 'EN_JP',
  EnMx = 'EN_MX',
  EnPl = 'EN_PL',
  EnQa = 'EN_QA',
  EnSg = 'EN_SG',
  EnUs = 'EN_US'
}

export type RegisterContact = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

export type RemoteFile = {
  __typename?: 'RemoteFile';
  uri: Scalars['String']['output'];
};

export enum RepairMetal {
  GoldPlatedBronze = 'GoldPlatedBronze',
  GoldPlatedSilver = 'GoldPlatedSilver',
  SolidGold = 'SolidGold',
  SterlingSilver = 'SterlingSilver',
  Unknown = 'Unknown'
}

export enum RepairType {
  BangleOrCuffReshape = 'BangleOrCuffReshape',
  BeadOrPearlRestring = 'BeadOrPearlRestring',
  ChainRepair = 'ChainRepair',
  ChainRepair1 = 'ChainRepair1',
  ClaspRepairOrReplace = 'ClaspRepairOrReplace',
  ClaspRepairOrReplace2 = 'ClaspRepairOrReplace2',
  EarringPostRepair = 'EarringPostRepair',
  EarringPostRepairOrReplace = 'EarringPostRepairOrReplace',
  GemstoneReplacementResetOnly = 'GemstoneReplacementResetOnly',
  GemstoneReplacementSupplyAndSet = 'GemstoneReplacementSupplyAndSet',
  GemstoneReplacementSupplyAndSet1 = 'GemstoneReplacementSupplyAndSet1',
  RingClawOrProngReTip = 'RingClawOrProngReTip',
  RingReShape = 'RingReShape',
  RingShankRepair = 'RingShankRepair',
  StoneReplacementResetOnlyByGlue = 'StoneReplacementResetOnlyByGlue',
  StoneReplacementResetOnlyBySolder = 'StoneReplacementResetOnlyBySolder',
  StoneReplacementSupplyAndResetByGlue = 'StoneReplacementSupplyAndResetByGlue',
  StoneReplacementSupplyAndResetBySolder = 'StoneReplacementSupplyAndResetBySolder',
  ReWire = 'reWire'
}

export enum ReplateMetal {
  GoldPlatedBronze = 'GoldPlatedBronze',
  GoldPlatedSilver = 'GoldPlatedSilver',
  Other = 'Other',
  SolidGold = 'SolidGold',
  SterlingSilver = 'SterlingSilver',
  Unknown = 'Unknown'
}

export enum ResizeMetal {
  GoldPlatedBronze = 'GoldPlatedBronze',
  GoldPlatedSilver = 'GoldPlatedSilver',
  Other = 'Other',
  SolidGold = 'SolidGold',
  SterlingSilver = 'SterlingSilver',
  Unknown = 'Unknown'
}

export enum ResizeType {
  BraceletOrNecklaceLengthIncrease = 'BraceletOrNecklaceLengthIncrease',
  BraceletOrNecklaceLengthReduction = 'BraceletOrNecklaceLengthReduction',
  RingResize = 'RingResize'
}

export type Ring = {
  __typename?: 'Ring';
  category?: Maybe<RingCategory>;
};

export enum RingCategory {
  Band = 'Band',
  Chain = 'Chain',
  Cocktail = 'Cocktail',
  Engagement = 'Engagement',
  FullEternity = 'FullEternity',
  HalfEternity = 'HalfEternity',
  Signet = 'Signet',
  Stackable = 'Stackable',
  Statement = 'Statement',
  Wedding = 'Wedding'
}

export type RingInput = {
  category?: InputMaybe<RingCategory>;
};

export type SearchResult = {
  __typename?: 'SearchResult';
  handle?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  type: SearchResultType;
};

export type SearchResultEdge = {
  __typename?: 'SearchResultEdge';
  cursor: Scalars['String']['output'];
  node: SearchResult;
};

export enum SearchResultType {
  Brand = 'Brand',
  Designer = 'Designer',
  DesignerOrder = 'DesignerOrder',
  Piece = 'Piece'
}

export type SearchResultsPage = {
  __typename?: 'SearchResultsPage';
  edges: Array<SearchResultEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ServiceOrder = {
  __typename?: 'ServiceOrder';
  address1?: Maybe<Scalars['String']['output']>;
  approximateValue?: Maybe<ApproximateValue>;
  attributes?: Maybe<ServiceOrderAttributeModel>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  exchangeDesigner?: Maybe<Scalars['String']['output']>;
  exchangeMetal?: Maybe<ExchangeMetal>;
  exchangeWeight?: Maybe<Scalars['Float']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  inboundShipment?: Maybe<Shipment>;
  items: Array<ServiceOrderItem>;
  jewelleryType?: Maybe<JewelleryType>;
  lastName: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  orderPage?: Maybe<Scalars['String']['output']>;
  orderReference?: Maybe<Scalars['String']['output']>;
  outboundShipment?: Maybe<Shipment>;
  recycleMetal?: Maybe<RecycleMetal>;
  recycleWeight?: Maybe<Scalars['Float']['output']>;
  refreshType?: Maybe<RefreshType>;
  repairJewelleryType?: Maybe<JewelleryType>;
  repairMetal?: Maybe<RepairMetal>;
  repairType?: Maybe<RepairType>;
  replateKarat?: Maybe<Scalars['String']['output']>;
  replateMetal?: Maybe<ReplateMetal>;
  replateNumberOfPieces?: Maybe<Scalars['Int']['output']>;
  replatePlatingThickness?: Maybe<Scalars['Float']['output']>;
  resizeMetal?: Maybe<ResizeMetal>;
  resizeNewSize?: Maybe<Scalars['String']['output']>;
  resizeOtherMetal?: Maybe<Scalars['String']['output']>;
  resizeType?: Maybe<ResizeType>;
  service?: Maybe<ServiceOrderType>;
  serviceOrderAttributes: Array<ServiceOrderAttributeModel>;
  serviceOrderHistory: Array<ServiceOrderHistory>;
  status: ServiceOrderStatus;
  statusUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  totalItems: Scalars['Float']['output'];
  userSource?: Maybe<UserSource>;
  zip?: Maybe<Scalars['String']['output']>;
};

export enum ServiceOrderAttributeKey {
  BespokeBudget = 'BespokeBudget',
  BespokeInspirationDesigners = 'BespokeInspirationDesigners',
  BespokeInspirationImage = 'BespokeInspirationImage',
  BespokeJewelleryType = 'BespokeJewelleryType',
  BespokeOriginalPieceDescription = 'BespokeOriginalPieceDescription',
  BespokeOriginalPieceImage = 'BespokeOriginalPieceImage',
  ExchangeDesigner = 'ExchangeDesigner',
  ExchangeMetal = 'ExchangeMetal',
  ExchangeWeight = 'ExchangeWeight',
  RecycleMetal = 'RecycleMetal',
  RecycleWeight = 'RecycleWeight',
  RefreshType = 'RefreshType',
  RepairJewelleryType = 'RepairJewelleryType',
  RepairMetal = 'RepairMetal',
  RepairType = 'RepairType',
  ReplateKarat = 'ReplateKarat',
  ReplateNumberOfPieces = 'ReplateNumberOfPieces',
  ReplatePlatingThickness = 'ReplatePlatingThickness',
  ResizeMetal = 'ResizeMetal',
  ResizeNewSize = 'ResizeNewSize',
  ResizeOtherMetal = 'ResizeOtherMetal',
  ResizeType = 'ResizeType'
}

export type ServiceOrderAttributeModel = {
  __typename?: 'ServiceOrderAttributeModel';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  key: ServiceOrderAttributeKey;
  value: Scalars['String']['output'];
};

export type ServiceOrderBespoke = {
  __typename?: 'ServiceOrderBespoke';
  address1?: Maybe<Scalars['String']['output']>;
  attributes?: Maybe<ServiceOrderAttributeModel>;
  budget: Scalars['String']['output'];
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  inboundShipment?: Maybe<Shipment>;
  inspirationDesigners: Array<Scalars['String']['output']>;
  inspirationImagesUrls: Array<Scalars['String']['output']>;
  jewelleryType: JewelleryType;
  lastName: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  orderReference?: Maybe<Scalars['String']['output']>;
  originalPieceDescription?: Maybe<Scalars['String']['output']>;
  originalPieceImagesUrls?: Maybe<Array<Scalars['String']['output']>>;
  outboundShipment?: Maybe<Shipment>;
  service?: Maybe<ServiceOrderType>;
  serviceOrderHistory?: Maybe<Array<ServiceOrderHistory>>;
  status: ServiceOrderStatus;
  statusUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  userSource?: Maybe<UserSource>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type ServiceOrderCreateInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  approximateValue?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  exchangeDesigner?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  image?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isLocationUnsupported?: InputMaybe<Scalars['Boolean']['input']>;
  jewelleryDescription?: InputMaybe<Scalars['String']['input']>;
  jewelleryType?: InputMaybe<Scalars['String']['input']>;
  karat?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  metal?: InputMaybe<Scalars['String']['input']>;
  newSize?: InputMaybe<Scalars['String']['input']>;
  numberOfPieces?: InputMaybe<Scalars['String']['input']>;
  orderPage?: InputMaybe<Scalars['String']['input']>;
  otherMetal?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  platingThickness?: InputMaybe<Scalars['String']['input']>;
  refreshNumberOfPieces?: InputMaybe<Scalars['Float']['input']>;
  refreshType?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  repairType?: InputMaybe<Scalars['String']['input']>;
  resizeType?: InputMaybe<Scalars['String']['input']>;
  restoreType?: InputMaybe<Scalars['String']['input']>;
  service?: InputMaybe<Scalars['String']['input']>;
  userSource?: InputMaybe<UserSource>;
  weight?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type ServiceOrderCreateShipmentInput = {
  direction: ShipmentDirection;
  serviceOrderId: Scalars['String']['input'];
};

export type ServiceOrderEdge = {
  __typename?: 'ServiceOrderEdge';
  cursor: Scalars['String']['output'];
  node: ServiceOrder;
};

export type ServiceOrderHistory = {
  __typename?: 'ServiceOrderHistory';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  status: ServiceOrderStatus;
};

export type ServiceOrderItem = {
  __typename?: 'ServiceOrderItem';
  approximateValue?: Maybe<ApproximateValue>;
  batch?: Maybe<Batch>;
  batchId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  exchangeDesigner?: Maybe<Scalars['String']['output']>;
  exchangeMetal?: Maybe<ExchangeMetal>;
  exchangeWeight?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  image?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  orderId: Scalars['String']['output'];
  recycleMetal?: Maybe<RecycleMetal>;
  recycleWeight?: Maybe<Scalars['Float']['output']>;
  refreshType?: Maybe<RefreshType>;
  repairJewelleryType?: Maybe<JewelleryType>;
  repairMetal?: Maybe<RepairMetal>;
  repairType?: Maybe<RepairType>;
  replateKarat?: Maybe<Scalars['String']['output']>;
  replateMetal?: Maybe<ReplateMetal>;
  replateNumberOfPieces?: Maybe<Scalars['Float']['output']>;
  replatePlatingThickness?: Maybe<Scalars['Float']['output']>;
  resizeMetal?: Maybe<ResizeMetal>;
  resizeNewSize?: Maybe<Scalars['String']['output']>;
  resizeOtherMetal?: Maybe<Scalars['String']['output']>;
  resizeType?: Maybe<ResizeType>;
  service?: Maybe<ServiceOrderType>;
  updatedAt: Scalars['DateTime']['output'];
  workshopJob?: Maybe<WorkshopJob>;
  workshopJobId?: Maybe<Scalars['String']['output']>;
};

export type ServiceOrderItemCreateInput = {
  approximateValue?: InputMaybe<ApproximateValue>;
  batchId?: InputMaybe<Scalars['String']['input']>;
  exchangeDesigner?: InputMaybe<Scalars['String']['input']>;
  exchangeMetal?: InputMaybe<ExchangeMetal>;
  exchangeWeight?: InputMaybe<Scalars['Float']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  recycleMetal?: InputMaybe<RecycleMetal>;
  recycleWeight?: InputMaybe<Scalars['Float']['input']>;
  refreshType?: InputMaybe<RefreshType>;
  repairJewelleryType?: InputMaybe<JewelleryType>;
  repairMetal?: InputMaybe<RepairMetal>;
  repairType?: InputMaybe<RepairType>;
  replateKarat?: InputMaybe<Scalars['String']['input']>;
  replateMetal?: InputMaybe<ReplateMetal>;
  replateNumberOfPieces?: InputMaybe<Scalars['Float']['input']>;
  replatePlatingThickness?: InputMaybe<Scalars['Float']['input']>;
  resizeMetal?: InputMaybe<ResizeMetal>;
  resizeNewSize?: InputMaybe<Scalars['String']['input']>;
  resizeOtherMetal?: InputMaybe<Scalars['String']['input']>;
  resizeType?: InputMaybe<ResizeType>;
  service: ServiceOrderType;
  workshopJobId?: InputMaybe<Scalars['String']['input']>;
};

export type ServiceOrderItemUpdateInput = {
  approximateValue?: InputMaybe<ApproximateValue>;
  batchId?: InputMaybe<Scalars['String']['input']>;
  exchangeDesigner?: InputMaybe<Scalars['String']['input']>;
  exchangeMetal?: InputMaybe<ExchangeMetal>;
  exchangeWeight?: InputMaybe<Scalars['Float']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  recycleMetal?: InputMaybe<RecycleMetal>;
  recycleWeight?: InputMaybe<Scalars['Float']['input']>;
  refreshType?: InputMaybe<RefreshType>;
  repairJewelleryType?: InputMaybe<JewelleryType>;
  repairMetal?: InputMaybe<RepairMetal>;
  repairType?: InputMaybe<RepairType>;
  replateKarat?: InputMaybe<Scalars['String']['input']>;
  replateMetal?: InputMaybe<ReplateMetal>;
  replatePlatingThickness?: InputMaybe<Scalars['Float']['input']>;
  resizeMetal?: InputMaybe<ResizeMetal>;
  resizeNewSize?: InputMaybe<Scalars['String']['input']>;
  resizeOtherMetal?: InputMaybe<Scalars['String']['input']>;
  resizeType?: InputMaybe<ResizeType>;
  service?: InputMaybe<ServiceOrderType>;
  workshopJobId?: InputMaybe<Scalars['String']['input']>;
};

export enum ServiceOrderOrderByInput {
  CreatedAt = 'createdAt',
  Id = 'id',
  Service = 'service',
  Status = 'status'
}

export enum ServiceOrderStatus {
  Cancelled = 'Cancelled',
  CustomerConsultation = 'CustomerConsultation',
  DeposityPaid = 'DeposityPaid',
  DesignerContacted = 'DesignerContacted',
  LabelSent = 'LabelSent',
  New = 'New',
  PackagingSent = 'PackagingSent',
  PaidInFull = 'PaidInFull',
  PieceReceived = 'PieceReceived',
  ProductionComplete = 'ProductionComplete',
  ProductionStarted = 'ProductionStarted',
  ReturnedToCustomer = 'ReturnedToCustomer',
  SentToCustomer = 'SentToCustomer',
  Unpaid = 'Unpaid'
}

export enum ServiceOrderType {
  Bespoke = 'Bespoke',
  Exchange = 'Exchange',
  Recycle = 'Recycle',
  Refresh = 'Refresh',
  Remodel = 'Remodel',
  Repair = 'Repair',
  Replate = 'Replate',
  Resize = 'Resize'
}

export type ServiceOrdersPage = {
  __typename?: 'ServiceOrdersPage';
  edges: Array<ServiceOrderEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ServicesLeadTime = {
  __typename?: 'ServicesLeadTime';
  from?: Maybe<Scalars['Float']['output']>;
  to?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

export type ServicesTerms = {
  __typename?: 'ServicesTerms';
  availableForInPersonConsultations?: Maybe<Scalars['Boolean']['output']>;
  availableForVirtualConsultations?: Maybe<Scalars['Boolean']['output']>;
  iterationRounds?: Maybe<Scalars['Float']['output']>;
  paymentTerms?: Maybe<Scalars['String']['output']>;
  recyclesGoldForReuse?: Maybe<Scalars['Boolean']['output']>;
  servicesLeadTime?: Maybe<ServicesLeadTime>;
  startingBudget?: Maybe<Scalars['Float']['output']>;
  worksWithHeirloomGemstones?: Maybe<Scalars['Boolean']['output']>;
};

export type ServicesTermsInput = {
  availableForInPersonConsultations?: InputMaybe<Scalars['Boolean']['input']>;
  availableForVirtualConsultations?: InputMaybe<Scalars['Boolean']['input']>;
  iterationRounds?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms?: InputMaybe<Scalars['String']['input']>;
  recyclesGoldForReuse?: InputMaybe<Scalars['Boolean']['input']>;
  servicesLeadTime?: InputMaybe<ServicesLeadTimeInput>;
  startingBudget?: InputMaybe<Scalars['Float']['input']>;
  worksWithHeirloomGemstones?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Shipment = Node & {
  __typename?: 'Shipment';
  courier: Scalars['String']['output'];
  courierTrackingNumber: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  invoice: Scalars['String']['output'];
  label: Scalars['String']['output'];
  providerName: Scalars['String']['output'];
  reference: Scalars['String']['output'];
  shipmentLines: Array<ShipmentLine>;
  shipmentReference: Scalars['String']['output'];
  status: Scalars['String']['output'];
  trackingNumber: Scalars['String']['output'];
  trackingUrl: Scalars['String']['output'];
};

export enum ShipmentDirection {
  Inbound = 'inbound',
  Outbound = 'outbound'
}

export type ShipmentEdge = {
  __typename?: 'ShipmentEdge';
  cursor: Scalars['String']['output'];
  node: Shipment;
};

export type ShipmentLine = Node & {
  __typename?: 'ShipmentLine';
  id: Scalars['ID']['output'];
  piece: Piece;
  quantity: Scalars['Int']['output'];
};

export type ShipmentPage = {
  __typename?: 'ShipmentPage';
  edges: Array<ShipmentEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum ShippingRegions {
  Asia = 'Asia',
  CentralEurope = 'CentralEurope',
  EastCoastAmerica = 'EastCoastAmerica',
  Uk = 'UK',
  WestCoastAmerica = 'WestCoastAmerica'
}

export enum SizeUnit {
  Cm = 'CM',
  Inches = 'Inches',
  Mm = 'MM',
  Relative = 'Relative',
  RingUk = 'RingUK',
  RingUs = 'RingUS',
  Um = 'UM'
}

export enum Status {
  Active = 'Active',
  Deleted = 'Deleted',
  Draft = 'Draft',
  Inactive = 'Inactive',
  Pending = 'Pending'
}

export type SubscriptionHistoryModel = {
  __typename?: 'SubscriptionHistoryModel';
  canceledAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currentPeriodEnd?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  productName: Scalars['String']['output'];
  status: Scalars['String']['output'];
  tier: Scalars['String']['output'];
};

export type SubscriptionPlanModel = {
  __typename?: 'SubscriptionPlanModel';
  amount: Scalars['Float']['output'];
  configureMarkets: Scalars['Boolean']['output'];
  currency: Scalars['String']['output'];
  interval: Scalars['String']['output'];
  margin: Scalars['Float']['output'];
  marginBespoke?: Maybe<Scalars['Float']['output']>;
  priceId: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  tier: Scalars['String']['output'];
};

export type SubscriptionPlansResponseModel = {
  __typename?: 'SubscriptionPlansResponseModel';
  monthly: Array<SubscriptionPlanModel>;
  yearly: Array<SubscriptionPlanModel>;
};

export enum SustainabilityLabel {
  GemstonesFairmined = 'GemstonesFairmined',
  GemstonesLabgrown = 'GemstonesLabgrown',
  GoldFairmined = 'GoldFairmined',
  GoldRecycled = 'GoldRecycled',
  MaterialProvenance = 'MaterialProvenance',
  ReclaimedDiamonds = 'ReclaimedDiamonds',
  SilverRecycled = 'SilverRecycled',
  StudioCrafted = 'StudioCrafted',
  StudioStandards = 'StudioStandards'
}

export type SyncOrder = {
  __typename?: 'SyncOrder';
  item?: Maybe<SyncedOrder>;
};

export type SyncOrders = {
  __typename?: 'SyncOrders';
  items?: Maybe<Array<SyncedOrder>>;
};

export type SyncProducts = {
  __typename?: 'SyncProducts';
  items?: Maybe<Array<SyncedPiece>>;
};

export type SyncedOrder = {
  __typename?: 'SyncedOrder';
  id?: Maybe<Scalars['String']['output']>;
};

export type SyncedPiece = {
  __typename?: 'SyncedPiece';
  handle?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
};

export type TimeRange = {
  __typename?: 'TimeRange';
  unit: TimeUnit;
  value: Scalars['String']['output'];
};

export type TimeRangeInput = {
  unit: TimeUnit;
  value: Scalars['String']['input'];
};

export enum TimeUnit {
  Days = 'Days',
  Weeks = 'Weeks'
}

export enum Tonality {
  Black = 'Black',
  Blue = 'Blue',
  Brown = 'Brown',
  Green = 'Green',
  Grey = 'Grey',
  Multi = 'Multi',
  Orange = 'Orange',
  Pink = 'Pink',
  Purple = 'Purple',
  Red = 'Red',
  White = 'White',
  Yellow = 'Yellow'
}

export type User = Node & {
  __typename?: 'User';
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  designerUsers: Array<DesignerUserModel>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  requestedActivationAt?: Maybe<Scalars['DateTime']['output']>;
  role: UserRole;
};

export type UserCreateInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<UserRole>;
};

export type UserEdge = {
  __typename?: 'UserEdge';
  cursor: Scalars['String']['output'];
  node: User;
};

export type UserError = {
  __typename?: 'UserError';
  field?: Maybe<Array<Scalars['String']['output']>>;
  message: Scalars['String']['output'];
};

export enum UserRole {
  Admin = 'Admin',
  DataEntry = 'DataEntry',
  Finance = 'Finance',
  Regular = 'Regular',
  ServiceOrderAu = 'ServiceOrderAU',
  ServiceOrderEu = 'ServiceOrderEU',
  ServiceOrderUk = 'ServiceOrderUK',
  ServiceOrderUs = 'ServiceOrderUS'
}

export enum UserSource {
  FmWebsite = 'FMWebsite',
  Google = 'Google',
  Instagram = 'Instagram',
  Other = 'Other',
  Press = 'Press',
  WordOfMouth = 'WordOfMouth'
}

export type UserUpdateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<UserRole>;
};

export type UsersPage = {
  __typename?: 'UsersPage';
  edges: Array<UserEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type VacationDatesInput = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Vintage = {
  __typename?: 'Vintage';
  authenticity?: Maybe<Authenticity>;
  condition?: Maybe<Condition>;
  isVintage?: Maybe<Scalars['Boolean']['output']>;
  originalBox?: Maybe<Scalars['Boolean']['output']>;
  warranty?: Maybe<Scalars['String']['output']>;
};

export type VintageInput = {
  authenticity?: InputMaybe<AuthenticityInput>;
  condition?: InputMaybe<ConditionInput>;
  isVintage?: InputMaybe<Scalars['Boolean']['input']>;
  originalBox?: InputMaybe<Scalars['Boolean']['input']>;
  warranty?: InputMaybe<Scalars['String']['input']>;
};

export type Workshop = {
  __typename?: 'Workshop';
  active: Scalars['Boolean']['output'];
  barcodePrefix?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  enterpriseClientId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  location?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  servicesOffered?: Maybe<Array<ServiceOrderType>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type WorkshopCreateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  barcodePrefix?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  enterpriseClientId?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  servicesOffered?: InputMaybe<Array<ServiceOrderType>>;
};

export type WorkshopJob = {
  __typename?: 'WorkshopJob';
  barcode?: Maybe<Scalars['String']['output']>;
  barcodeSource?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  items?: Maybe<Array<ServiceOrderItem>>;
  jobGroupReference?: Maybe<Scalars['String']['output']>;
  serviceType: ServiceOrderType;
  status: WorkshopJobStatus;
  totalItems: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  workshop?: Maybe<Workshop>;
  workshopId?: Maybe<Scalars['String']['output']>;
};

export type WorkshopJobCreateInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  barcodeSource?: InputMaybe<Scalars['String']['input']>;
  jobGroupReference?: InputMaybe<Scalars['String']['input']>;
  serviceType: ServiceOrderType;
  status?: InputMaybe<WorkshopJobStatus>;
  totalItems?: InputMaybe<Scalars['Float']['input']>;
  workshopId?: InputMaybe<Scalars['String']['input']>;
};

export enum WorkshopJobStatus {
  Completed = 'Completed',
  InProgress = 'InProgress',
  Pending = 'Pending',
  Shipped = 'Shipped'
}

export type WorkshopJobUpdateInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  barcodeSource?: InputMaybe<Scalars['String']['input']>;
  jobGroupReference?: InputMaybe<Scalars['String']['input']>;
  serviceType?: InputMaybe<ServiceOrderType>;
  status?: InputMaybe<WorkshopJobStatus>;
  totalItems?: InputMaybe<Scalars['Float']['input']>;
  workshopId?: InputMaybe<Scalars['String']['input']>;
};

export type WorkshopUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  barcodePrefix?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  enterpriseClientId?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  servicesOffered?: InputMaybe<Array<ServiceOrderType>>;
};

export type ServicesLeadTimeInput = {
  from?: InputMaybe<Scalars['Float']['input']>;
  to?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type DesignerB2BUrlQueryVariables = Exact<{
  handle: Scalars['String']['input'];
}>;


export type DesignerB2BUrlQuery = { __typename?: 'Query', designer: { __typename?: 'Designer', b2bPageUrl?: string | null } };

export type DesignerUpdateFromAdminFormMutationVariables = Exact<{
  handle: Scalars['String']['input'];
  input: DesignerUpdateInput;
}>;


export type DesignerUpdateFromAdminFormMutation = { __typename?: 'Mutation', designerUpdate: { __typename?: 'Designer', b2bPageUrl?: string | null } };

export type DesignerUpdateFromB2BServicesMutationVariables = Exact<{
  handle: Scalars['String']['input'];
  input: DesignerUpdateInput;
}>;


export type DesignerUpdateFromB2BServicesMutation = { __typename?: 'Mutation', designerUpdate: { __typename?: 'Designer', name: string, selectedB2BServices?: string | null } };

export type UpdatePieceCollectionMutationVariables = Exact<{
  input: PieceCollectionUpdateInput;
  handle: Scalars['String']['input'];
}>;


export type UpdatePieceCollectionMutation = { __typename?: 'Mutation', pieceCollectionUpdate: { __typename?: 'PieceCollection', id: string } };

export type CreatePieceCollectionMutationVariables = Exact<{
  input: PieceCollectionCreateInput;
}>;


export type CreatePieceCollectionMutation = { __typename?: 'Mutation', pieceCollectionCreate: { __typename?: 'PieceCollection', id: string } };

export type PieceCollectionQueryVariables = Exact<{
  handle: Scalars['String']['input'];
}>;


export type PieceCollectionQuery = { __typename?: 'Query', pieceCollections: { __typename?: 'PieceCollectionsPage', edges: Array<{ __typename?: 'PieceCollectionEdge', node: { __typename?: 'PieceCollection', id: string, title: string, handle: string, description?: string | null, brand?: { __typename?: 'Brand', id: string, name: string, handle: string } | null } }> } };

export type DeletePieceCollectionMutationVariables = Exact<{
  handle: Scalars['String']['input'];
}>;


export type DeletePieceCollectionMutation = { __typename?: 'Mutation', pieceCollectionDelete: { __typename?: 'DeletedEntity', id: string } };

export type CreateCustomerCreditEntryMutationVariables = Exact<{
  source: CustomerCreditEntrySource;
  shopifyOrderId?: InputMaybe<Scalars['String']['input']>;
  shopifyDiscountCode?: InputMaybe<Scalars['String']['input']>;
  shopifyCustomerId: Scalars['String']['input'];
  currency: Currency;
  amount: Scalars['Float']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  expiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  settled?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateCustomerCreditEntryMutation = { __typename?: 'Mutation', createCustomerCreditEntry: { __typename?: 'CustomerCreditEntry', id: string } };

export type DesignerUpdateMutationVariables = Exact<{
  input: DesignerUpdateInput;
  handle: Scalars['String']['input'];
}>;


export type DesignerUpdateMutation = { __typename?: 'Mutation', designerUpdate: { __typename?: 'Designer', handle: string } };

export type DesignerOrdersByDesignerHandleQueryVariables = Exact<{
  handle: Scalars['String']['input'];
}>;


export type DesignerOrdersByDesignerHandleQuery = { __typename?: 'Query', designerOrders: { __typename?: 'DesignerOrdersPage', edges: Array<{ __typename?: 'DesignerOrderEdge', node: { __typename?: 'DesignerOrder', id: string, status: DesignerOrderStatus, orderName: string, lineItems: Array<{ __typename?: 'FulfillmentOrderLineItem', quantity: number, title: string, sku?: string | null, refundableQuantity?: number | null }>, designer: { __typename?: 'Designer', name: string } } }> } };

export type UpdateDesignerProfileAttributesMutationVariables = Exact<{
  handle: Scalars['String']['input'];
  input: DesignerUpdateInput;
}>;


export type UpdateDesignerProfileAttributesMutation = { __typename?: 'Mutation', designerUpdate: { __typename?: 'Designer', id: string } };

export type PiecesByDesignerHandleQueryVariables = Exact<{
  designerHandle?: InputMaybe<Scalars['String']['input']>;
}>;


export type PiecesByDesignerHandleQuery = { __typename?: 'Query', pieces: { __typename?: 'PiecesPage', edges: Array<{ __typename?: 'PieceEdge', node: { __typename?: 'Piece', id: string, title: string } }> } };

export type CurrencyRatesQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrencyRatesQuery = { __typename?: 'Query', currencyRates: Array<{ __typename?: 'CurrencyRate', code: Currency, rate: number }> };

export type DesignerOrderAcceptMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input?: InputMaybe<DesignerOrderAcceptInput>;
}>;


export type DesignerOrderAcceptMutation = { __typename?: 'Mutation', designerOrderAccept: { __typename?: 'DesignerOrder', status: DesignerOrderStatus } };

export type DesignerOrderShippingRequestMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: DesignerOrderShippingRequestInput;
}>;


export type DesignerOrderShippingRequestMutation = { __typename?: 'Mutation', designerOrderShippingRequest: { __typename?: 'DesignerOrder', id: string } };

export type DesignerUserUpdateMutationMutationVariables = Exact<{
  input: DesignerUserInput;
  id: Scalars['String']['input'];
}>;


export type DesignerUserUpdateMutationMutation = { __typename?: 'Mutation', designerUserUpdate: { __typename?: 'DesignerUserModel', id: string, user: { __typename?: 'User', id: string } } };

export type DesignerUserRemoveMutationMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DesignerUserRemoveMutationMutation = { __typename?: 'Mutation', designerUserRemove: { __typename?: 'DeletedEntity', id: string } };

export type DesignersQueryVariables = Exact<{ [key: string]: never; }>;


export type DesignersQuery = { __typename?: 'Query', designers: { __typename?: 'DesignersPage', edges: Array<{ __typename?: 'DesignerEdge', node: { __typename?: 'Designer', id: string, name: string, handle: string } }> } };

export type UploadFileMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
  namespace: Scalars['String']['input'];
  path: Scalars['String']['input'];
}>;


export type UploadFileMutation = { __typename?: 'Mutation', uploadFile: { __typename?: 'RemoteFile', uri: string } };

export type AutocompleteCustomersSearchQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type AutocompleteCustomersSearchQuery = { __typename?: 'Query', customersSearch: Array<{ __typename?: 'CustomerSearchItem', id: string, displayName?: string | null, value?: string | null }> };

export type SearchProductsAutocompleteQueryVariables = Exact<{
  query: Scalars['String']['input'];
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchProductsAutocompleteQuery = { __typename?: 'Query', searchCombined: { __typename?: 'SearchResultsPage', edges: Array<{ __typename?: 'SearchResultEdge', node: { __typename?: 'SearchResult', id: string, title: string } }> } };

export type SearchProductVariantsAutocompleteQueryVariables = Exact<{
  productIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type SearchProductVariantsAutocompleteQuery = { __typename?: 'Query', productVariants: Array<{ __typename?: 'ProductVariant', id: string, name?: string | null, order?: number | null, isDefault?: boolean | null }> };

export type DesignerQueryVariables = Exact<{
  handle: Scalars['String']['input'];
}>;


export type DesignerQuery = { __typename?: 'Query', designer: { __typename?: 'Designer', jewellerCategory?: string | null, handle: string, longitude?: string | null, latitude?: string | null, abbreviation?: string | null, margin: number, shippingRegion?: ShippingRegions | null, ein?: string | null, eori?: string | null, website?: string | null, instagramHandle?: string | null, phone?: string | null, returnPeriodDays: number, awaitingImagesPiecesCount: number, awaitingQAPiecesCount: number, bankAccountName?: string | null, bespoke: boolean, readyToOrder: boolean, verifiedPartner: boolean, customisation: boolean, repair: boolean, disabledCountries: Array<Country>, enabledCurrencies: Array<Currency>, highlights?: Array<string> | null, summary?: string | null, headline?: string | null, profileImageUrl?: string | null, curatorQuote?: string | null, storeAddress?: string | null, storeGoogleMapsUrl?: string | null, storeImageUrl?: string | null, specialties?: Array<string> | null, workbenchImageUrl?: string | null, videoHighlightUrl?: string | null, videoHighlightDescription?: string | null, draftPiecesCount: number, email?: string | null, id: string, livePiecesCount: number, microBusiness?: boolean | null, comingSoon: boolean, countryOfOrigin?: string | null, name: string, productSpreadsheetId?: string | null, remodel: boolean, vatIdNo?: string | null, status: Status, tags: Array<DesignerStyleTag>, isRegisteredInShopify?: boolean | null, servicesTerms?: { __typename?: 'ServicesTerms', startingBudget?: number | null, paymentTerms?: string | null, iterationRounds?: number | null, worksWithHeirloomGemstones?: boolean | null, recyclesGoldForReuse?: boolean | null, availableForVirtualConsultations?: boolean | null, availableForInPersonConsultations?: boolean | null, servicesLeadTime?: { __typename?: 'ServicesLeadTime', from?: number | null, to?: number | null, unit?: string | null } | null } | null, featuredProduct?: { __typename?: 'Piece', id: string } | null, billingAddress?: { __typename?: 'Address', line1: string, line2?: string | null, line3?: string | null, city: string, zip?: string | null, region?: string | null, country: string } | null, shippingAddress?: { __typename?: 'Address', line1: string, line2?: string | null, line3?: string | null, city: string, zip?: string | null, region?: string | null, country: string } | null } };

export type SendMessageToLeadMutationVariables = Exact<{
  handle: Scalars['String']['input'];
  input: LeadMessageInput;
}>;


export type SendMessageToLeadMutation = { __typename?: 'Mutation', leadSendMessage: { __typename?: 'Designer', id: string } };

export type UpdateDesignerLeadsMutationVariables = Exact<{
  handle: Scalars['String']['input'];
  input: DesignerUpdateInput;
}>;


export type UpdateDesignerLeadsMutation = { __typename?: 'Mutation', designerUpdate: { __typename?: 'Designer', id: string } };

export type ContactLeadMutationVariables = Exact<{
  handle: Scalars['String']['input'];
  input?: InputMaybe<LeadMessageInput>;
}>;


export type ContactLeadMutation = { __typename?: 'Mutation', leadContact: { __typename?: 'Designer', status: Status, id: string } };

export type LeadCreateInternalMutationVariables = Exact<{
  input: LeadCreateInternalInput;
}>;


export type LeadCreateInternalMutation = { __typename?: 'Mutation', leadCreateInternal: { __typename?: 'Designer', id: string, status: Status, email?: string | null } };

export type RejectLeadMutationVariables = Exact<{
  handle: Scalars['String']['input'];
  input?: InputMaybe<LeadMessageInput>;
}>;


export type RejectLeadMutation = { __typename?: 'Mutation', leadReject: { __typename?: 'Designer', status: Status, id: string } };

export type OnHoldLeadMutationVariables = Exact<{
  handle: Scalars['String']['input'];
  input?: InputMaybe<LeadMessageInput>;
}>;


export type OnHoldLeadMutation = { __typename?: 'Mutation', leadOnHold: { __typename?: 'Designer', status: Status, id: string } };

export type DesignerOrdersQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  includeClosed?: InputMaybe<Scalars['Boolean']['input']>;
  designerHandle?: InputMaybe<Scalars['String']['input']>;
}>;


export type DesignerOrdersQuery = { __typename?: 'Query', designerOrders: { __typename?: 'DesignerOrdersPage', edges: Array<{ __typename?: 'DesignerOrderEdge', cursor: string, node: { __typename?: 'DesignerOrder', id: string, status: DesignerOrderStatus, orderName: string, expectedFulfillmentAt?: any | null, lineItems: Array<{ __typename?: 'FulfillmentOrderLineItem', quantity: number, title: string, refundableQuantity?: number | null }>, designer: { __typename?: 'Designer', name: string, handle: string } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage?: boolean | null } } };

export type AddArbitraryPayoutLineMutationVariables = Exact<{
  input: PayoutLineInput;
}>;


export type AddArbitraryPayoutLineMutation = { __typename?: 'Mutation', addArbitraryPayoutLine: { __typename?: 'Payout', id: string } };

export type ChangePayoutStatusMutationVariables = Exact<{
  id: Scalars['String']['input'];
  status: PayoutStatus;
}>;


export type ChangePayoutStatusMutation = { __typename?: 'Mutation', changePayoutStatus: { __typename?: 'Payout', status: PayoutStatus } };

export type GetPayoutsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  designerIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  statuses?: InputMaybe<Array<PayoutStatus> | PayoutStatus>;
  designerCurrencies?: InputMaybe<Array<Currency> | Currency>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<PayoutOrderByInput>;
  sort?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPayoutsQuery = { __typename?: 'Query', payouts: { __typename?: 'PayoutsPage', pageInfo: { __typename?: 'PageInfo', hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename?: 'PayoutEdge', cursor: string, node: { __typename?: 'Payout', paymentPeriod: any, designerId: string, designerCurrency: string, id: string, reference: string, status: PayoutStatus, totalAmount: number, totalAmountByExchangeRate: number, pdfUrl: string, designer: { __typename?: 'Designer', name: string }, payoutLines: Array<{ __typename?: 'PayoutLine', id: string }> } }> } };

export type GetDesignerPayoutsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  designerIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  statuses?: InputMaybe<Array<PayoutStatus> | PayoutStatus>;
  designerCurrencies?: InputMaybe<Array<Currency> | Currency>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<PayoutOrderByInput>;
  sort?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDesignerPayoutsQuery = { __typename?: 'Query', payouts: { __typename?: 'PayoutsPage', pageInfo: { __typename?: 'PageInfo', hasNextPage?: boolean | null }, edges: Array<{ __typename?: 'PayoutEdge', cursor: string, node: { __typename?: 'Payout', paymentPeriod: any, designerCurrency: string, id: string, reference: string, status: PayoutStatus, totalAmountByExchangeRate: number, payoutLines: Array<{ __typename?: 'PayoutLine', id: string }> } }> } };

export type GetPhotoshootsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  statuses?: InputMaybe<Array<PhotoshootStatus> | PhotoshootStatus>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<PhotoshootOrderByInput>;
  sort?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPhotoshootsQuery = { __typename?: 'Query', photoshoots: { __typename?: 'PhotoshootsPage', pageInfo: { __typename?: 'PageInfo', hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename?: 'PhotoshootEdge', cursor: string, node: { __typename?: 'Photoshoot', id: string, reference: string, location: PhotoshootLocation, status: PhotoshootStatus, startDate?: any | null, endDate?: any | null, type: PhotoshootType } }> } };

export type ChangePhotoshootStatusMutationVariables = Exact<{
  id: Scalars['String']['input'];
  status: PhotoshootStatus;
}>;


export type ChangePhotoshootStatusMutation = { __typename?: 'Mutation', changePhotoshootStatus: { __typename?: 'Photoshoot', status: PhotoshootStatus } };

export type DeletePhotoshootMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeletePhotoshootMutation = { __typename?: 'Mutation', deletePhotoshoot: { __typename?: 'DeletedEntity', id: string } };

export type CreatePhotoshootShipmentsMutationVariables = Exact<{
  input: CreatePhotoshootShipmentsInput;
}>;


export type CreatePhotoshootShipmentsMutation = { __typename?: 'Mutation', createPhotoshootShipments: Array<{ __typename?: 'Shipment', id: string }> };

export type CreatePhotoshootReturnsShipmentsMutationVariables = Exact<{
  input: CreatePhotoshootShipmentsInput;
}>;


export type CreatePhotoshootReturnsShipmentsMutation = { __typename?: 'Mutation', createPhotoshootShipments: Array<{ __typename?: 'Shipment', id: string }> };

export type CreatePhotoshootMutationVariables = Exact<{
  input: CreatePhotoshootInput;
}>;


export type CreatePhotoshootMutation = { __typename?: 'Mutation', createPhotoshoot: { __typename?: 'Photoshoot', id: string } };

export type CreatePhotoshootLinesMutationVariables = Exact<{
  input: CreatePhotoshootLinesInput;
}>;


export type CreatePhotoshootLinesMutation = { __typename?: 'Mutation', createPhotoshootLines: { __typename?: 'Photoshoot', id: string } };

export type GetPiecesPhotoshootsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<PhotoshootStatus> | PhotoshootStatus>;
}>;


export type GetPiecesPhotoshootsQuery = { __typename?: 'Query', photoshoots: { __typename?: 'PhotoshootsPage', edges: Array<{ __typename?: 'PhotoshootEdge', cursor: string, node: { __typename?: 'Photoshoot', id: string, reference: string } }> } };

export type PiecesSummaryQueryVariables = Exact<{
  designerHandle: Scalars['String']['input'];
}>;


export type PiecesSummaryQuery = { __typename?: 'Query', piecesSummary: Array<{ __typename?: 'Piece', id: string, title: string }> };

export type BulkUpdateLeadTimeMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  leadTime: LeadTimeInput;
}>;


export type BulkUpdateLeadTimeMutation = { __typename?: 'Mutation', bulkUpdateLeadTime: boolean };

export type ExportPiecesMutationVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ExportPiecesMutation = { __typename?: 'Mutation', piecesExportPieces: { __typename?: 'GenericResult', success: boolean } };

export type PieceCreateMutationVariables = Exact<{
  input: PieceCreateInput;
}>;


export type PieceCreateMutation = { __typename?: 'Mutation', pieceCreate: { __typename?: 'Piece', id: string } };

export type PieceBrandsQueryVariables = Exact<{
  designerHandle?: InputMaybe<Scalars['String']['input']>;
}>;


export type PieceBrandsQuery = { __typename?: 'Query', brands: { __typename?: 'BrandsPage', edges: Array<{ __typename?: 'BrandEdge', node: { __typename?: 'Brand', name: string, handle: string } }> } };

export type PieceDesignerQueryVariables = Exact<{
  handle: Scalars['String']['input'];
}>;


export type PieceDesignerQuery = { __typename?: 'Query', designer: { __typename?: 'Designer', countryOfOrigin?: string | null, enabledCurrencies: Array<Currency> } };

export type PieceCollectionsByBrandQueryVariables = Exact<{
  brandHandle: Scalars['String']['input'];
}>;


export type PieceCollectionsByBrandQuery = { __typename?: 'Query', pieceCollections: { __typename?: 'PieceCollectionsPage', edges: Array<{ __typename?: 'PieceCollectionEdge', node: { __typename?: 'PieceCollection', id: string, title: string, handle: string } }> } };

export type LongForm_PieceFragment = { __typename?: 'Piece', id: string, shopifyUrl?: string | null, status: PieceStatus, siteUrl?: string | null, title: string, sku: string, description?: string | null, curatorQuote?: string | null, type: PieceType, gender: PieceGender, tonality?: Tonality | null, oneOfAKind: boolean, engraving: boolean, engravingMaxLength?: number | null, hasCustomLettering: boolean, customLetteringMaxLength?: number | null, isHollow: boolean, designYear?: string | null, productionYear?: string | null, returnPeriodDays?: number | null, margin: number, tags: Array<PieceTags>, designer: { __typename?: 'Designer', id: string, handle: string, name: string }, brand: { __typename?: 'Brand', id: string, handle: string }, collection?: { __typename?: 'PieceCollection', id: string, handle: string } | null, anklet?: { __typename?: 'Anklet', category?: AnkletCategory | null } | null, bracelet?: { __typename?: 'Bracelet', category?: BraceletCategory | null, lock?: BraceletLock | null } | null, earring?: { __typename?: 'Earring', category?: EarringCategory | null, soldAs?: EarringSoldAs | null, closure?: EarringClosure | null } | null, necklace?: { __typename?: 'Necklace', category?: NecklaceCategory | null, lock?: NecklaceLock | null } | null, ring?: { __typename?: 'Ring', category?: RingCategory | null } | null, brooch?: { __typename?: 'Brooch', category?: BroochCategory | null } | null, cufflink?: { __typename?: 'Cufflink', category?: CufflinkCategory | null } | null, leadTime?: { __typename?: 'TimeRange', unit: TimeUnit, value: string } | null, vintage: { __typename?: 'Vintage', isVintage?: boolean | null } };

export type PieceImageDeleteMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type PieceImageDeleteMutation = { __typename?: 'Mutation', pieceImageDelete: { __typename?: 'GenericResult', success: boolean } };

export type UploadProductImageMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
  pieceId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
  gender: Scalars['String']['input'];
  order: Scalars['Float']['input'];
  usePhotoroom: Scalars['Boolean']['input'];
}>;


export type UploadProductImageMutation = { __typename?: 'Mutation', uploadProductImage: { __typename?: 'GenericResult', success: boolean } };

export type Images_PieceFragment = { __typename?: 'Piece', id: string, title: string, images: Array<{ __typename?: 'PieceImage', image: string, url: string, type: string, gender: string, id: string, order: number }>, videos: Array<{ __typename?: 'PieceImage', url: string, gender: string, id: string }>, designer: { __typename?: 'Designer', name: string } };

export type MaterialsAndGemstones_PieceFragment = { __typename?: 'Piece', metals: Array<{ __typename?: 'PieceMetal', id: string, description?: string | null, primaryMaterial?: Material | null, durability?: Durability | null, baseMaterial?: Material | null, platingThickness?: number | null, karat?: number | null, finish?: Finish | null, weight?: number | null }>, gemstones: Array<{ __typename?: 'PieceGemstone', id: string, description?: string | null, type?: GemstoneType | null, carat?: number | null, count?: number | null, pearl?: { __typename?: 'Pearl', type?: PearlType | null, shape?: PearlShape | null } | null, diamond?: { __typename?: 'Diamond', clarity?: DiamondClarity | null, colour?: DiamondColour | null, shape?: DiamondShape | null, cut?: DiamondCut | null, class?: DiamondClass | null } | null }> };

export type OptionsAndSizes_PieceFragment = { __typename?: 'Piece', options: Array<{ __typename?: 'PieceOption', id: string, name: string, values: Array<{ __typename?: 'PieceOptionValue', id: string, name: string, skuSuffix?: string | null }> }>, width?: { __typename?: 'PieceSize', unit: SizeUnit, option: boolean, requestable: boolean, variable: boolean, description?: string | null, values: Array<{ __typename?: 'PieceSizeValue', id: string, value: string }> } | null, length?: { __typename?: 'PieceSize', unit: SizeUnit, option: boolean, requestable: boolean, variable: boolean, description?: string | null, values: Array<{ __typename?: 'PieceSizeValue', id: string, value: string }> } | null, diameter?: { __typename?: 'PieceSize', unit: SizeUnit, option: boolean, requestable: boolean, variable: boolean, description?: string | null, values: Array<{ __typename?: 'PieceSizeValue', id: string, value: string }> } | null, circumference?: { __typename?: 'PieceSize', unit: SizeUnit, option: boolean, requestable: boolean, variable: boolean, description?: string | null, values: Array<{ __typename?: 'PieceSizeValue', id: string, value: string }> } | null, dropLength?: { __typename?: 'PieceSize', unit: SizeUnit, option: boolean, requestable: boolean, variable: boolean, description?: string | null, values: Array<{ __typename?: 'PieceSizeValue', id: string, value: string }> } | null };

export type PieceSizeDataFragment = { __typename?: 'PieceSize', unit: SizeUnit, option: boolean, requestable: boolean, variable: boolean, description?: string | null, values: Array<{ __typename?: 'PieceSizeValue', id: string, value: string }> };

export type FetchVariantsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FetchVariantsQuery = { __typename?: 'Query', pieceVariants: Array<{ __typename?: 'PieceVariant', id: string, title: string, skuOverride?: string | null, skuDefault: string, sku: string, prices?: Array<{ __typename?: 'PiecePrice', currency: Currency, type: PriceType, amount: number }> | null }> };

export type Prices_PieceFragment = { __typename?: 'Piece', id: string, prices: Array<{ __typename?: 'PiecePrice', currency: Currency, type: PriceType, amount: number }>, localPrices?: Array<{ __typename?: 'PiecePrice', currency: Currency, amount: number }> | null, designer: { __typename?: 'Designer', countryOfOrigin?: string | null, enabledCurrencies: Array<Currency> } };

export type Sustainability_PieceFragment = { __typename?: 'Piece', id: string, sustainabilityLabels: Array<SustainabilityLabel> };

export type UpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: PieceVariantInput;
}>;


export type UpdateMutation = { __typename?: 'Mutation', pieceVariantUpdate: { __typename?: 'PieceVariant', id: string, skuOverride?: string | null, skuDefault: string, prices?: Array<{ __typename?: 'PiecePrice', currency: Currency, type: PriceType, amount: number }> | null } };

export type PieceDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PieceDeleteMutation = { __typename?: 'Mutation', pieceDelete: { __typename?: 'DeletedEntity', id: string } };

export type PiecesHideMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type PiecesHideMutation = { __typename?: 'Mutation', hidePieces: Array<string> };

export type PiecesUnhideMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type PiecesUnhideMutation = { __typename?: 'Mutation', unhidePieces: Array<string> };

export type PiecesTableListQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  designerHandle?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  query: Scalars['String']['input'];
  hidden: Scalars['Boolean']['input'];
}>;


export type PiecesTableListQuery = { __typename?: 'Query', pieces: { __typename?: 'PiecesPage', totalCount?: number | null, edges: Array<{ __typename?: 'PieceEdge', cursor: string, node: { __typename?: 'Piece', id: string, title: string, type: PieceType, sku: string, createdAt: string, shopifyId?: string | null, status: PieceStatus, leadTime?: { __typename?: 'TimeRange', unit: TimeUnit, value: string } | null, prices: Array<{ __typename?: 'PiecePrice', id: string, amount: number }>, images: Array<{ __typename?: 'PieceImage', id: string }>, photoshoot?: { __typename?: 'Photoshoot', id: string } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage?: boolean | null } } };

export type DesignerExportPiecesMutationVariables = Exact<{
  designerHandle: Scalars['String']['input'];
}>;


export type DesignerExportPiecesMutation = { __typename?: 'Mutation', piecesExportDesigner: { __typename?: 'GenericResult', success: boolean } };

export type QaListQueryVariables = Exact<{ [key: string]: never; }>;


export type QaListQuery = { __typename?: 'Query', piecesToQA: Array<{ __typename?: 'Piece', id: string, title: string, type: PieceType, sku: string, createdAt: string, designer: { __typename?: 'Designer', name: string } }> };

export type PieceUpdateMutationVariables = Exact<{
  input: PieceUpdateInput;
  id: Scalars['ID']['input'];
}>;


export type PieceUpdateMutation = { __typename?: 'Mutation', pieceUpdate: { __typename?: 'Piece', id: string } };

export type CreateCustomerReferralCampaignEntryMutationVariables = Exact<{
  amount: Scalars['Float']['input'];
  currency: Currency;
  campaign?: InputMaybe<Scalars['String']['input']>;
  maximumUses: Scalars['Float']['input'];
  expiryPeriod?: InputMaybe<Scalars['Float']['input']>;
}>;


export type CreateCustomerReferralCampaignEntryMutation = { __typename?: 'Mutation', createCustomerReferralCampaignEntry: { __typename?: 'CustomerReferralEntry', id: string } };

export type UpdateStatusMutationVariables = Exact<{
  id: Scalars['String']['input'];
  status: ServiceOrderStatus;
}>;


export type UpdateStatusMutation = { __typename?: 'Mutation', updateServiceOrderStatus: { __typename?: 'ServiceOrder', id: string, status: ServiceOrderStatus } };

export type CreateServiceOrderShipmentMutationVariables = Exact<{
  input: ServiceOrderCreateShipmentInput;
}>;


export type CreateServiceOrderShipmentMutation = { __typename?: 'Mutation', createServiceOrderShipment: { __typename?: 'Shipment', id: string, label: string } };

export type UpdateNotesMutationVariables = Exact<{
  id: Scalars['String']['input'];
  notes: Scalars['String']['input'];
}>;


export type UpdateNotesMutation = { __typename?: 'Mutation', updateServiceOrderItem?: { __typename?: 'ServiceOrderItem', id: string } | null };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'Query', userCurrent: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string, role: UserRole, designerUsers: Array<{ __typename?: 'DesignerUserModel', id: string, shouldNotifyOrders: boolean, shouldNotifyPayouts: boolean, designer: { __typename?: 'Designer', handle: string, name: string, id: string } }> } };

export type LoginPasswordMutationVariables = Exact<{
  input: LoginPasswordInput;
}>;


export type LoginPasswordMutation = { __typename?: 'Mutation', loginPassword: { __typename?: 'Authentication', accessToken: string, user: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string, role: UserRole, designerUsers: Array<{ __typename?: 'DesignerUserModel', id: string, notify: boolean, designer: { __typename?: 'Designer', id: string, handle: string, name: string } }> } } };

export type LoginGoogleStartQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type LoginGoogleStartQueryQuery = { __typename?: 'Query', loginGoogleStart: { __typename?: 'GoogleAuthenticationStart', url: string, state: string } };

export type SetMutationVariables = Exact<{
  input: ActivateUserInput;
}>;


export type SetMutation = { __typename?: 'Mutation', activateUser: { __typename?: 'Authentication', accessToken: string, user: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string, role: UserRole, designerUsers: Array<{ __typename?: 'DesignerUserModel', id: string, notify: boolean, designer: { __typename?: 'Designer', handle: string, name: string, id: string } }> } } };

export type CustomerCreditTotalsQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerCreditTotalsQuery = { __typename?: 'Query', customerCreditTotals: Array<{ __typename?: 'Price', amount: number, currency: Currency }> };

export type LoginGoogleMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type LoginGoogleMutation = { __typename?: 'Mutation', loginGoogle: { __typename?: 'Authentication', accessToken: string, user: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string, role: UserRole } } };

export type AssociateMutationVariables = Exact<{
  customerId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  variantId: Scalars['String']['input'];
}>;


export type AssociateMutation = { __typename?: 'Mutation', customerAssociateProduct: { __typename?: 'CustomerAssociatePayload', customer: { __typename?: 'CustomerSummaryBasic', displayName?: string | null }, piece: { __typename?: 'Piece', designer: { __typename?: 'Designer', name: string } }, variant: { __typename?: 'ProductVariant', name?: string | null } } };

export type GetCustomerSummaryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetCustomerSummaryQuery = { __typename?: 'Query', customerGetOwnerSummary: { __typename?: 'CustomerSummaryWithProducts', displayName?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, products?: Array<{ __typename?: 'Instance', name?: string | null, id?: string | null, productVariantId?: string | null, createdAt?: string | null, designerName?: string | null, images?: Array<{ __typename?: 'Image', altText?: string | null, type?: string | null, order?: string | null, url?: string | null }> | null }> | null }, customerCreditEntries: Array<{ __typename?: 'CustomerCreditEntry', id: string, source: CustomerCreditEntrySource, shopifyOrderId?: string | null, shopifyCustomerId?: string | null, shopifyDiscountCode?: string | null, currency: Currency, amount: number, notes?: string | null, createdAt: any }>, customerCredit: Array<{ __typename?: 'Price', amount: number, currency: Currency }>, customerReferralEntries: Array<{ __typename?: 'CustomerReferralEntry', id: string, createdAt: any, referringUserEmail?: string | null, toUserEmail?: string | null, amount: number, currency: Currency, status: ReferralStatus }>, favourites: Array<{ __typename?: 'Favourite', handle: string, createdAt: any }> };

export type DesignerOrderQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DesignerOrderQuery = { __typename?: 'Query', designerOrder: { __typename?: 'DesignerOrder', id: string, entityId?: string | null, status: DesignerOrderStatus, orderName: string, giftWrapping: boolean, expectedFulfillmentAt?: any | null, createdAt: any, shippingTo?: { __typename?: 'DesignerOrderDestinationModel', name?: string | null, email?: string | null, phone?: string | null, company?: string | null, line1: string, line2?: string | null, line3?: string | null, city: string, zip?: string | null, region?: string | null, country: string, countryName: string } | null, lineItems: Array<{ __typename?: 'FulfillmentOrderLineItem', id: string, quantity: number, title: string, sku?: string | null, image?: string | null, refundableQuantity?: number | null, engraving?: string | null, engravingMaxLength?: string | null, customLettering?: string | null, deliveredBy?: string | null }>, invoice?: { __typename?: 'Invoice', pdfSales: string, pdfCommercial: string } | null, shipment?: { __typename?: 'Shipment', trackingNumber: string, trackingUrl: string, label: string, courier: string, courierTrackingNumber: string } | null, designer: { __typename?: 'Designer', name: string } } };

export type SaveBankDetailsMutationVariables = Exact<{
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  bankAccountName: Scalars['String']['input'];
  bankAddress?: InputMaybe<Scalars['String']['input']>;
  clearingNumber?: InputMaybe<Scalars['String']['input']>;
  cvr?: InputMaybe<Scalars['String']['input']>;
  designerId: Scalars['String']['input'];
  iban?: InputMaybe<Scalars['String']['input']>;
  routingNumber?: InputMaybe<Scalars['String']['input']>;
  sortCode?: InputMaybe<Scalars['String']['input']>;
  swiftCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type SaveBankDetailsMutation = { __typename?: 'Mutation', saveBankDetails: { __typename?: 'BankDetails', id: string } };

export type DesignerRegistrationMutationVariables = Exact<{
  handle: Scalars['String']['input'];
}>;


export type DesignerRegistrationMutation = { __typename?: 'Mutation', designerRegisterShopify: { __typename?: 'Designer', id: string } };

export type DesignerDeletionMutationVariables = Exact<{
  handle: Scalars['String']['input'];
}>;


export type DesignerDeletionMutation = { __typename?: 'Mutation', designerDelete: { __typename?: 'DeletedEntity', id: string } };

export type DesignerRestoreMutationVariables = Exact<{
  handle: Scalars['String']['input'];
}>;


export type DesignerRestoreMutation = { __typename?: 'Mutation', designerRestore: { __typename?: 'Designer', handle: string } };

export type GetB2bServicesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetB2bServicesQuery = { __typename?: 'Query', getB2bServices?: string | null };

export type Designerb2bDataQueryVariables = Exact<{
  handle: Scalars['String']['input'];
}>;


export type Designerb2bDataQuery = { __typename?: 'Query', designer: { __typename?: 'Designer', name: string, selectedB2BServices?: string | null } };

export type CreateMutationVariables = Exact<{
  input: DesignerCreateInput;
}>;


export type CreateMutation = { __typename?: 'Mutation', designerCreate: { __typename?: 'Designer', handle: string } };

export type DesignersListQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  query: Scalars['String']['input'];
}>;


export type DesignersListQuery = { __typename?: 'Query', designers: { __typename?: 'DesignersPage', edges: Array<{ __typename?: 'DesignerEdge', cursor: string, node: { __typename?: 'Designer', id: string, name: string, email?: string | null, phone?: string | null, handle: string, status: Status, draftPiecesCount: number, awaitingImagesPiecesCount: number, awaitingQAPiecesCount: number, livePiecesCount: number, billingAddress?: { __typename?: 'Address', country: string } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage?: boolean | null } } };

export type DesignerOnboardingQueryVariables = Exact<{
  designerHandle: Scalars['String']['input'];
}>;


export type DesignerOnboardingQuery = { __typename?: 'Query', pieces: { __typename?: 'PiecesPage', edges: Array<{ __typename?: 'PieceEdge', node: { __typename?: 'Piece', id: string } }> }, getDates: Array<{ __typename?: 'DesignerVacationDates', id: string }>, pieceCollections: { __typename?: 'PieceCollectionsPage', edges: Array<{ __typename?: 'PieceCollectionEdge', node: { __typename?: 'PieceCollection', id: string } }> } };

export type LeadQueryVariables = Exact<{
  handle: Scalars['String']['input'];
}>;


export type LeadQuery = { __typename?: 'Query', lead: { __typename?: 'Designer', id: string, name: string, email?: string | null, leadStatus: LeadStatus, website?: string | null, instagramHandle?: string | null, leadSource?: LeadSource | null, countryOfOrigin?: string | null, description?: string | null, jewelleryMakingLocation?: string | null, materials?: string | null, leadTime?: string | null, priceRange?: string | null, otherPartners?: string | null, otherPartnersText?: string | null, taxRegistered?: string | null, statusHistory?: Array<{ __typename?: 'DesignerStatusHistory', createdAt?: any | null, leadStatus: LeadStatus }> | null } };

export type LeadsQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<LeadStatus> | LeadStatus>;
  orderBy?: InputMaybe<LeadOrderByInput>;
  sort?: InputMaybe<Scalars['String']['input']>;
  query: Scalars['String']['input'];
}>;


export type LeadsQuery = { __typename?: 'Query', leads: { __typename?: 'DesignersPage', edges: Array<{ __typename?: 'DesignerEdge', cursor: string, node: { __typename?: 'Designer', id: string, name: string, handle: string, status: Status, leadStatus: LeadStatus, countryOfOrigin?: string | null, website?: string | null, createdAt: any } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage?: boolean | null } } };

export type LeadRemoveMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LeadRemoveMutation = { __typename?: 'Mutation', leadRemove: boolean };

export type ChangePayoutLineStatusMutationVariables = Exact<{
  id: Scalars['String']['input'];
  isExcluded: Scalars['Boolean']['input'];
  excludedReason?: InputMaybe<PayoutLineExcludedReason>;
}>;


export type ChangePayoutLineStatusMutation = { __typename?: 'Mutation', changePayoutLineStatus: { __typename?: 'Payout', id: string } };

export type GetPayoutQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  convertToDesignerCurrency: Scalars['Boolean']['input'];
}>;


export type GetPayoutQuery = { __typename?: 'Query', payout: { __typename?: 'Payout', paymentPeriod: any, designerId: string, id: string, designerCurrency: string, pdfUrl: string, reference: string, status: PayoutStatus, totalAmount: number, totalAmountByExchangeRate: number, totalFinematterCommission: number, totalGrossTransactionalAmount: number, totalGrossEarningsExcludingTaxes: number, totalTaxCollected: number, totalVATCollected: number, totalFinematterVAT: number, vatRate?: number | null, designer: { __typename?: 'Designer', name: string }, payoutLines: Array<{ __typename?: 'PayoutLine', commissionTotal: number, id: string, importTotal: number, pieceId?: string | null, name: string, grossTransactionalAmount: number, shipmentType?: PayoutShipmentType | null, vatTotal: number, isExcluded: boolean, orderReference?: string | null, shopifyOrderId?: string | null, netTotalExcludingCommission: number, refundOf?: { __typename?: 'PayoutLine', id: string, commissionTotal: number, importTotal: number, name: string, grossTransactionalAmount: number, netTotalExcludingCommission: number, vatTotal: number } | null }> } };

export type GetPhotoshootQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPhotoshootQuery = { __typename?: 'Query', photoshoot: { __typename?: 'Photoshoot', id: string, reference: string, type: PhotoshootType, status: PhotoshootStatus, startDate?: any | null, endDate?: any | null, photoshootLines: Array<{ __typename?: 'PhotoshootLine', id: string, status: PhotoshootLineStatus, piece: { __typename?: 'Piece', title: string, id: string, type: PieceType, sku: string, designer: { __typename?: 'Designer', name: string }, images: Array<{ __typename?: 'PieceImage', url: string }> } }> } };

export type ChangePhotoshootLineStatusMutationVariables = Exact<{
  id: Scalars['String']['input'];
  status: PhotoshootLineStatus;
}>;


export type ChangePhotoshootLineStatusMutation = { __typename?: 'Mutation', changePhotoshootLineStatus: { __typename?: 'Photoshoot', id: string } };

export type DeletePhotoshootLineMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeletePhotoshootLineMutation = { __typename?: 'Mutation', deletePhotoshootLine: { __typename?: 'Photoshoot', id: string } };

export type GetPhotoshootShipmentsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPhotoshootShipmentsQuery = { __typename?: 'Query', photoshoot: { __typename?: 'Photoshoot', id: string, reference: string, photoshootLines: Array<{ __typename?: 'PhotoshootLine', id: string, status: PhotoshootLineStatus, piece: { __typename?: 'Piece', title: string, id: string, type: PieceType, sku: string, designer: { __typename?: 'Designer', name: string }, images: Array<{ __typename?: 'PieceImage', url: string }> }, inboundShipment?: { __typename?: 'Shipment', id: string, createdAt: any, reference: string, shipmentReference: string, trackingUrl: string, trackingNumber: string, label: string, invoice: string, status: string } | null, outboundShipment?: { __typename?: 'Shipment', id: string, createdAt: any, reference: string, shipmentReference: string, trackingUrl: string, trackingNumber: string, label: string, invoice: string, status: string } | null }> } };

export type PiecesExportPieceMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type PiecesExportPieceMutation = { __typename?: 'Mutation', piecesExportPiece: { __typename?: 'GenericResult', success: boolean } };

export type PieceQueryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PieceQueryQuery = { __typename?: 'Query', piece: { __typename?: 'Piece', id: string, shopifyUrl?: string | null, status: PieceStatus, siteUrl?: string | null, title: string, sku: string, description?: string | null, curatorQuote?: string | null, type: PieceType, gender: PieceGender, tonality?: Tonality | null, oneOfAKind: boolean, engraving: boolean, engravingMaxLength?: number | null, hasCustomLettering: boolean, customLetteringMaxLength?: number | null, isHollow: boolean, designYear?: string | null, productionYear?: string | null, returnPeriodDays?: number | null, margin: number, tags: Array<PieceTags>, sustainabilityLabels: Array<SustainabilityLabel>, designer: { __typename?: 'Designer', id: string, handle: string, name: string, countryOfOrigin?: string | null, enabledCurrencies: Array<Currency> }, brand: { __typename?: 'Brand', id: string, handle: string }, collection?: { __typename?: 'PieceCollection', id: string, handle: string } | null, anklet?: { __typename?: 'Anklet', category?: AnkletCategory | null } | null, bracelet?: { __typename?: 'Bracelet', category?: BraceletCategory | null, lock?: BraceletLock | null } | null, earring?: { __typename?: 'Earring', category?: EarringCategory | null, soldAs?: EarringSoldAs | null, closure?: EarringClosure | null } | null, necklace?: { __typename?: 'Necklace', category?: NecklaceCategory | null, lock?: NecklaceLock | null } | null, ring?: { __typename?: 'Ring', category?: RingCategory | null } | null, brooch?: { __typename?: 'Brooch', category?: BroochCategory | null } | null, cufflink?: { __typename?: 'Cufflink', category?: CufflinkCategory | null } | null, leadTime?: { __typename?: 'TimeRange', unit: TimeUnit, value: string } | null, vintage: { __typename?: 'Vintage', isVintage?: boolean | null }, images: Array<{ __typename?: 'PieceImage', image: string, url: string, type: string, gender: string, id: string, order: number }>, videos: Array<{ __typename?: 'PieceImage', url: string, gender: string, id: string }>, prices: Array<{ __typename?: 'PiecePrice', currency: Currency, type: PriceType, amount: number }>, localPrices?: Array<{ __typename?: 'PiecePrice', currency: Currency, amount: number }> | null, metals: Array<{ __typename?: 'PieceMetal', id: string, description?: string | null, primaryMaterial?: Material | null, durability?: Durability | null, baseMaterial?: Material | null, platingThickness?: number | null, karat?: number | null, finish?: Finish | null, weight?: number | null }>, gemstones: Array<{ __typename?: 'PieceGemstone', id: string, description?: string | null, type?: GemstoneType | null, carat?: number | null, count?: number | null, pearl?: { __typename?: 'Pearl', type?: PearlType | null, shape?: PearlShape | null } | null, diamond?: { __typename?: 'Diamond', clarity?: DiamondClarity | null, colour?: DiamondColour | null, shape?: DiamondShape | null, cut?: DiamondCut | null, class?: DiamondClass | null } | null }>, options: Array<{ __typename?: 'PieceOption', id: string, name: string, values: Array<{ __typename?: 'PieceOptionValue', id: string, name: string, skuSuffix?: string | null }> }>, width?: { __typename?: 'PieceSize', unit: SizeUnit, option: boolean, requestable: boolean, variable: boolean, description?: string | null, values: Array<{ __typename?: 'PieceSizeValue', id: string, value: string }> } | null, length?: { __typename?: 'PieceSize', unit: SizeUnit, option: boolean, requestable: boolean, variable: boolean, description?: string | null, values: Array<{ __typename?: 'PieceSizeValue', id: string, value: string }> } | null, diameter?: { __typename?: 'PieceSize', unit: SizeUnit, option: boolean, requestable: boolean, variable: boolean, description?: string | null, values: Array<{ __typename?: 'PieceSizeValue', id: string, value: string }> } | null, circumference?: { __typename?: 'PieceSize', unit: SizeUnit, option: boolean, requestable: boolean, variable: boolean, description?: string | null, values: Array<{ __typename?: 'PieceSizeValue', id: string, value: string }> } | null, dropLength?: { __typename?: 'PieceSize', unit: SizeUnit, option: boolean, requestable: boolean, variable: boolean, description?: string | null, values: Array<{ __typename?: 'PieceSizeValue', id: string, value: string }> } | null } };

export type MaterialPricesQueryVariables = Exact<{ [key: string]: never; }>;


export type MaterialPricesQuery = { __typename?: 'Query', materialPrices: Array<{ __typename?: 'MaterialPrice', materialType: MaterialType, currencyAmounts: Array<{ __typename?: 'CurrencyAmount', currency: Currency, amount: number }> }> };

export type MaterialPriceUpdateMutationVariables = Exact<{
  materialType: MaterialType;
  currencyAmounts: Array<CurrencyAmountInput> | CurrencyAmountInput;
}>;


export type MaterialPriceUpdateMutation = { __typename?: 'Mutation', materialPriceUpdate: { __typename?: 'MaterialPrice', materialType: MaterialType } };

export type PiecesExportPricesMutationVariables = Exact<{ [key: string]: never; }>;


export type PiecesExportPricesMutation = { __typename?: 'Mutation', piecesExportPrices: { __typename?: 'GenericResult', success: boolean } };

export type PublicDesignerByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type PublicDesignerByIdQuery = { __typename?: 'Query', publicDesignerById: { __typename?: 'PublicDesigner', name: string, email?: string | null, leadStatus?: LeadStatus | null } };

export type PublicRegisterDesignerMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: PublicRegisterDesignerArgs;
}>;


export type PublicRegisterDesignerMutation = { __typename?: 'Mutation', publicRegisterDesigner: { __typename?: 'PublicDesigner', email?: string | null } };

export type ServiceOrdersQueryQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  services?: InputMaybe<Array<ServiceOrderType> | ServiceOrderType>;
  includeUnpaid?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<ServiceOrderStatus> | ServiceOrderStatus>;
  countries?: InputMaybe<Array<Country> | Country>;
  includeReturned?: InputMaybe<Scalars['Boolean']['input']>;
  includeCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<ServiceOrderOrderByInput>;
  sort?: InputMaybe<Scalars['String']['input']>;
  orderNumber: Scalars['String']['input'];
}>;


export type ServiceOrdersQueryQuery = { __typename?: 'Query', serviceOrders: { __typename?: 'ServiceOrdersPage', totalCount?: number | null, edges: Array<{ __typename?: 'ServiceOrderEdge', cursor: string, node: { __typename?: 'ServiceOrder', id: string, firstName: string, lastName: string, email: string, address1?: string | null, zip?: string | null, city?: string | null, country?: string | null, image?: string | null, status: ServiceOrderStatus, createdAt: any, service?: ServiceOrderType | null, exchangeWeight?: number | null, exchangeMetal?: ExchangeMetal | null, exchangeDesigner?: string | null, recycleWeight?: number | null, recycleMetal?: RecycleMetal | null, replateMetal?: ReplateMetal | null, replateKarat?: string | null, replatePlatingThickness?: number | null, replateNumberOfPieces?: number | null, repairMetal?: RepairMetal | null, orderPage?: string | null, repairType?: RepairType | null, repairJewelleryType?: JewelleryType | null, refreshType?: RefreshType | null, resizeMetal?: ResizeMetal | null, resizeType?: ResizeType | null, resizeNewSize?: string | null, resizeOtherMetal?: string | null, orderReference?: string | null, statusUpdatedAt?: any | null, notes?: string | null, serviceOrderHistory: Array<{ __typename?: 'ServiceOrderHistory', createdAt: any, status: ServiceOrderStatus }>, serviceOrderAttributes: Array<{ __typename?: 'ServiceOrderAttributeModel', key: ServiceOrderAttributeKey, value: string }>, inboundShipment?: { __typename?: 'Shipment', id: string, label: string } | null, outboundShipment?: { __typename?: 'Shipment', id: string, label: string } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, startCursor?: string | null, endCursor?: string | null } } };

export type ShipmentsQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  query: Scalars['String']['input'];
}>;


export type ShipmentsQuery = { __typename?: 'Query', shipments: { __typename?: 'ShipmentPage', edges: Array<{ __typename?: 'ShipmentEdge', cursor: string, node: { __typename?: 'Shipment', id: string, createdAt: any, reference: string, shipmentReference: string, trackingUrl: string, trackingNumber: string, label: string, invoice: string, status: string, shipmentLines: Array<{ __typename?: 'ShipmentLine', quantity: number, piece: { __typename?: 'Piece', title: string } }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage?: boolean | null } } };

export type UserUpdateMutationVariables = Exact<{
  input: UserUpdateInput;
  id: Scalars['String']['input'];
}>;


export type UserUpdateMutation = { __typename?: 'Mutation', userUpdate: { __typename?: 'User', id: string } };

export type UserQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type UserQuery = { __typename?: 'Query', user: { __typename?: 'User', firstName: string, lastName: string, name?: string | null, email: string, role: UserRole } };

export type UserProfileQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type UserProfileQuery = { __typename?: 'Query', user: { __typename?: 'User', name?: string | null, email: string, activatedAt?: any | null, designerUsers: Array<{ __typename?: 'DesignerUserModel', id: string, shouldNotifyOrders: boolean, shouldNotifyPayouts: boolean, designer: { __typename?: 'Designer', handle: string, name: string } }> } };

export type AddDesignerUserMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  designerHandle: Scalars['String']['input'];
}>;


export type AddDesignerUserMutation = { __typename?: 'Mutation', designerUserAdd: { __typename?: 'DesignerUserModel', id: string } };

export type ActivateUserRequestMutationVariables = Exact<{
  input: ActivateUserRequestInput;
}>;


export type ActivateUserRequestMutation = { __typename?: 'Mutation', activateUserRequest: { __typename?: 'GenericResult', success: boolean } };

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser: { __typename?: 'GenericResult', success: boolean } };

export type UsersQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  query: Scalars['String']['input'];
}>;


export type UsersQuery = { __typename?: 'Query', users: { __typename?: 'UsersPage', edges: Array<{ __typename?: 'UserEdge', cursor: string, node: { __typename?: 'User', id: string, name?: string | null, email: string, activatedAt?: any | null, requestedActivationAt?: any | null, designerUsers: Array<{ __typename?: 'DesignerUserModel', id: string, designer: { __typename?: 'Designer', name: string } }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage?: boolean | null } } };

export const LongForm_PieceFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LongForm_Piece"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Piece"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shopifyUrl"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"siteUrl"}},{"kind":"Field","name":{"kind":"Name","value":"designer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"curatorQuote"}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"tonality"}},{"kind":"Field","name":{"kind":"Name","value":"oneOfAKind"}},{"kind":"Field","name":{"kind":"Name","value":"engraving"}},{"kind":"Field","name":{"kind":"Name","value":"engravingMaxLength"}},{"kind":"Field","name":{"kind":"Name","value":"hasCustomLettering"}},{"kind":"Field","name":{"kind":"Name","value":"customLetteringMaxLength"}},{"kind":"Field","name":{"kind":"Name","value":"isHollow"}},{"kind":"Field","name":{"kind":"Name","value":"designYear"}},{"kind":"Field","name":{"kind":"Name","value":"productionYear"}},{"kind":"Field","name":{"kind":"Name","value":"returnPeriodDays"}},{"kind":"Field","name":{"kind":"Name","value":"anklet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bracelet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"lock"}}]}},{"kind":"Field","name":{"kind":"Name","value":"earring"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"soldAs"}},{"kind":"Field","name":{"kind":"Name","value":"closure"}}]}},{"kind":"Field","name":{"kind":"Name","value":"necklace"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"lock"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ring"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brooch"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cufflink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}}]}},{"kind":"Field","name":{"kind":"Name","value":"leadTime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vintage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isVintage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"margin"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}}]}}]} as unknown as DocumentNode<LongForm_PieceFragment, unknown>;
export const Images_PieceFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Images_Piece"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Piece"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"auto"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"FORMAT"},{"kind":"EnumValue","value":"COMPRESS"}]}},{"kind":"Argument","name":{"kind":"Name","value":"w"},"value":{"kind":"IntValue","value":"300"}},{"kind":"Argument","name":{"kind":"Name","value":"h"},"value":{"kind":"IntValue","value":"400"}}]},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"videos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"designer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<Images_PieceFragment, unknown>;
export const MaterialsAndGemstones_PieceFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MaterialsAndGemstones_Piece"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Piece"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"primaryMaterial"}},{"kind":"Field","name":{"kind":"Name","value":"durability"}},{"kind":"Field","name":{"kind":"Name","value":"baseMaterial"}},{"kind":"Field","name":{"kind":"Name","value":"platingThickness"}},{"kind":"Field","name":{"kind":"Name","value":"karat"}},{"kind":"Field","name":{"kind":"Name","value":"finish"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gemstones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"carat"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"carat"}},{"kind":"Field","name":{"kind":"Name","value":"pearl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"shape"}}]}},{"kind":"Field","name":{"kind":"Name","value":"diamond"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clarity"}},{"kind":"Field","name":{"kind":"Name","value":"colour"}},{"kind":"Field","name":{"kind":"Name","value":"shape"}},{"kind":"Field","name":{"kind":"Name","value":"cut"}},{"kind":"Field","name":{"kind":"Name","value":"class"}}]}}]}}]}}]} as unknown as DocumentNode<MaterialsAndGemstones_PieceFragment, unknown>;
export const PieceSizeDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PieceSizeData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PieceSize"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"option"}},{"kind":"Field","name":{"kind":"Name","value":"requestable"}},{"kind":"Field","name":{"kind":"Name","value":"variable"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]} as unknown as DocumentNode<PieceSizeDataFragment, unknown>;
export const OptionsAndSizes_PieceFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OptionsAndSizes_Piece"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Piece"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"skuSuffix"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"width"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PieceSizeData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"length"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PieceSizeData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"diameter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PieceSizeData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"circumference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PieceSizeData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dropLength"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PieceSizeData"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PieceSizeData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PieceSize"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"option"}},{"kind":"Field","name":{"kind":"Name","value":"requestable"}},{"kind":"Field","name":{"kind":"Name","value":"variable"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]} as unknown as DocumentNode<OptionsAndSizes_PieceFragment, unknown>;
export const Prices_PieceFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Prices_Piece"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Piece"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"prices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"localPrices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"designer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryOfOrigin"}},{"kind":"Field","name":{"kind":"Name","value":"enabledCurrencies"}}]}}]}}]} as unknown as DocumentNode<Prices_PieceFragment, unknown>;
export const Sustainability_PieceFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Sustainability_Piece"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Piece"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sustainabilityLabels"}}]}}]} as unknown as DocumentNode<Sustainability_PieceFragment, unknown>;
export const DesignerB2BUrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DesignerB2BUrl"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"handle"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"designer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"handle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"handle"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"b2bPageUrl"}}]}}]}}]} as unknown as DocumentNode<DesignerB2BUrlQuery, DesignerB2BUrlQueryVariables>;
export const DesignerUpdateFromAdminFormDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DesignerUpdateFromAdminForm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"handle"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DesignerUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"designerUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"handle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"handle"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"b2bPageUrl"}}]}}]}}]} as unknown as DocumentNode<DesignerUpdateFromAdminFormMutation, DesignerUpdateFromAdminFormMutationVariables>;
export const DesignerUpdateFromB2BServicesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DesignerUpdateFromB2BServices"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"handle"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DesignerUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"designerUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"handle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"handle"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"selectedB2BServices"}}]}}]}}]} as unknown as DocumentNode<DesignerUpdateFromB2BServicesMutation, DesignerUpdateFromB2BServicesMutationVariables>;
export const UpdatePieceCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePieceCollection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PieceCollectionUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"handle"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pieceCollectionUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"handle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"handle"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdatePieceCollectionMutation, UpdatePieceCollectionMutationVariables>;
export const CreatePieceCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreatePieceCollection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PieceCollectionCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pieceCollectionCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreatePieceCollectionMutation, CreatePieceCollectionMutationVariables>;
export const PieceCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PieceCollection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"handle"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pieceCollections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"50"}},{"kind":"Argument","name":{"kind":"Name","value":"brandHandle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"handle"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PieceCollectionQuery, PieceCollectionQueryVariables>;
export const DeletePieceCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeletePieceCollection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"handle"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pieceCollectionDelete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"handle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"handle"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeletePieceCollectionMutation, DeletePieceCollectionMutationVariables>;
export const CreateCustomerCreditEntryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCustomerCreditEntry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"source"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerCreditEntrySource"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shopifyOrderId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shopifyDiscountCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shopifyCustomerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currency"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Currency"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"amount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notes"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"expiryDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"settled"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCustomerCreditEntry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"Variable","name":{"kind":"Name","value":"source"}}},{"kind":"Argument","name":{"kind":"Name","value":"shopifyOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shopifyOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"shopifyDiscountCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shopifyDiscountCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"shopifyCustomerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shopifyCustomerId"}}},{"kind":"Argument","name":{"kind":"Name","value":"currency"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currency"}}},{"kind":"Argument","name":{"kind":"Name","value":"amount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"amount"}}},{"kind":"Argument","name":{"kind":"Name","value":"notes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notes"}}},{"kind":"Argument","name":{"kind":"Name","value":"expiryDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"expiryDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"settled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"settled"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateCustomerCreditEntryMutation, CreateCustomerCreditEntryMutationVariables>;
export const DesignerUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"designerUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DesignerUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"handle"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"designerUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"handle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"handle"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"handle"}}]}}]}}]} as unknown as DocumentNode<DesignerUpdateMutation, DesignerUpdateMutationVariables>;
export const DesignerOrdersByDesignerHandleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DesignerOrdersByDesignerHandle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"handle"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"designerOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"12"}},{"kind":"Argument","name":{"kind":"Name","value":"designerHandle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"handle"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"orderName"}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"refundableQuantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"designer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DesignerOrdersByDesignerHandleQuery, DesignerOrdersByDesignerHandleQueryVariables>;
export const UpdateDesignerProfileAttributesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDesignerProfileAttributes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"handle"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DesignerUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"designerUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"handle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"handle"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateDesignerProfileAttributesMutation, UpdateDesignerProfileAttributesMutationVariables>;
export const PiecesByDesignerHandleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PiecesByDesignerHandle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"designerHandle"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pieces"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"300"}},{"kind":"Argument","name":{"kind":"Name","value":"designerHandle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"designerHandle"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PiecesByDesignerHandleQuery, PiecesByDesignerHandleQueryVariables>;
export const CurrencyRatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"currencyRates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currencyRates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}}]}}]} as unknown as DocumentNode<CurrencyRatesQuery, CurrencyRatesQueryVariables>;
export const DesignerOrderAcceptDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"designerOrderAccept"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DesignerOrderAcceptInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"designerOrderAccept"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<DesignerOrderAcceptMutation, DesignerOrderAcceptMutationVariables>;
export const DesignerOrderShippingRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"designerOrderShippingRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DesignerOrderShippingRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"designerOrderShippingRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DesignerOrderShippingRequestMutation, DesignerOrderShippingRequestMutationVariables>;
export const DesignerUserUpdateMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DesignerUserUpdateMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DesignerUserInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"designerUserUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<DesignerUserUpdateMutationMutation, DesignerUserUpdateMutationMutationVariables>;
export const DesignerUserRemoveMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DesignerUserRemoveMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"designerUserRemove"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DesignerUserRemoveMutationMutation, DesignerUserRemoveMutationMutationVariables>;
export const DesignersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Designers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"designers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"300"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DesignersQuery, DesignersQueryVariables>;
export const UploadFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UploadFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"namespace"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"path"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"file"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file"}}},{"kind":"Argument","name":{"kind":"Name","value":"namespace"},"value":{"kind":"Variable","name":{"kind":"Name","value":"namespace"}}},{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"Variable","name":{"kind":"Name","value":"path"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uri"}}]}}]}}]} as unknown as DocumentNode<UploadFileMutation, UploadFileMutationVariables>;
export const AutocompleteCustomersSearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AutocompleteCustomersSearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customersSearch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<AutocompleteCustomersSearchQuery, AutocompleteCustomersSearchQueryVariables>;
export const SearchProductsAutocompleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchProductsAutocomplete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchCombined"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SearchProductsAutocompleteQuery, SearchProductsAutocompleteQueryVariables>;
export const SearchProductVariantsAutocompleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchProductVariantsAutocomplete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productVariants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"productIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}}]}}]}}]} as unknown as DocumentNode<SearchProductVariantsAutocompleteQuery, SearchProductVariantsAutocompleteQueryVariables>;
export const DesignerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Designer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"handle"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"designer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"handle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"handle"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jewellerCategory"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"margin"}},{"kind":"Field","name":{"kind":"Name","value":"shippingRegion"}},{"kind":"Field","name":{"kind":"Name","value":"ein"}},{"kind":"Field","name":{"kind":"Name","value":"eori"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"instagramHandle"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"returnPeriodDays"}},{"kind":"Field","name":{"kind":"Name","value":"awaitingImagesPiecesCount"}},{"kind":"Field","name":{"kind":"Name","value":"awaitingQAPiecesCount"}},{"kind":"Field","name":{"kind":"Name","value":"bankAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"bespoke"}},{"kind":"Field","name":{"kind":"Name","value":"readyToOrder"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedPartner"}},{"kind":"Field","name":{"kind":"Name","value":"customisation"}},{"kind":"Field","name":{"kind":"Name","value":"repair"}},{"kind":"Field","name":{"kind":"Name","value":"servicesTerms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startingBudget"}},{"kind":"Field","name":{"kind":"Name","value":"paymentTerms"}},{"kind":"Field","name":{"kind":"Name","value":"servicesLeadTime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"iterationRounds"}},{"kind":"Field","name":{"kind":"Name","value":"worksWithHeirloomGemstones"}},{"kind":"Field","name":{"kind":"Name","value":"recyclesGoldForReuse"}},{"kind":"Field","name":{"kind":"Name","value":"availableForVirtualConsultations"}},{"kind":"Field","name":{"kind":"Name","value":"availableForInPersonConsultations"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disabledCountries"}},{"kind":"Field","name":{"kind":"Name","value":"enabledCurrencies"}},{"kind":"Field","name":{"kind":"Name","value":"highlights"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"profileImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"curatorQuote"}},{"kind":"Field","name":{"kind":"Name","value":"storeAddress"}},{"kind":"Field","name":{"kind":"Name","value":"storeGoogleMapsUrl"}},{"kind":"Field","name":{"kind":"Name","value":"storeImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"specialties"}},{"kind":"Field","name":{"kind":"Name","value":"workbenchImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"videoHighlightUrl"}},{"kind":"Field","name":{"kind":"Name","value":"videoHighlightDescription"}},{"kind":"Field","name":{"kind":"Name","value":"featuredProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"line3"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"draftPiecesCount"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"livePiecesCount"}},{"kind":"Field","name":{"kind":"Name","value":"microBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"comingSoon"}},{"kind":"Field","name":{"kind":"Name","value":"countryOfOrigin"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"productSpreadsheetId"}},{"kind":"Field","name":{"kind":"Name","value":"remodel"}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"line3"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vatIdNo"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"isRegisteredInShopify"}}]}}]}}]} as unknown as DocumentNode<DesignerQuery, DesignerQueryVariables>;
export const SendMessageToLeadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendMessageToLead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"handle"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LeadMessageInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leadSendMessage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"handle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"handle"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<SendMessageToLeadMutation, SendMessageToLeadMutationVariables>;
export const UpdateDesignerLeadsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDesignerLeads"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"handle"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DesignerUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"designerUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"handle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"handle"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateDesignerLeadsMutation, UpdateDesignerLeadsMutationVariables>;
export const ContactLeadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ContactLead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"handle"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LeadMessageInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leadContact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"handle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"handle"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ContactLeadMutation, ContactLeadMutationVariables>;
export const LeadCreateInternalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LeadCreateInternal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LeadCreateInternalInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leadCreateInternal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<LeadCreateInternalMutation, LeadCreateInternalMutationVariables>;
export const RejectLeadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RejectLead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"handle"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LeadMessageInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leadReject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"handle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"handle"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RejectLeadMutation, RejectLeadMutationVariables>;
export const OnHoldLeadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OnHoldLead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"handle"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LeadMessageInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leadOnHold"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"handle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"handle"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<OnHoldLeadMutation, OnHoldLeadMutationVariables>;
export const DesignerOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DesignerOrders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeClosed"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"designerHandle"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"designerOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"includeClosed"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeClosed"}}},{"kind":"Argument","name":{"kind":"Name","value":"designerHandle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"designerHandle"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"orderName"}},{"kind":"Field","name":{"kind":"Name","value":"expectedFulfillmentAt"}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"refundableQuantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"designer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}}]} as unknown as DocumentNode<DesignerOrdersQuery, DesignerOrdersQueryVariables>;
export const AddArbitraryPayoutLineDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddArbitraryPayoutLine"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PayoutLineInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addArbitraryPayoutLine"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AddArbitraryPayoutLineMutation, AddArbitraryPayoutLineMutationVariables>;
export const ChangePayoutStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChangePayoutStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PayoutStatus"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changePayoutStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<ChangePayoutStatusMutation, ChangePayoutStatusMutationVariables>;
export const GetPayoutsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPayouts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"designerIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"statuses"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PayoutStatus"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"designerCurrencies"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Currency"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateFrom"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateTo"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PayoutOrderByInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payouts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}},{"kind":"Argument","name":{"kind":"Name","value":"designerIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"designerIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"dateFrom"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateFrom"}}},{"kind":"Argument","name":{"kind":"Name","value":"dateTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateTo"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"statuses"},"value":{"kind":"Variable","name":{"kind":"Name","value":"statuses"}}},{"kind":"Argument","name":{"kind":"Name","value":"designerCurrencies"},"value":{"kind":"Variable","name":{"kind":"Name","value":"designerCurrencies"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentPeriod"}},{"kind":"Field","name":{"kind":"Name","value":"designerId"}},{"kind":"Field","name":{"kind":"Name","value":"designerCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmountByExchangeRate"}},{"kind":"Field","name":{"kind":"Name","value":"pdfUrl"}},{"kind":"Field","name":{"kind":"Name","value":"designer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payoutLines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPayoutsQuery, GetPayoutsQueryVariables>;
export const GetDesignerPayoutsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDesignerPayouts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"designerIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"statuses"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PayoutStatus"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"designerCurrencies"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Currency"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateFrom"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateTo"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PayoutOrderByInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payouts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}},{"kind":"Argument","name":{"kind":"Name","value":"designerIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"designerIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"dateFrom"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateFrom"}}},{"kind":"Argument","name":{"kind":"Name","value":"dateTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateTo"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"statuses"},"value":{"kind":"Variable","name":{"kind":"Name","value":"statuses"}}},{"kind":"Argument","name":{"kind":"Name","value":"designerCurrencies"},"value":{"kind":"Variable","name":{"kind":"Name","value":"designerCurrencies"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentPeriod"}},{"kind":"Field","name":{"kind":"Name","value":"designerCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmountByExchangeRate"}},{"kind":"Field","name":{"kind":"Name","value":"payoutLines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetDesignerPayoutsQuery, GetDesignerPayoutsQueryVariables>;
export const GetPhotoshootsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPhotoshoots"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"statuses"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PhotoshootStatus"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PhotoshootOrderByInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photoshoots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"statuses"},"value":{"kind":"Variable","name":{"kind":"Name","value":"statuses"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPhotoshootsQuery, GetPhotoshootsQueryVariables>;
export const ChangePhotoshootStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChangePhotoshootStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PhotoshootStatus"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changePhotoshootStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<ChangePhotoshootStatusMutation, ChangePhotoshootStatusMutationVariables>;
export const DeletePhotoshootDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deletePhotoshoot"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletePhotoshoot"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeletePhotoshootMutation, DeletePhotoshootMutationVariables>;
export const CreatePhotoshootShipmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createPhotoshootShipments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreatePhotoshootShipmentsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPhotoshootShipments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreatePhotoshootShipmentsMutation, CreatePhotoshootShipmentsMutationVariables>;
export const CreatePhotoshootReturnsShipmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreatePhotoshootReturnsShipments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreatePhotoshootShipmentsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPhotoshootShipments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreatePhotoshootReturnsShipmentsMutation, CreatePhotoshootReturnsShipmentsMutationVariables>;
export const CreatePhotoshootDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createPhotoshoot"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreatePhotoshootInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPhotoshoot"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreatePhotoshootMutation, CreatePhotoshootMutationVariables>;
export const CreatePhotoshootLinesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createPhotoshootLines"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreatePhotoshootLinesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPhotoshootLines"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreatePhotoshootLinesMutation, CreatePhotoshootLinesMutationVariables>;
export const GetPiecesPhotoshootsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPiecesPhotoshoots"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"statuses"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PhotoshootStatus"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photoshoots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"statuses"},"value":{"kind":"Variable","name":{"kind":"Name","value":"statuses"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPiecesPhotoshootsQuery, GetPiecesPhotoshootsQueryVariables>;
export const PiecesSummaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"piecesSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"designerHandle"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"piecesSummary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"designerHandle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"designerHandle"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<PiecesSummaryQuery, PiecesSummaryQueryVariables>;
export const BulkUpdateLeadTimeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BulkUpdateLeadTime"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"leadTime"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LeadTimeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkUpdateLeadTime"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}},{"kind":"Argument","name":{"kind":"Name","value":"leadTime"},"value":{"kind":"Variable","name":{"kind":"Name","value":"leadTime"}}}]}]}}]} as unknown as DocumentNode<BulkUpdateLeadTimeMutation, BulkUpdateLeadTimeMutationVariables>;
export const ExportPiecesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ExportPieces"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"piecesExportPieces"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<ExportPiecesMutation, ExportPiecesMutationVariables>;
export const PieceCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PieceCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PieceCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pieceCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<PieceCreateMutation, PieceCreateMutationVariables>;
export const PieceBrandsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PieceBrands"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"designerHandle"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brands"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"500"}},{"kind":"Argument","name":{"kind":"Name","value":"designerHandle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"designerHandle"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PieceBrandsQuery, PieceBrandsQueryVariables>;
export const PieceDesignerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PieceDesigner"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"handle"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"designer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"handle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"handle"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryOfOrigin"}},{"kind":"Field","name":{"kind":"Name","value":"enabledCurrencies"}}]}}]}}]} as unknown as DocumentNode<PieceDesignerQuery, PieceDesignerQueryVariables>;
export const PieceCollectionsByBrandDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PieceCollectionsByBrand"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandHandle"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pieceCollections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"200"}},{"kind":"Argument","name":{"kind":"Name","value":"brandHandle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandHandle"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PieceCollectionsByBrandQuery, PieceCollectionsByBrandQueryVariables>;
export const PieceImageDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PieceImageDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pieceImageDelete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<PieceImageDeleteMutation, PieceImageDeleteMutationVariables>;
export const UploadProductImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uploadProductImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pieceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gender"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"usePhotoroom"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadProductImage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"file"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file"}}},{"kind":"Argument","name":{"kind":"Name","value":"pieceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pieceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"Argument","name":{"kind":"Name","value":"gender"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gender"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"usePhotoroom"},"value":{"kind":"Variable","name":{"kind":"Name","value":"usePhotoroom"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<UploadProductImageMutation, UploadProductImageMutationVariables>;
export const FetchVariantsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchVariants"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pieceVariants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pieceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"skuOverride"}},{"kind":"Field","name":{"kind":"Name","value":"skuDefault"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"prices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}}]} as unknown as DocumentNode<FetchVariantsQuery, FetchVariantsQueryVariables>;
export const UpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"update"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PieceVariantInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pieceVariantUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"skuOverride"}},{"kind":"Field","name":{"kind":"Name","value":"skuDefault"}},{"kind":"Field","name":{"kind":"Name","value":"prices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateMutation, UpdateMutationVariables>;
export const PieceDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PieceDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pieceDelete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<PieceDeleteMutation, PieceDeleteMutationVariables>;
export const PiecesHideDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PiecesHide"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hidePieces"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}]}}]} as unknown as DocumentNode<PiecesHideMutation, PiecesHideMutationVariables>;
export const PiecesUnhideDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PiecesUnhide"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unhidePieces"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}]}}]} as unknown as DocumentNode<PiecesUnhideMutation, PiecesUnhideMutationVariables>;
export const PiecesTableListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PiecesTableList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"designerHandle"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hidden"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pieces"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"designerHandle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"designerHandle"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"hidden"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hidden"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"shopifyId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"leadTime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"prices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"photoshoot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<PiecesTableListQuery, PiecesTableListQueryVariables>;
export const DesignerExportPiecesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DesignerExportPieces"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"designerHandle"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"piecesExportDesigner"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"designerHandle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"designerHandle"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<DesignerExportPiecesMutation, DesignerExportPiecesMutationVariables>;
export const QaListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QAList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"piecesToQA"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"designer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<QaListQuery, QaListQueryVariables>;
export const PieceUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PieceUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PieceUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pieceUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<PieceUpdateMutation, PieceUpdateMutationVariables>;
export const CreateCustomerReferralCampaignEntryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCustomerReferralCampaignEntry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"amount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currency"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Currency"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaign"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maximumUses"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"expiryPeriod"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCustomerReferralCampaignEntry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"amount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"amount"}}},{"kind":"Argument","name":{"kind":"Name","value":"currency"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currency"}}},{"kind":"Argument","name":{"kind":"Name","value":"campaign"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaign"}}},{"kind":"Argument","name":{"kind":"Name","value":"maximumUses"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maximumUses"}}},{"kind":"Argument","name":{"kind":"Name","value":"expiryPeriod"},"value":{"kind":"Variable","name":{"kind":"Name","value":"expiryPeriod"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateCustomerReferralCampaignEntryMutation, CreateCustomerReferralCampaignEntryMutationVariables>;
export const UpdateStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ServiceOrderStatus"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateServiceOrderStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<UpdateStatusMutation, UpdateStatusMutationVariables>;
export const CreateServiceOrderShipmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createServiceOrderShipment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ServiceOrderCreateShipmentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createServiceOrderShipment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<CreateServiceOrderShipmentMutation, CreateServiceOrderShipmentMutationVariables>;
export const UpdateNotesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateNotes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notes"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateServiceOrderItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notes"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateNotesMutation, UpdateNotesMutationVariables>;
export const CurrentUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CurrentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userCurrent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"designerUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shouldNotifyOrders"}},{"kind":"Field","name":{"kind":"Name","value":"shouldNotifyPayouts"}},{"kind":"Field","name":{"kind":"Name","value":"designer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CurrentUserQuery, CurrentUserQueryVariables>;
export const LoginPasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LoginPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LoginPasswordInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loginPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"designerUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"notify"}},{"kind":"Field","name":{"kind":"Name","value":"designer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<LoginPasswordMutation, LoginPasswordMutationVariables>;
export const LoginGoogleStartQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LoginGoogleStartQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loginGoogleStart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}}]} as unknown as DocumentNode<LoginGoogleStartQueryQuery, LoginGoogleStartQueryQueryVariables>;
export const SetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"set"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActivateUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"designerUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"notify"}},{"kind":"Field","name":{"kind":"Name","value":"designer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SetMutation, SetMutationVariables>;
export const CustomerCreditTotalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"customerCreditTotals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerCreditTotals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]} as unknown as DocumentNode<CustomerCreditTotalsQuery, CustomerCreditTotalsQueryVariables>;
export const LoginGoogleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"loginGoogle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loginGoogle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}}]}}]} as unknown as DocumentNode<LoginGoogleMutation, LoginGoogleMutationVariables>;
export const AssociateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"associate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerAssociateProduct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"customerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}},{"kind":"Argument","name":{"kind":"Name","value":"productId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productId"}}},{"kind":"Argument","name":{"kind":"Name","value":"variantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variantId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"piece"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"designer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"variant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<AssociateMutation, AssociateMutationVariables>;
export const GetCustomerSummaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCustomerSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerGetOwnerSummary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productVariantId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"altText"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"designerName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"customerCreditEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"shopifyCustomerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"shopifyOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"shopifyCustomerId"}},{"kind":"Field","name":{"kind":"Name","value":"shopifyDiscountCode"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customerCredit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"shopifyCustomerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customerReferralEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"shopifyCustomerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"referringUserEmail"}},{"kind":"Field","name":{"kind":"Name","value":"toUserEmail"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"favourites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<GetCustomerSummaryQuery, GetCustomerSummaryQueryVariables>;
export const DesignerOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DesignerOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"designerOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"entityId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"orderName"}},{"kind":"Field","name":{"kind":"Name","value":"giftWrapping"}},{"kind":"Field","name":{"kind":"Name","value":"expectedFulfillmentAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"shippingTo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"company"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"line3"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"countryName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"refundableQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"engraving"}},{"kind":"Field","name":{"kind":"Name","value":"engravingMaxLength"}},{"kind":"Field","name":{"kind":"Name","value":"customLettering"}},{"kind":"Field","name":{"kind":"Name","value":"deliveredBy"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pdfSales"}},{"kind":"Field","name":{"kind":"Name","value":"pdfCommercial"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trackingNumber"}},{"kind":"Field","name":{"kind":"Name","value":"trackingUrl"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"courier"}},{"kind":"Field","name":{"kind":"Name","value":"courierTrackingNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"designer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<DesignerOrderQuery, DesignerOrderQueryVariables>;
export const SaveBankDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveBankDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bankAccountName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bankAddress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clearingNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cvr"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"designerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"iban"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"routingNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"swiftCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveBankDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"bankAccountName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bankAccountName"}}},{"kind":"Argument","name":{"kind":"Name","value":"bankAddress"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bankAddress"}}},{"kind":"Argument","name":{"kind":"Name","value":"clearingNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clearingNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"cvr"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cvr"}}},{"kind":"Argument","name":{"kind":"Name","value":"designerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"designerId"}}},{"kind":"Argument","name":{"kind":"Name","value":"iban"},"value":{"kind":"Variable","name":{"kind":"Name","value":"iban"}}},{"kind":"Argument","name":{"kind":"Name","value":"routingNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"routingNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"swiftCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"swiftCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<SaveBankDetailsMutation, SaveBankDetailsMutationVariables>;
export const DesignerRegistrationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DesignerRegistration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"handle"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"designerRegisterShopify"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"handle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"handle"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DesignerRegistrationMutation, DesignerRegistrationMutationVariables>;
export const DesignerDeletionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DesignerDeletion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"handle"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"designerDelete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"handle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"handle"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DesignerDeletionMutation, DesignerDeletionMutationVariables>;
export const DesignerRestoreDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DesignerRestore"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"handle"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"designerRestore"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"handle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"handle"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"handle"}}]}}]}}]} as unknown as DocumentNode<DesignerRestoreMutation, DesignerRestoreMutationVariables>;
export const GetB2bServicesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getB2bServices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getB2bServices"}}]}}]} as unknown as DocumentNode<GetB2bServicesQuery, GetB2bServicesQueryVariables>;
export const Designerb2bDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"designerb2bData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"handle"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"designer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"handle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"handle"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"selectedB2BServices"}}]}}]}}]} as unknown as DocumentNode<Designerb2bDataQuery, Designerb2bDataQueryVariables>;
export const CreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"create"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DesignerCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"designerCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"handle"}}]}}]}}]} as unknown as DocumentNode<CreateMutation, CreateMutationVariables>;
export const DesignersListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DesignersList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"designers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"draftPiecesCount"}},{"kind":"Field","name":{"kind":"Name","value":"awaitingImagesPiecesCount"}},{"kind":"Field","name":{"kind":"Name","value":"awaitingQAPiecesCount"}},{"kind":"Field","name":{"kind":"Name","value":"livePiecesCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}}]} as unknown as DocumentNode<DesignersListQuery, DesignersListQueryVariables>;
export const DesignerOnboardingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DesignerOnboarding"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"designerHandle"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pieces"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"designerHandle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"designerHandle"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"getDates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"handle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"designerHandle"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pieceCollections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"brandHandle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"designerHandle"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DesignerOnboardingQuery, DesignerOnboardingQueryVariables>;
export const LeadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Lead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"handle"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lead"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"handle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"handle"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"leadStatus"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"instagramHandle"}},{"kind":"Field","name":{"kind":"Name","value":"leadSource"}},{"kind":"Field","name":{"kind":"Name","value":"countryOfOrigin"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"jewelleryMakingLocation"}},{"kind":"Field","name":{"kind":"Name","value":"materials"}},{"kind":"Field","name":{"kind":"Name","value":"leadTime"}},{"kind":"Field","name":{"kind":"Name","value":"priceRange"}},{"kind":"Field","name":{"kind":"Name","value":"otherPartners"}},{"kind":"Field","name":{"kind":"Name","value":"otherPartnersText"}},{"kind":"Field","name":{"kind":"Name","value":"taxRegistered"}},{"kind":"Field","name":{"kind":"Name","value":"statusHistory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"leadStatus"}}]}}]}}]}}]} as unknown as DocumentNode<LeadQuery, LeadQueryVariables>;
export const LeadsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Leads"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"statuses"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LeadStatus"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LeadOrderByInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"statuses"},"value":{"kind":"Variable","name":{"kind":"Name","value":"statuses"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"leadStatus"}},{"kind":"Field","name":{"kind":"Name","value":"countryOfOrigin"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}}]} as unknown as DocumentNode<LeadsQuery, LeadsQueryVariables>;
export const LeadRemoveDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LeadRemove"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leadRemove"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<LeadRemoveMutation, LeadRemoveMutationVariables>;
export const ChangePayoutLineStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChangePayoutLineStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isExcluded"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"excludedReason"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PayoutLineExcludedReason"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changePayoutLineStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"isExcluded"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isExcluded"}}},{"kind":"Argument","name":{"kind":"Name","value":"excludedReason"},"value":{"kind":"Variable","name":{"kind":"Name","value":"excludedReason"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ChangePayoutLineStatusMutation, ChangePayoutLineStatusMutationVariables>;
export const GetPayoutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPayout"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"convertToDesignerCurrency"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payout"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"convertToDesignerCurrency"},"value":{"kind":"Variable","name":{"kind":"Name","value":"convertToDesignerCurrency"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentPeriod"}},{"kind":"Field","name":{"kind":"Name","value":"designerId"}},{"kind":"Field","name":{"kind":"Name","value":"designer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"designerCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"pdfUrl"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmountByExchangeRate"}},{"kind":"Field","name":{"kind":"Name","value":"totalFinematterCommission"}},{"kind":"Field","name":{"kind":"Name","value":"totalGrossTransactionalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"totalGrossEarningsExcludingTaxes"}},{"kind":"Field","name":{"kind":"Name","value":"totalTaxCollected"}},{"kind":"Field","name":{"kind":"Name","value":"totalVATCollected"}},{"kind":"Field","name":{"kind":"Name","value":"totalFinematterVAT"}},{"kind":"Field","name":{"kind":"Name","value":"vatRate"}},{"kind":"Field","name":{"kind":"Name","value":"payoutLines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"commissionTotal"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"importTotal"}},{"kind":"Field","name":{"kind":"Name","value":"pieceId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"grossTransactionalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"shipmentType"}},{"kind":"Field","name":{"kind":"Name","value":"vatTotal"}},{"kind":"Field","name":{"kind":"Name","value":"isExcluded"}},{"kind":"Field","name":{"kind":"Name","value":"orderReference"}},{"kind":"Field","name":{"kind":"Name","value":"shopifyOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"netTotalExcludingCommission"}},{"kind":"Field","name":{"kind":"Name","value":"refundOf"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"commissionTotal"}},{"kind":"Field","name":{"kind":"Name","value":"importTotal"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"grossTransactionalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"netTotalExcludingCommission"}},{"kind":"Field","name":{"kind":"Name","value":"vatTotal"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPayoutQuery, GetPayoutQueryVariables>;
export const GetPhotoshootDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPhotoshoot"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photoshoot"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"photoshootLines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"piece"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"designer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<GetPhotoshootQuery, GetPhotoshootQueryVariables>;
export const ChangePhotoshootLineStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChangePhotoshootLineStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PhotoshootLineStatus"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changePhotoshootLineStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ChangePhotoshootLineStatusMutation, ChangePhotoshootLineStatusMutationVariables>;
export const DeletePhotoshootLineDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deletePhotoshootLine"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletePhotoshootLine"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeletePhotoshootLineMutation, DeletePhotoshootLineMutationVariables>;
export const GetPhotoshootShipmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPhotoshootShipments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photoshoot"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"photoshootLines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"piece"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"designer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"inboundShipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"shipmentReference"}},{"kind":"Field","name":{"kind":"Name","value":"trackingUrl"}},{"kind":"Field","name":{"kind":"Name","value":"trackingNumber"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"invoice"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"outboundShipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"shipmentReference"}},{"kind":"Field","name":{"kind":"Name","value":"trackingUrl"}},{"kind":"Field","name":{"kind":"Name","value":"trackingNumber"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"invoice"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<GetPhotoshootShipmentsQuery, GetPhotoshootShipmentsQueryVariables>;
export const PiecesExportPieceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"piecesExportPiece"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"piecesExportPiece"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<PiecesExportPieceMutation, PiecesExportPieceMutationVariables>;
export const PieceQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PieceQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"piece"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LongForm_Piece"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Images_Piece"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Prices_Piece"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Sustainability_Piece"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MaterialsAndGemstones_Piece"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OptionsAndSizes_Piece"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PieceSizeData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PieceSize"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"option"}},{"kind":"Field","name":{"kind":"Name","value":"requestable"}},{"kind":"Field","name":{"kind":"Name","value":"variable"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LongForm_Piece"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Piece"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shopifyUrl"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"siteUrl"}},{"kind":"Field","name":{"kind":"Name","value":"designer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"curatorQuote"}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"tonality"}},{"kind":"Field","name":{"kind":"Name","value":"oneOfAKind"}},{"kind":"Field","name":{"kind":"Name","value":"engraving"}},{"kind":"Field","name":{"kind":"Name","value":"engravingMaxLength"}},{"kind":"Field","name":{"kind":"Name","value":"hasCustomLettering"}},{"kind":"Field","name":{"kind":"Name","value":"customLetteringMaxLength"}},{"kind":"Field","name":{"kind":"Name","value":"isHollow"}},{"kind":"Field","name":{"kind":"Name","value":"designYear"}},{"kind":"Field","name":{"kind":"Name","value":"productionYear"}},{"kind":"Field","name":{"kind":"Name","value":"returnPeriodDays"}},{"kind":"Field","name":{"kind":"Name","value":"anklet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bracelet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"lock"}}]}},{"kind":"Field","name":{"kind":"Name","value":"earring"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"soldAs"}},{"kind":"Field","name":{"kind":"Name","value":"closure"}}]}},{"kind":"Field","name":{"kind":"Name","value":"necklace"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"lock"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ring"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brooch"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cufflink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}}]}},{"kind":"Field","name":{"kind":"Name","value":"leadTime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vintage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isVintage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"margin"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Images_Piece"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Piece"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"auto"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"FORMAT"},{"kind":"EnumValue","value":"COMPRESS"}]}},{"kind":"Argument","name":{"kind":"Name","value":"w"},"value":{"kind":"IntValue","value":"300"}},{"kind":"Argument","name":{"kind":"Name","value":"h"},"value":{"kind":"IntValue","value":"400"}}]},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"videos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"designer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Prices_Piece"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Piece"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"prices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"localPrices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"designer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryOfOrigin"}},{"kind":"Field","name":{"kind":"Name","value":"enabledCurrencies"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Sustainability_Piece"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Piece"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sustainabilityLabels"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MaterialsAndGemstones_Piece"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Piece"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"primaryMaterial"}},{"kind":"Field","name":{"kind":"Name","value":"durability"}},{"kind":"Field","name":{"kind":"Name","value":"baseMaterial"}},{"kind":"Field","name":{"kind":"Name","value":"platingThickness"}},{"kind":"Field","name":{"kind":"Name","value":"karat"}},{"kind":"Field","name":{"kind":"Name","value":"finish"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gemstones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"carat"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"carat"}},{"kind":"Field","name":{"kind":"Name","value":"pearl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"shape"}}]}},{"kind":"Field","name":{"kind":"Name","value":"diamond"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clarity"}},{"kind":"Field","name":{"kind":"Name","value":"colour"}},{"kind":"Field","name":{"kind":"Name","value":"shape"}},{"kind":"Field","name":{"kind":"Name","value":"cut"}},{"kind":"Field","name":{"kind":"Name","value":"class"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OptionsAndSizes_Piece"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Piece"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"skuSuffix"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"width"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PieceSizeData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"length"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PieceSizeData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"diameter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PieceSizeData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"circumference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PieceSizeData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dropLength"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PieceSizeData"}}]}}]}}]} as unknown as DocumentNode<PieceQueryQuery, PieceQueryQueryVariables>;
export const MaterialPricesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MaterialPrices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"materialPrices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"materialType"}},{"kind":"Field","name":{"kind":"Name","value":"currencyAmounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}}]} as unknown as DocumentNode<MaterialPricesQuery, MaterialPricesQueryVariables>;
export const MaterialPriceUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MaterialPriceUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"materialType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MaterialType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currencyAmounts"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CurrencyAmountInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"materialPriceUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"materialType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"materialType"}}},{"kind":"Argument","name":{"kind":"Name","value":"currencyAmounts"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currencyAmounts"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"materialType"}}]}}]}}]} as unknown as DocumentNode<MaterialPriceUpdateMutation, MaterialPriceUpdateMutationVariables>;
export const PiecesExportPricesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"piecesExportPrices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"piecesExportPrices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<PiecesExportPricesMutation, PiecesExportPricesMutationVariables>;
export const PublicDesignerByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PublicDesignerById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicDesignerById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"leadStatus"}}]}}]}}]} as unknown as DocumentNode<PublicDesignerByIdQuery, PublicDesignerByIdQueryVariables>;
export const PublicRegisterDesignerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PublicRegisterDesigner"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PublicRegisterDesignerArgs"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicRegisterDesigner"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<PublicRegisterDesignerMutation, PublicRegisterDesignerMutationVariables>;
export const ServiceOrdersQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ServiceOrdersQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"services"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ServiceOrderType"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeUnpaid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"statuses"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ServiceOrderStatus"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countries"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Country"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeReturned"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeCancelled"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ServiceOrderOrderByInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"serviceOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"services"},"value":{"kind":"Variable","name":{"kind":"Name","value":"services"}}},{"kind":"Argument","name":{"kind":"Name","value":"includeUnpaid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeUnpaid"}}},{"kind":"Argument","name":{"kind":"Name","value":"statuses"},"value":{"kind":"Variable","name":{"kind":"Name","value":"statuses"}}},{"kind":"Argument","name":{"kind":"Name","value":"countries"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countries"}}},{"kind":"Argument","name":{"kind":"Name","value":"includeReturned"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeReturned"}}},{"kind":"Argument","name":{"kind":"Name","value":"includeCancelled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeCancelled"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderNumber"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"service"}},{"kind":"Field","name":{"kind":"Name","value":"exchangeWeight"}},{"kind":"Field","name":{"kind":"Name","value":"exchangeMetal"}},{"kind":"Field","name":{"kind":"Name","value":"exchangeDesigner"}},{"kind":"Field","name":{"kind":"Name","value":"recycleWeight"}},{"kind":"Field","name":{"kind":"Name","value":"recycleMetal"}},{"kind":"Field","name":{"kind":"Name","value":"replateMetal"}},{"kind":"Field","name":{"kind":"Name","value":"replateKarat"}},{"kind":"Field","name":{"kind":"Name","value":"replatePlatingThickness"}},{"kind":"Field","name":{"kind":"Name","value":"replateNumberOfPieces"}},{"kind":"Field","name":{"kind":"Name","value":"repairMetal"}},{"kind":"Field","name":{"kind":"Name","value":"orderPage"}},{"kind":"Field","name":{"kind":"Name","value":"repairType"}},{"kind":"Field","name":{"kind":"Name","value":"repairJewelleryType"}},{"kind":"Field","name":{"kind":"Name","value":"refreshType"}},{"kind":"Field","name":{"kind":"Name","value":"resizeMetal"}},{"kind":"Field","name":{"kind":"Name","value":"resizeType"}},{"kind":"Field","name":{"kind":"Name","value":"resizeNewSize"}},{"kind":"Field","name":{"kind":"Name","value":"resizeOtherMetal"}},{"kind":"Field","name":{"kind":"Name","value":"orderReference"}},{"kind":"Field","name":{"kind":"Name","value":"statusUpdatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"serviceOrderHistory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serviceOrderAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inboundShipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"outboundShipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"notes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<ServiceOrdersQueryQuery, ServiceOrdersQueryQueryVariables>;
export const ShipmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"shipments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shipments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"shipmentReference"}},{"kind":"Field","name":{"kind":"Name","value":"trackingUrl"}},{"kind":"Field","name":{"kind":"Name","value":"trackingNumber"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"invoice"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"shipmentLines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"piece"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}}]} as unknown as DocumentNode<ShipmentsQuery, ShipmentsQueryVariables>;
export const UserUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"userUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UserUpdateMutation, UserUpdateMutationVariables>;
export const UserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"user"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}}]} as unknown as DocumentNode<UserQuery, UserQueryVariables>;
export const UserProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"activatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"designerUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shouldNotifyOrders"}},{"kind":"Field","name":{"kind":"Name","value":"shouldNotifyPayouts"}},{"kind":"Field","name":{"kind":"Name","value":"designer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserProfileQuery, UserProfileQueryVariables>;
export const AddDesignerUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddDesignerUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"designerHandle"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"designerUserAdd"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"designerHandle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"designerHandle"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AddDesignerUserMutation, AddDesignerUserMutationVariables>;
export const ActivateUserRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ActivateUserRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActivateUserRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activateUserRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<ActivateUserRequestMutation, ActivateUserRequestMutationVariables>;
export const DeleteUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<DeleteUserMutation, DeleteUserMutationVariables>;
export const UsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"users"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"activatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"requestedActivationAt"}},{"kind":"Field","name":{"kind":"Name","value":"designerUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"designer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}}]} as unknown as DocumentNode<UsersQuery, UsersQueryVariables>;
